webpackJsonp([1],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/card-back.e6717cb.png";

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKwSURBVHgBpVXBdeIwEJUEB3LLVrCmgiUVxFQQUgHkkLzkFKggpgK8Jycvh3U6IBXgrWDZCqLtgD1B3gv2/pFGQoADh9V7smx59Gf+n5EkxYFW3d5GoqomQsrTmt9X8vFRH1rfFIdbDOBe7R8p7/Ecif8A7/NYcAedqmMcluXgGLh0L0YCIR6weI7Fv3l6xoA9+fT0Gti9mfmyHOFfIZQ6xxpy+iqzbFoHTguimgA0tG2HE7Alp/GeZVUtxMlJW6bpgj4VGw88sJTzwLxA7+6BtFqXeOZboNQp8avVxEfONGcMniPKq2o4NNXhIvishXbV3d3QVJZtXeAUBJ7igzKveVJvAVxfd0SjMeFEnho2UubQ9mXP2UauAjhdkuWC5ViA7lakiKaHZNkFm1qP4Sivbm6Ge1Q2ksbEisDHrFsn1Ivn3AbSGAfosXAlqdSEJXVRJ7B3DhOSSiH8nD54cmBksMYEFHkNIQP6T5NMSp51fhGE0ufoU2CagE21uA+O6Cu/OWAd5sEkWamCgVwgkbf/+PC5UJ6Sa2X5x4E6JyF9jrjDo9WYcuXYKNX3gXCN//CUssxsaVNmy+VboHmC8S9AqLJiXt92rHZKcYz5RGLyF0eiEcFZWNus+0zUt2RLTutg4pO6Xp8pfEyZ4t6xShuBojM2jrat83gXmDHcCarl8/O8iWi/g/7Q0F8uH/BjFO48pn0pPmlka3bo9hGSmIHphHppsamUQtRcCsb5akV13fc5Ieb23RwhZGdLMcvSYHdFAU6MPnNMfLOb7T7YtVHw7uVqBnoRdXueKzU3xut1jjES7++0WUz9clkOmH5q6rrRoHPnG8pY49zXDlKKA80fRMRqk3h7EyHBAPpyaP2xa+5F2IOKSrXD0XJYcnpk7RHwVmsKfc/F7g1lL4axONL+ASkMWhzJDwrvAAAAAElFTkSuQmCC"

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL9SURBVHgBrVZdVtpAFL53MmJ7jueUrqDpCoRHK1BYQd2BdAXSxz4ggg8+iiso7sCuAMS/R3AFzQ7Kg6dqMpPpnSQTElogevI9aObnzjf3h+8OQkZ0JpMif3goKaVsM4eIjtjamnbL5VmWM3A9weM+fe4BqPrynWoEaA3alZ1zeA1Zb3zTRIRT+ixCRihAh7w9Wkb6X7Lj8fWAYrQ/P0XNFLABKn8qfLzfKLz9LeWTTQtFFngNdTrJjrej6h9WKt/Wkh1f307o8FJMgtiXwj3rNhor89K7uusg+C2YR2Laru6Wl5IdX9306d9ByAOOlG6DSBzIiJPh0BZWYRh7iUB53P36D1mUox+vJVpOyJomhzj36vYX0dg6dEJ65STRyd2dLYQa0vpMiOASs8hmqABsybHR3dlxUoS8MIEwpNrmo7ZhxquASHtFOVr0yPO8erROuSzYIdGVnqsjzXMpPyf3fyd7Kqh+NCxyvhkUW0CGUeXp8B1Wd7uwAszCd5ABUjydaa/Ckb8X2HaGw2LiBzuCnKDDphQOwhHWNQ/jnJfMBmXBBeQKcW++NA9Lah1IzKRxWWFZ1jQeIH5g6cU3DuQI12Wpy6fIPPfxPeQIzoWdItNtIl7cUNuQJ5SKRdz3mcOEEHFclc9KkCeY9SUmk8/3LFQDHOkJRNUMfwo5QWE9+hjFCkIwJV+0eOEgyzmMsZWVS6J+ZFRJC3Jgo/8I8ayFchbOQ6tDWpg03JByRJ3R0Tfs1D5d6jnXdWkMOgVT4XmXyf0noX3cPdqVSlqIe+Mxqb4Vqj513EVxzYqEaNuhV6ppyOLSP6zVBnSN6AbKtshg0cOXEpFc9Q1ReO4CKNa6NZiqpND6Z+1q9WgFR/Qw+qO7tA5dtk5t0BvfnlJltsxYh5XCMUJf/qSSnQnOnYLvF6WUJWB8G5VqQvJhpKhD1+YdeiVZSEg5BKuTfMisBTVeSkwrGbpMZClS5Ptr342gLkggzlc9jNaSGQT9yNrcZsq3zZyPzNHKsO7lZfAXrIuDlbvh/ocAAAAASUVORK5CYII="

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return doLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getsendMail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getUn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLogDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addGameRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCharacter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return chooseMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return otherLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return canceld; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return doReg; });
/* unused harmony export editUserName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return editUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getUserInfoByEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserInfoById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return changPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return createRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRoomDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getRoomDetailByUid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getInvitationRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return insertInvitationLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getGamesRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return startGame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return gamesOperate; });
/* unused harmony export noticeUserOperate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return plan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updatePlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return createPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return createCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return createSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return checkSubscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return sendCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return sendVCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return confirmCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return changepwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return showUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return delRoom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request_js__ = __webpack_require__(440);


var doLogin = function doLogin(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/sys/login',
        method: 'post',
        data: data
    });
};

var getsendMail = function getsendMail(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/email/sendMail',
        method: 'post',
        data: data
    });
};

var getUn = function getUn(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getInviteLog/' + id,
        method: 'get'
    });
};

var getLogDetail = function getLogDetail(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getGamesRecordDetail?roomId=' + id,
        method: 'get'
    });
};

var addGameRecord = function addGameRecord(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/addGamesRecord',
        method: 'post',
        data: data
    });
};

var getCharacter = function getCharacter(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/result/getCharacter?cardNumber=' + id,
        method: 'get'
    });
};

var chooseMember = function chooseMember(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/createRoomPersonCount',
        method: 'post',
        data: data
    });
};

var otherLogin = function otherLogin(token) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/oauth/getLoginUser/' + token,
        method: 'get'
    });
};

var canceld = function canceld(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/cancelSubscription',
        method: 'post',
        data: data
    });
};

var getSame = function getSame(roomid) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/synchronousData/' + roomid,
        method: 'get'
    });
};

var doReg = function doReg(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/sys/user/register',
        method: 'post',
        data: data
    });
};

var editUserName = function editUserName(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/updateUserName',
        method: 'post',
        data: data
    });
};

var editUserInfo = function editUserInfo(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/updateUserInfo',
        method: 'post',
        data: data
    });
};

var getUserInfo = function getUserInfo(token) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/sys/user/getUserSectionInfoByToken',
        method: 'get',
        data: { token: token }
    });
};

var getUserInfoByEmail = function getUserInfoByEmail(email) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getUserInfoByEmail/' + email,
        method: 'get'
    });
};

var getUserInfoById = function getUserInfoById(userId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getUserInfoById/' + userId,
        method: 'get'
    });
};

var changPassword = function changPassword(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/sys/user/changPassword',
        method: 'put',
        data: data
    });
};

var createRoom = function createRoom(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/createRoom',
        method: 'post',
        data: data
    });
};

var getRoomDetail = function getRoomDetail(roomId) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getRoomDetail/' + roomId,
        method: 'get'
    });
};

var getRoomDetailByUid = function getRoomDetailByUid(homeowner, code) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getRoomDetailByUrlAndHomeowner/' + code + '/' + homeowner,
        method: 'get'
    });
};

var getInvitationRecord = function getInvitationRecord(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getInvitationRecord',
        method: 'post',
        data: data
    });
};

var insertInvitationLog = function insertInvitationLog(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/insertInvitationLog',
        method: 'post',
        data: data
    });
};

var getGamesRecord = function getGamesRecord(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/getGamesRecord',
        method: 'post',
        data: data
    });
};

var startGame = function startGame(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/insertRoomUser',
        method: 'post',
        data: data
    });
};

var gamesOperate = function gamesOperate(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/gamesOperate',
        method: 'post',
        data: data
    });
};

var noticeUserOperate = function noticeUserOperate(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/noticeUserOperate',
        method: 'post',
        data: data
    });
};

var plan = function plan(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/productList',
        method: 'post',
        data: data
    });
};

var updatePlan = function updatePlan(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/updatePlan',
        method: 'post',
        data: data
    });
};

var createPrice = function createPrice(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/createPrice',
        method: 'post',
        data: data
    });
};

var createCustomer = function createCustomer(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/createCustomer',
        method: 'post',
        data: data
    });
};

var createSession = function createSession(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/createSession',
        method: 'post',
        data: data
    });
};

var checkSubscribe = function checkSubscribe(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/v1/subscriptionSearch?customerId=' + id,
        method: 'get'
    });
};

var setUrl = function setUrl(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/sys/user/saveUrl',
        method: 'post',
        data: data
    });
};

var sendCode = function sendCode(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/email/sendMailCode',
        method: 'post',
        data: data
    });
};

var sendVCode = function sendVCode(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/email/sendMailVCode',
        method: 'post',
        data: data
    });
};

var confirmCode = function confirmCode(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/email/confirmCode',
        method: 'post',
        data: data
    });
};

var changepwd = function changepwd(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/updatePassword',
        method: 'post',
        data: data
    });
};

var showUrl = function showUrl(data) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/sys/user/getUserUrl',
        method: 'get'
    });
};

var delRoom = function delRoom(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request_js__["a" /* default */])({
        url: '/jeecg-boot/games/rooms/deleteRoom/' + id,
        method: 'delete'
    });
};

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(823)
__webpack_require__(824)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  "data-v-6bedf926",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(829)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  "data-v-76a2c8c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_index_Login_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_index_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_index_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_index_Register_vue__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_index_Register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_index_Register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_index_My_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_index_My_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_index_My_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_index_Info_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_index_Info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_index_Info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_index_Workspace_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_index_Workspace_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_index_Workspace_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_index_Waiting_vue__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_index_Waiting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_index_Waiting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_room_Index_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_room_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_room_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_room_Info_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_room_Info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_room_Info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_room_Logs_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_room_Logs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_room_Logs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_pay_Index_vue__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_pay_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_pay_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_game_Index_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_game_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_game_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_game_Index1_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_game_Index1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_game_Index1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_game_Index2_vue__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_game_Index2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_game_Index2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_game_Index3_vue__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_game_Index3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_game_Index3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_game_Result_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_game_Result_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_game_Result_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_pay_Seturl_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_pay_Seturl_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_pay_Seturl_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_pay_Choose_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_pay_Choose_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_pay_Choose_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_feedback_Feedback_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_feedback_Feedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_feedback_Feedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_game_analysis_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_game_analysis_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_game_analysis_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_room_resu_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_room_resu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_room_resu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_index_TermsOfService__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_index_TermsOfService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_index_TermsOfService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_index_PrivacyPolicy__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_index_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_index_PrivacyPolicy__);


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{ path: '/', redirect: '/my' }, { path: '/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_3__views_index_Login_vue___default.a }, { path: '/register', name: 'register', component: __WEBPACK_IMPORTED_MODULE_4__views_index_Register_vue___default.a }, { path: '/my', name: 'my', component: __WEBPACK_IMPORTED_MODULE_5__views_index_My_vue___default.a }, { path: '/info', name: 'userinfo', component: __WEBPACK_IMPORTED_MODULE_6__views_index_Info_vue___default.a }, { path: '/workspace', name: 'workspace', component: __WEBPACK_IMPORTED_MODULE_7__views_index_Workspace_vue___default.a }, { path: '/waiting', name: 'waiting', component: __WEBPACK_IMPORTED_MODULE_8__views_index_Waiting_vue___default.a }, { path: '/room/index', name: 'invite', component: __WEBPACK_IMPORTED_MODULE_9__views_room_Index_vue___default.a }, { path: '/room/info', name: 'room', component: __WEBPACK_IMPORTED_MODULE_10__views_room_Info_vue___default.a }, { path: '/room/logs', name: 'logs', component: __WEBPACK_IMPORTED_MODULE_11__views_room_Logs_vue___default.a }, { path: '/pay/index', name: 'plan', component: __WEBPACK_IMPORTED_MODULE_12__views_pay_Index_vue___default.a }, { path: '/pay/seturl', name: 'seturl', component: __WEBPACK_IMPORTED_MODULE_18__views_pay_Seturl_vue___default.a }, { path: '/game/index', name: 'game', component: __WEBPACK_IMPORTED_MODULE_13__views_game_Index_vue___default.a }, { path: '/game/result', name: 'gameresult', component: __WEBPACK_IMPORTED_MODULE_17__views_game_Result_vue___default.a }, { path: '/pay/choose', name: 'choose', component: __WEBPACK_IMPORTED_MODULE_19__views_pay_Choose_vue___default.a }, { path: '/feedback/feedback', name: 'feedback', component: __WEBPACK_IMPORTED_MODULE_20__views_feedback_Feedback_vue___default.a }, { path: '/game/index2', name: 'game2', component: __WEBPACK_IMPORTED_MODULE_15__views_game_Index2_vue___default.a }, { path: '/game/index3', name: 'game3', component: __WEBPACK_IMPORTED_MODULE_16__views_game_Index3_vue___default.a }, { path: '/game/index1', name: 'game1', component: __WEBPACK_IMPORTED_MODULE_14__views_game_Index1_vue___default.a }, { path: '/game/analysis', name: 'analysis', component: __WEBPACK_IMPORTED_MODULE_21__views_game_analysis_vue___default.a }, { path: '/room/resu', name: 'resu', component: __WEBPACK_IMPORTED_MODULE_22__views_room_resu_vue___default.a }, { path: '/terms-of-service', name: 'terms-of-service', component: __WEBPACK_IMPORTED_MODULE_23__views_index_TermsOfService___default.a }, { path: '/privacy-policy', name: 'privacy-policy', component: __WEBPACK_IMPORTED_MODULE_24__views_index_PrivacyPolicy___default.a }]
});

router.beforeEach(function (to, from, next) {
    if (to.path === '/terms-of-service' || to.path === '/feedback/feedback' || to.path === '/privacy-policy') {
        next();
    } else if (to.path === '/login' || to.path === '/register') {
        localStorage.removeItem('Authorization');
        localStorage.removeItem('homeowner');
        localStorage.removeItem('userEmail');
        next();
    } else {
        var token = localStorage.getItem('Authorization');
        var query = to.query,
            newQuery = {},
            roomId = 0,
            invite = '',
            code = '';
        if (query.hasOwnProperty('roomId')) {
            roomId = query.roomId;
            newQuery.roomId = roomId;
        }
        if (query.hasOwnProperty('invite')) {
            invite = query.invite;
            newQuery.invite = invite;
        }
        if (query.hasOwnProperty('code')) {
            code = query.code;
            newQuery.code = code;
        }

        if (token === null || token === '') {
            localStorage.removeItem('Authorization');
            localStorage.removeItem('homeowner');
            localStorage.removeItem('userEmail');
            next({ path: '/login', query: newQuery });
        } else {
            next();
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(52);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    state: {
        loader: true,
        footerShow: true,
        isJoin: false,
        Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
        homeowner: localStorage.getItem('homeowner') ? localStorage.getItem('homeowner') : '',
        userEmail: localStorage.getItem('userEmail') ? localStorage.getItem('userEmail') : '',
        userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '' },
    mutations: {
        updateLoader: function updateLoader(state, val) {
            state.loader = val ? true : false;
        },
        updateJoin: function updateJoin(state, val) {
            state.isJoin = val ? true : false;
        },
        updateFooter: function updateFooter(state, val) {
            state.footerShow = val ? true : false;
        },
        changeLogin: function changeLogin(state, user) {
            state.Authorization = user.Authorization;
            state.homeowner = user.homeowner;
            state.userEmail = user.userEmail;
            state.userName = user.userName;
            console.log(user.Authorization);
            localStorage.setItem('Authorization', user.Authorization);
            localStorage.setItem('homeowner', user.homeowner);
            localStorage.setItem('userEmail', user.userEmail);
            localStorage.setItem('userName', user.userName);
        }
    },
    actions: {},
    modules: {}
}));

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(52);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    ws: null,
    lockReconnect: false,
    timeout: 15000,
    timeoutObj: null,
    serverTimeoutObj: null,
    timeoutnum: null,
    msg: null },
  getters: {
    socketMsgs: function socketMsgs(state) {
      return state.msg;
    }
  },
  mutations: {
    webSocketInit: function webSocketInit(state) {
      var that = this;

      state.ws = new WebSocket(__webpack_require__.i({"NODE_ENV":"production"}).VUE_APP_WEBSOCKET_URL);
      state.ws.onopen = function (res) {
        console.log("Connection success...");

        that.commit("start");
      };
      state.ws.onmessage = function (res) {
        if (res.data === "heartCheck") {
          that.commit("reset");
          console.log("socket-heartCheck");
        } else {
          state.msg = res;
        }
      };
      state.ws.onclose = function (res) {
        console.log("Connection closed...");

        that.commit('reconnect');
      };
      state.ws.onerror = function (res) {
        console.log("Connection error...");

        that.commit('reconnect');
      };
    },
    reconnect: function reconnect(state) {
      var that = this;
      if (state.lockReconnect) {
        return;
      }
      state.lockReconnect = true;

      state.timeoutnum && clearTimeout(state.timeoutnum);
      state.timeoutnum = setTimeout(function () {
        that.commit('webSocketInit');
        state.lockReconnect = false;
      }, 5000);
    },
    reset: function reset(state) {
      var that = this;

      clearTimeout(state.timeoutObj);
      clearTimeout(state.serverTimeoutObj);

      that.commit('start');
    },
    start: function start(state) {
      var self = this;
      state.timeoutObj && clearTimeout(state.timeoutObj);
      state.serverTimeoutObj && clearTimeout(state.serverTimeoutObj);
      state.timeoutObj = setTimeout(function () {
        if (state.ws.readyState === 1) {
          state.ws.send("heartCheck");
        } else {
          self.commit('reconnect');
        }
        state.serverTimeoutObj = setTimeout(function () {
          state.ws.close();
        }, state.timeout);
      }, state.timeout);
    }
  },
  actions: {
    webSocketInit: function webSocketInit(_ref, url) {
      var commit = _ref.commit;

      commit('webSocketInit', url);
    },
    webSocketSend: function webSocketSend(_ref2, p) {
      var commit = _ref2.commit;

      commit('webSocketSend', p);
    }
  }
}));

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_footer_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      footerShow: this.$store.state.footerShow
    };
  },

  computed: {
    changrFooterShow: function changrFooterShow() {
      return this.$store.state.footerShow;
    }
  },
  watch: {
    changrFooterShow: function changrFooterShow(val, oldVal) {
      this.footerShow = val;
    }
  },
  components: {
    vfooter: __WEBPACK_IMPORTED_MODULE_0__components_footer_vue___default.a
  },
  methods: {
    toLogin: function toLogin() {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var wsBaseUrl = 'ws://cardgame.unismart.dev/jeecg-boot/websocket/';
var region = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外'];
var job = ['公務員', '経営者・役員', '会社員', '自営業', '自由業', '専業主婦', 'パート・アルバイト', '学生', 'その他'];
var sexBox = ['秘密', '男性', '女性'];
var tags = ['一番手', '二番手', '三番手', '四番手', '五番手', '六番手'];

var randomString = function randomString(len) {
  len = len || 6;

  var $chars = 'ABCDEFGHJKMNPQRSTWXYZ12345678';
  var maxLen = $chars.length;
  var str = '';
  for (var i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxLen));
  }
  return str;
};

var strToTime = function strToTime(time) {
  var date = new Date(time);
  var newTime = Date.parse(date) / 1000;
  return newTime;
};

var timeFormat = function timeFormat(value) {
  if (value) {
    var add0 = function add0(m) {
      return m < 10 ? '0' + m : m;
    };
    var time = new Date(value);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();

    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm);
  } else {
    return '';
  }
};

var getHttps = function getHttps() {
  var ishttps = 'https:' == document.location.protocol ? true : false;
  var isUrl = 'https';
  if (ishttps) {
    isUrl = 'https';
  } else {
    isUrl = 'http';
  }
  return isUrl;
};
/* harmony default export */ __webpack_exports__["default"] = ({
  wsBaseUrl: wsBaseUrl,
  region: region,
  job: job,
  sexBox: sexBox,
  tags: tags,
  randomString: randomString,
  strToTime: strToTime,
  timeFormat: timeFormat,
  getHttps: getHttps
});

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);

var echarts = __webpack_require__(748);

__webpack_require__(576);
__webpack_require__(667);

__webpack_require__(688);
__webpack_require__(678);

__webpack_require__(649);


/* harmony default export */ __webpack_exports__["default"] = ({
	name: "echarts",
	props: {
		height: {
			type: String,
			default: "32rem"
		},
		width: {
			type: String,
			default: "32rem"
		},
		id: {
			type: String,
			default: "demo"
		},
		userid: {
			type: String
		}
	},
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		this.drawLine();
	},

	methods: {
		drawLine: function drawLine() {
			var that = this;

			console.log('userid', that.userid);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["c" /* getCharacter */])(that.userid).then(function (res) {
				console.log(res);
				if (res.code == 0) {
					console.log("success");
					var myChart = echarts.init(document.getElementById(that.id));

					myChart.setOption({
						radar: [{
							triggerEvent: true,

							radius: 100,
							center: ['50%', '50%'],
							axisName: {
								formatter: '{value}',
								color: '#000'
							},
							indicator: [{
								name: '専門',
								max: 5
							}, {
								name: '伝達',
								max: 5
							}, {
								name: '自然体',
								max: 5
							}, {
								name: '挑戦、問題解決',
								max: 5
							}, {
								name: '社会貢献',
								max: 5
							}, {
								name: '創造',
								max: 5
							}, {
								name: '安心、安定',
								max: 5
							}, {
								name: '独自',
								max: 5
							}, {
								name: '組織',
								max: 5
							}]
						}],
						tooltip: {
							trigger: 'axis',
							triggerEvent: true,
							axisPointer: {
								type: 'line' },
							textStyle: {
								color: '#000',
								fontSize: 14 }
						},
						splitLine: {
							lineStyle: {
								color: ['rgba(52, 148, 136, 0.3)', 'rgba(52, 148, 136, 0.4)', 'rgba(52, 148, 136, 0.5)', 'rgba(52, 148, 136, 0.7)', 'rgba(52, 148, 136, 0.8)', 'rgba(52, 148, 136, 1)'].reverse()
							}
						},
						series: [{
							name: '',
							type: 'radar',
							textStyle: {
								color: '#000000',
								fontSize: 14 },
							data: [{
								value: res.result.resultList
							}]
						}]
					});
				}
			});
		}
	}
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  methods: {
    toFeedback: function toFeedback() {
      this.$router.push('/feedback/feedback');
    },
    toTermsOfService: function toTermsOfService() {
      window.open('#/terms-of-service', '_blank');
    },
    toPrivacyPolicy: function toPrivacyPolicy() {
      window.open('#/privacy-policy', '_blank');
    }
  }
});

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      links: [],
      centerDialogVisible: false,
      url: "",
      multies: true,
      passForm: {
        url1: "",
        url2: "",
        url3: "",
        url4: "",
        url5: ""
      },
      options: [{
        value: '商品に関する問い合わせ1',
        label: '商品に関する問い合わせ'
      }, {
        value: 'プランの問い合わせ2',
        label: 'プランの問い合わせ'
      }, {
        value: 'その他',
        label: 'その他'
      }],
      value: '',
      textarea: ""
    };
  },
  created: function created() {},

  components: {},
  methods: {
    goback: function goback() {
      this.$router.push('/my');
    },
    sendMail: function sendMail() {
      var data = {
        content: this.textarea,
        subject: this.value

      };
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["h" /* getsendMail */])(data).then(function (res) {
        console.log(123, res);
        if (res.code == 200) {
          that.$message({
            message: "送信しました",
            type: "success"
          });
          that.goback();
        }
      }).catch(function (err) {
        console.log(321, res);
      });
    },

    goPage: function goPage(page) {
      this.$router.push(page);
    },
    tobuy: function tobuy() {
      var that = this;
      that.centerDialogVisible = true;
    }
  }

});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_global_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(52);












/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isUrl: "https",
      loading: false,
      tags: this.GLOBAL.tags,
      mode: "play",
      imgUrl: "://online.engagement-card.com/img/",
      cardsBack: __webpack_require__(123),
      scrollWidth: "900px",
      UID: "",

      userId: "1505124724596801538",
      userEmail: "2856678408@qq.com",
      userName: "",
      allCards: [],
      cards: [],
      cardsNum: 89,
      isfinish: 0,
      lastDiscardNum: 0,
      touch: {
        disX: 0,
        disY: 0,
        originalScrollLeft: 0,
        originalScrollTop: 0,
        originalScrollBehavior: '',
        originalPointerEvents: ''
      },

      users: [],

      users2: [],

      roomId: "c0e6b1e56ed0141b000650f2ec5232d9",
      play: true,
      isHomewer: false,
      info: {
        homeowner: "1505124724596801538",
        roomName: "测试房间1",
        homeownerName: "戸田勇大1",
        startTime: "2022-4-6 10:00",
        theme: "人生",
        isCopy: true,
        isPublic: false,
        peopleNumber: 4,
        url: ""
      },

      userInfo: {},

      user1: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user2: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user3: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user4: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user5: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user6: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },

      userCards: [],

      extracting: false,
      extractCardInfo: {},
      discardCardInfo: {},

      playUser: 1,
      gemePeople: 0,

      dialogSettingVisible: false,
      dialogFinishVisible: false,
      dialogSkipVisible: false,
      dialogPauseVisible: false,
      dialogPauseVisiblePre: false,
      dialogSkipVisiblePre: false,

      userTimes: 0,
      totalPerson: 0,
      countsNumber: 0,
      gameTimes: {
        str: "00:00",
        hour: 0,
        minute: 0,
        second: 0,
        ms: 0
      },
      watchCount: 0 };
  },

  watch: {
    user1: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        if (val.hasOwnProperty("discard")) {
          var el = this.$refs.location1,
              discardCount = val.discard.length,
              clientWidth = 0;
          if (discardCount > 7) {
            clientWidth = (el.children[0].clientWidth + 25) * discardCount;
            el.style["width"] = clientWidth + "px";
          }
        }
      }
    },
    user3: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        if (val.hasOwnProperty("discard")) {
          var el = this.$refs.location3,
              discardCount = val.discard.length,
              clientWidth = 0;
          if (discardCount > 7) {
            clientWidth = (el.children[0].clientWidth + 25) * discardCount;
            el.style["width"] = clientWidth + "px";
          }
        }
      }
    },
    users2: {
      immediate: true,

      deep: true,
      handler: function handler(val) {}
    },
    cards: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        console.log("监听卡牌", val);
      }
    }
  },
  components: {},
  created: function created() {
    this.updateFooter(false);
    this.roomId = this.$route.query.roomId;
    this.userId = localStorage.getItem("homeowner");
    this.userEmail = localStorage.getItem("userEmail");
    this.getRoomDetail();
  },
  mounted: function mounted() {
    this.users = JSON.parse(localStorage.getItem("room_" + this.roomId));

    this.getUserInfo();
    this.goTimes();
    this.countDown();
    window.addEventListener("onmessageWS", this.getsocketData);
    if (document.getElementById('app')) {
      document.getElementById('app').style.overflow = 'hidden';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapMutations */])(["updateFooter"]), {
    goPage: function goPage(page) {
      this.$router.push(page);
    },

    createSocket: function createSocket(code, userEmail) {
      var that = this;
      var wsUrl = "";
      var ishttps = "https:" == document.location.protocol ? true : false;

      if (ishttps) wsUrl = "wss://" + __WEBPACK_IMPORTED_MODULE_8__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;else wsUrl = "ws://" + __WEBPACK_IMPORTED_MODULE_8__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["a" /* createSocket */])(wsUrl);
    },
    csh: function csh() {
      var that = this;
      that.discardCardInfo = {};
      that.copiedcard = {};
      for (var i = 0; i < that.user1.cards.length; i++) {
        that.user1.cards[i].checked = false;
      }
      for (var _i = 0; _i < that.user1.discard.length; _i++) {
        that.user1.discard[_i].checked = false;
      }
      for (var _i2 = 0; _i2 < that.user2.cards.length; _i2++) {
        that.user2.cards[_i2].checked = false;
      }
      for (var _i3 = 0; _i3 < that.user2.discard.length; _i3++) {
        that.user2.discard[_i3].checked = false;
      }
      for (var _i4 = 0; _i4 < that.user3.cards.length; _i4++) {
        that.user3.cards[_i4].checked = false;
      }
      for (var _i5 = 0; _i5 < that.user3.discard.length; _i5++) {
        that.user3.discard[_i5].checked = false;
      }
      for (var _i6 = 0; _i6 < that.user4.cards.length; _i6++) {
        that.user4.cards[_i6].checked = false;
      }
      for (var _i7 = 0; _i7 < that.user4.discard.length; _i7++) {
        that.user4.discard[_i7].checked = false;
      }
      for (var _i8 = 0; _i8 < that.user5.cards.length; _i8++) {
        that.user5.cards[_i8].checked = false;
      }
      for (var _i9 = 0; _i9 < that.user5.discard.length; _i9++) {
        that.user5.discard[_i9].checked = false;
      }
      for (var _i10 = 0; _i10 < that.user6.cards.length; _i10++) {
        that.user6.cards[_i10].checked = false;
      }
      for (var _i11 = 0; _i11 < that.user6.discard.length; _i11++) {
        that.user6.discard[_i11].checked = false;
      }
    },
    getSame: function getSame() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["d" /* getSame */])(that.roomId).then(function (res) {
        console.log("same", res);
        if (res.result) {
          if (res.result.customize) {
            var samedata = JSON.parse(res.result.customize);
            var re = samedata[0];
            console.log("re", re);

            setTimeout(function () {
              for (var i = 0; i < re.temp.length; i++) {
                if (that.user1.sort == re.temp[i].sort) {
                  that.user1 = re.temp[i];
                }
                if (that.user2.sort == re.temp[i].sort) {
                  that.user2 = re.temp[i];
                }
                if (that.user3.sort == re.temp[i].sort) {
                  that.user3 = re.temp[i];
                }
                if (that.user4.sort == re.temp[i].sort) {
                  that.user4 = re.temp[i];
                }
              }
              that.cards = re.pk;
              that.userTimes = re.countdown;
              that.gameTimes = re.gameTime;
              that.playUser = re.usersort;
            }, 1000);
          }
        }
      });
    },

    getsocketData: function getsocketData(e) {
      var that = this;
      if (e.detail.data == "发生连接错误") return false;
      var data = JSON.parse(e.detail.data),
          newUser = {},
          isNew = true;
      if (data.onlineNumber > 0) {
        that.totalPerson = data.onlineNumber;
        that.getSame();
      }
      if (data.operateMsg == "从卡堆抽牌") {
        that.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            that.extractCardInfo = {
              index: index,
              id: data.number,
              url: item.url
            };
            that.extracting = true;
            return true;
          }
        });
      }
      if (data.operateMsg == "从弃卡堆里抽牌") {
        var newCard = {},
            location = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            newCard = card;
          }
        });

        that.user1.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 1;
            newCard.index = index;
          }
        });
        that.user2.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 2;
            newCard.index = index;
          }
        });
        that.user3.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 3;
            newCard.index = index;
          }
        });
        that.user4.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 4;
            newCard.index = index;
          }
        });

        that.discardCardInfo = newCard;
      }
      if (data.operateMsg == "替换手牌") {
        that.users2.forEach(function (item, index) {
          if (data.userId == item.id) {
            var _location = item.location,
                userCards = [];
            switch (_location) {
              case 1:
                userCards = that.user1.cards;
                break;
              case 2:
                userCards = that.user2.cards;
                break;
              case 3:
                userCards = that.user3.cards;
                break;
              case 4:
                userCards = that.user4.cards;
                break;
              case 5:
                userCards = that.user5.cards;
                break;
              case 6:
                userCards = that.user6.cards;
                break;
            }
            if (that.extractCardInfo.id) {
              var _newCard = that.extractCardInfo,
                  oldCard = {};
              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(oldCard, _location, that);
                  }
                  that.cards.splice(_newCard.index, 1);
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            } else if (that.discardCardInfo.id) {
              var _newCard2 = that.discardCardInfo,
                  _oldCard = {};
              console.log("新手牌信息", _newCard2);
              console.log("替换手牌ID", data.number);

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard2;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard2;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard2;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard2;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard2;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard2;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(_oldCard, _newCard2.location, that);
                  }

                  that.$options.methods.delDiscardCard(_newCard2, _newCard2.location, that);
                }
              });
            } else if (that.copiedcard.id) {
              var _newCard3 = that.copiedcard,
                  _oldCard2 = {};

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard2 = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard3;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard3;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard3;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard3;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard3;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard3;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(_oldCard2, _newCard3.location, that);
                  }

                  that.$options.methods.delDiscardCard(_newCard3, _newCard3.location, that);
                  that.copiedcard = {};
                }
              });
            }
          }
        });
      }
      if (data.operateMsg == "弃牌") {
        console.log("已经弃牌");
        if (that.extractCardInfo.id) {
          var _newCard4 = that.extractCardInfo;
          _newCard4.checked = false;
          console.log(that.users2);
          that.users2.forEach(function (item, index) {
            var location = item.location;
            if (item.id == data.userId) {
              console.log(item.id, data.userId);
              that.cards.splice(_newCard4.index, 1);
              console.log("newCard", _newCard4);
              console.log("discard", that.user1.discard);
              console.log(that.user1.discard.indexOf(_newCard4));
              switch (location) {
                case 1:
                  if (that.user1.discard.indexOf(_newCard4) == -1) {
                    that.user1.discard.splice(0, 0, _newCard4);
                    that.user1.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user1.discard)));
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(_newCard4) == -1) {
                    that.user2.discard.splice(0, 0, _newCard4);
                    that.user2.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user2.discard)));
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(_newCard4) == -1) {
                    that.user3.discard.splice(0, 0, _newCard4);
                    that.user3.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user3.discard)));
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(_newCard4) == -1) {
                    that.user4.discard.splice(0, 0, _newCard4);
                    that.user4.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user4.discard)));
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(_newCard4) == -1) {
                    that.user5.discard.splice(0, 0, _newCard4);
                    that.user5.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(_newCard4) == -1) {
                    that.user6.discard.splice(0, 0, _newCard4);
                    that.user6.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
              }
            }
          });
        } else if (that.discardCardInfo.id) {
          var _newCard5 = that.discardCardInfo;
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location2 = item.location,
                  userCards = [];

              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location2) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                    that.user1.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user1.discard)));
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                    that.user2.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user2.discard)));
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                    that.user3.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user3.discard)));
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                    that.user4.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user4.discard)));
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                    that.user5.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                    that.user6.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user6.discard)));
                  }
                  break;
              }
            }
          });
        } else {
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location3 = item.location;
              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location3) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                    that.user1.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user1.discard)));
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                    that.user2.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user2.discard)));
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                    that.user3.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user3.discard)));
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                    that.user4.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user4.discard)));
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                    that.user5.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                    that.user6.discard = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(that.user6.discard)));
                  }
                  break;
              }
            }
          });
        }
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.lastDiscardNum = data.foldNumber;
      }
      if (data.operateMsg == "下一用户操作") {
        if (that.isHomewer == true && that.cards.length == 0 && that.isfinish == 0) {
          that.isfinish = 1;
          that.noDoTimeOut();
        }
        that.UID = data.userId;
        console.log("dataid", data.userId);
        console.log("userid", that.userId);
        if (data.userId == that.userId) {
          that.$notify({
            title: "通知",
            message: "あなたの番です"
          });
        }
        for (var i = 0; i < that.user1.cards.length; i++) {
          that.user1.cards[i].checked = false;
        }
        for (var _i12 = 0; _i12 < that.user2.cards.length; _i12++) {
          that.user2.cards[_i12].checked = false;
        }
        for (var _i13 = 0; _i13 < that.user3.cards.length; _i13++) {
          that.user3.cards[_i13].checked = false;
        }
        for (var _i14 = 0; _i14 < that.user4.cards.length; _i14++) {
          that.user4.cards[_i14].checked = false;
        }
        var ids = [];
        that.userTimes = that.countsNumber;
        that.$options.methods.countDown();
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.users2.forEach(function (item, index) {
          if (item.id == data.userId) {
            that.playUser = item.sort;
          }
          if (item.checked == true) {
            ids.push(item.id);
          }
        });
        var arr = [];
        var syc = {};
        var temp = [];
        temp.push(that.user1);
        temp.push(that.user2);
        temp.push(that.user3);
        temp.push(that.user4);
        syc.temp = temp;
        syc.countdown = that.userTimes;
        syc.gameTime = that.gameTimes;
        syc.pk = that.cards;
        syc.users2 = that.users2;
        syc.usersort = that.playUser;
        syc.UId = that.UID;
        arr.push(syc);
        var next = {
          operateType: 13,
          userId: that.userId,
          roomId: that.roomId,
          username: that.userEmail,
          userIds: ids,
          customize: arr,
          url: that.info.url
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(next);
      }
      if (data.operateMsg == "游戏暂停") {
        that.play = false;
        that.dialogPauseVisible = true;
        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "继续游戏") {
        that.play = true;
        that.dialogPauseVisible = false;
        that.countDown();
        that.goTimes();
      }

      if (data.operateMsg == "等待房主操作") {
        that.play = false;

        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "跳过用户") {
        var cur = "";
        var cname = "";
        that.users2.forEach(function (item, index) {
          if (that.playUser == item.sort) {
            cur = item.id;
            cname = item.username;
          }
          if (data.userIds.indexOf(item.id) != -1) {
            item.checked = true;
            item.isSkip = true;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = true;
                break;
              case 2:
                that.user2.isSkip = true;
                break;
              case 3:
                that.user3.isSkip = true;
                break;
              case 4:
                that.user4.isSkip = true;
                break;
              case 5:
                that.user5.isSkip = true;
                break;
              case 6:
                that.user6.isSkip = true;
                break;
            }
          }
        });

        if (data.nextFlag) {
          var _arr = [];
          var _syc = {};
          var _temp = [];
          _temp.push(that.user1);
          _temp.push(that.user2);
          _temp.push(that.user3);
          _temp.push(that.user4);
          _syc.temp = _temp;
          _syc.countdown = that.userTimes;
          _syc.gameTime = that.gameTimes;
          _syc.pk = that.cards;
          _syc.users2 = that.users2;
          _arr.push(_syc);
          var _ids = [];
          that.users2.forEach(function (item, index) {
            if (item.checked == true) {
              _ids.push(item.id);
            }
          });
          var _next = {
            operateType: 12,
            userId: cur,
            roomId: that.roomId,
            username: cname,
            userIds: _ids,
            customize: _arr,
            url: that.info.url
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(_next);
        }
      }

      if (data.operateMsg == "解除跳过用户") {
        console.log("users2", that.users2);
        that.users2.forEach(function (item, index) {
          console.log("item", item);
          console.log("sdata", data);
          if (data.userIds.indexOf(item.id) != -1) {
            item.checked = false;
            item.isSkip = false;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = false;
                break;
              case 2:
                that.user2.isSkip = false;
                break;
              case 3:
                that.user3.isSkip = false;
                break;
              case 4:
                that.user4.isSkip = false;
                break;
              case 5:
                that.user5.isSkip = false;
                break;
              case 6:
                that.user6.isSkip = false;
                break;
            }
          }
        });
      }

      if (data.operateMsg == "复制其他用户的牌") {
        var _newCard6 = {},
            _location4 = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            _newCard6 = card;
          }
        });

        that.user1.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 1;
            _newCard6.index = index;
          }
        });
        that.user2.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 2;
            _newCard6.index = index;
          }
        });
        that.user3.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 3;
            _newCard6.index = index;
          }
        });
        that.user4.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 4;
            _newCard6.index = index;
          }
        });

        that.copiedcard = _newCard6;
      }

      if (data.operateMsg == "游戏结束") {
        var result = {
          minute: that.gameTimes.minute,
          second: that.gameTimes.second
        };
        var users = [];
        localStorage.removeItem("hasStart");
        if (that.user1.id) users.push(that.user1);
        if (that.user2.id) users.push(that.user2);
        if (that.user3.id) users.push(that.user3);
        if (that.user4.id) users.push(that.user4);
        if (that.user5.id) users.push(that.user5);
        if (that.user6.id) users.push(that.user6);
        result.users = users;
        var addResultParamList = [];
        if (that.user1.id) {
          var _temp2 = [];
          var obj = {};
          for (var _i15 = 0; _i15 < that.user1.cards.length; _i15++) {
            if (that.user1.cards[_i15].id < 10) {
              _temp2.push("0" + that.user1.cards[_i15].id);
            } else {
              _temp2.push(that.user1.cards[_i15].id);
            }
          }
          obj.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp2);
          obj.userName = that.user1.nickname;
          obj.userRole = that.user1.tag == "房主" ? 1 : 0;
          obj.roomId = that.roomId;
          addResultParamList.push(obj);
        }
        if (that.user2.id) {
          var _temp3 = [];
          var _obj = {};
          for (var _i16 = 0; _i16 < that.user2.cards.length; _i16++) {
            if (that.user2.cards[_i16].id < 10) {
              _temp3.push("0" + that.user2.cards[_i16].id);
            } else {
              _temp3.push(that.user2.cards[_i16].id);
            }
          }
          _obj.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp3);
          _obj.userName = that.user2.nickname;
          _obj.userRole = that.user2.tag == "房主" ? 1 : 0;
          _obj.roomId = that.roomId;
          addResultParamList.push(_obj);
        }
        if (that.user3.id) {
          var _temp4 = [];
          var _obj2 = {};
          for (var _i17 = 0; _i17 < that.user3.cards.length; _i17++) {
            if (that.user3.cards[_i17].id < 10) {
              _temp4.push("0" + that.user3.cards[_i17].id);
            } else {
              _temp4.push(that.user3.cards[_i17].id);
            }
          }
          _obj2.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp4);
          _obj2.userName = that.user3.nickname;
          _obj2.userRole = that.user3.tag == "房主" ? 1 : 0;
          _obj2.roomId = that.roomId;
          addResultParamList.push(_obj2);
        }
        if (that.user4.id) {
          var _temp5 = [];
          var _obj3 = {};
          for (var _i18 = 0; _i18 < that.user4.cards.length; _i18++) {
            if (that.user4.cards[_i18].id < 10) {
              _temp5.push("0" + that.user4.cards[_i18].id);
            } else {
              _temp5.push(that.user4.cards[_i18].id);
            }
          }
          _obj3.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp5);
          _obj3.userName = that.user4.nickname;
          _obj3.userRole = that.user4.tag == "房主" ? 1 : 0;
          _obj3.roomId = that.roomId;
          addResultParamList.push(_obj3);
        }
        if (that.user5.id) {
          var _temp6 = [];
          var _obj4 = {};
          for (var _i19 = 0; _i19 < that.user5.cards.length; _i19++) {
            if (that.user5.cards[_i19].id < 10) {
              _temp6.push("0" + that.user5.cards[_i19].id);
            } else {
              _temp6.push(that.user5.cards[_i19].id);
            }
          }
          _obj4.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp6);
          _obj4.userName = that.user5.nickname;
          _obj4.userRole = that.user5.tag == "房主" ? 1 : 0;
          _obj4.roomId = that.roomId;
          addResultParamList.push(_obj4);
        }
        if (that.user6.id) {
          var _temp7 = [];
          var _obj5 = {};
          for (var _i20 = 0; _i20 < that.user6.cards.length; _i20++) {
            if (that.user6.cards[_i20].id < 10) {
              _temp7.push("0" + that.user6.cards[_i20].id);
            } else {
              _temp7.push(that.user6.cards[_i20].id);
            }
          }
          _obj5.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp7);
          _obj5.userName = that.user6.nickname;
          _obj5.userRole = that.user6.tag == "房主" ? 1 : 0;
          _obj5.roomId = that.roomId;
          addResultParamList.push(_obj5);
        }
        console.log("result", addResultParamList);
        localStorage.setItem("room_result_" + that.roomId, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(result));
        localStorage.setItem("addResultParamList", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(addResultParamList));
        that.$router.push({
          path: "/game/result",
          query: {
            roomId: that.roomId
          }
        });
      }
    },

    giveLocation: function giveLocation(code, email) {
      var that = this,
          giveNum = 1,
          isPlayer = false,
          players = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";

      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }
      var playerIds = [];
      var playerIdsBox = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards);

      playerIdsBox.forEach(function (key, index) {
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        playerIds.push(key);
      });
      console.log("玩家ID顺序", playerIds);
      that.UID = playerIds[0];
      var playersCount = playerIds.length,
          num = 1;
      playerIds.forEach(function (key, index) {
        console.log(key);
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["e" /* getUserInfoById */])(key).then(function (res) {
          console.log("getUserInfoById", res);
          if (res.code == 200 && res.result) {
            var sort = index + 1,
                tag = that.tags[index],
                isHomewer = false;
            if (key == that.info.homeowner) {
              tag = "房主";
              isHomewer = true;
            }
            var userInfo = {
              email: res.result.email,
              id: res.result.id,
              realname: res.result.realname,
              nickname: res.result.nickname,
              username: res.result.username,
              sort: index + 1,
              tag: tag,
              isHomewer: isHomewer,
              isSkip: false,
              checked: false
            };
            that.users2.push(userInfo);
            players.push(userInfo);

            if (num == playersCount) {
              players.forEach(function (item, index) {
                if (that.userId == item.id) {
                  that.userInfo = item;
                  that.userInfo.isPlayer = isPlayer = true;
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                  players.splice(index, 1);
                }
              });
              if (!isPlayer) {
                players.forEach(function (item, index) {
                  if (1 == item.sort) {
                    giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                    players.splice(index, 1);
                  }
                });
                that.mode = "watch";
              }
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user2, 2, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user3, 3, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user4, 4, giveNum, that);
                  players.splice(index, 1);
                }
              });
              console.log("玩家", players);

              var cards = [],
                  cardsNum = that.cardsNum;
              for (var i = 1; i <= cardsNum; i++) {
                var url = "",
                    style = "";
                if (i < 10) {
                  url = that.isUrl + that.imgUrl + "card_0" + i + ".png";
                } else {
                  url = that.isUrl + that.imgUrl + "card_" + i + ".png";
                }
                var z = (that.cardsNum - i) / 8;

                style = "transform: translate3d(" + z + "px, " + z + "px, " + z + "px);";
                var card = {
                  id: i,
                  url: url,
                  style: style
                };

                cards[i] = card;
              }
              that.allCards = cards;

              that.user1.cards = [];
              that.user2.cards = [];
              that.user3.cards = [];
              that.user4.cards = [];

              var _userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
              if (!_userCards) {
                that.$message({
                  message: "カード情報に誤りがあるため、ゲームを再起動してください",
                  type: "error"
                });
              }

              var newCards = [],
                  noCards = [];
              playerIds.forEach(function (key) {
                var cardLists = _userCards[key],
                    userCard = [];
                cardLists.forEach(function (item, index) {
                  noCards.push(item);
                });

                cards.forEach(function (item, index) {
                  if (cardLists.indexOf(item.id) >= 0) {
                    userCard.push(item);
                  }
                });
                if (key == that.user1.id) that.user1.cards = userCard;
                if (key == that.user2.id) that.user2.cards = userCard;
                if (key == that.user3.id) that.user3.cards = userCard;
                if (key == that.user4.id) that.user4.cards = userCard;
                if (key == that.user5.id) that.user5.cards = userCard;
                if (key == that.user6.id) that.user6.cards = userCard;
              });

              cards.forEach(function (item, index) {
                if (noCards.indexOf(item.id) < 0) {
                  newCards.push(item);
                }
              });

              that.cards = newCards;
            }
            num++;
          }
        });
      });
      that.$options.methods.createSocket(code, email);
    },

    giveLocationData: function giveLocationData(item, index, obj, location, giveNum, e) {
      if (item.sort < e.info.peopleNumber) {
        giveNum = item.sort + 1;
      } else {
        giveNum = 1;
      }
      obj.email = item.email;
      obj.id = item.id;
      obj.username = item.username;
      obj.nickname = item.nickname;
      obj.realname = item.realname;
      obj.lineStatus = item.lineStatus;
      obj.sort = item.sort;
      obj.tag = item.tag;
      obj.location = location;
      obj.isSkip = item.isSkip;
      e.users2.forEach(function (item2, index2) {
        if (item2.id == item.id) {
          e.users2[index2].location = location;
        }
      });
      return giveNum;
    },

    getCards: function getCards() {
      var cards = [],
          that = this,
          cardsNum = that.cardsNum;
      for (var i = 1; i <= cardsNum; i++) {
        var url = "";
        if (i < 10) {
          url = that.imgUrl + "card_0" + i + ".png";
        } else {
          url = that.imgUrl + "card_" + i + ".png";
        }
        var card = {
          id: i,
          url: url
        };

        cards[i] = card;
      }

      that.user1.cards = [];
      that.user2.cards = [];
      that.user3.cards = [];
      that.user4.cards = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }

      var newCards = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards).forEach(function (key) {
        var cardLists = userCards[key],
            userCard = [];
        cards.forEach(function (item, index) {
          if (cardLists.indexOf(item.id) >= 0) {
            userCard.push(item);
          } else {
            newCards.push(item);
          }
        });
        if (key == that.user1.id) that.user1.cards = userCard;
        if (key == that.user2.id) that.user2.cards = userCard;
        if (key == that.user3.id) that.user3.cards = userCard;
        if (key == that.user4.id) that.user4.cards = userCard;
        if (key == that.user5.id) that.user5.cards = userCard;
        if (key == that.user6.id) that.user6.cards = userCard;
      });

      newCards.sort(function () {
        return Math.random() - 0.5;
      });
      that.cards = newCards;
    },

    shuffle: function shuffle() {
      var that = this;
      var cards = that.cards;

      var cardBoxObj = that.$refs.gamecardslists,
          cardLists = that.$refs.gamecardslists.children;
      cards.sort(function () {
        return Math.random() - 0.5;
      });
      cards.forEach(function (item, index) {
        var cardObj = cardLists[index],
            z = (that.cardsNum - index) / 8;

        cardObj.style["transform"] = "translate3d(" + z + "px, " + z + "px, -" + z + "px)";
      });
    },
    translate: function translate(a, b, c) {
      c = c || 0;
      if (has3d) {
        return "translate3d(" + a + ", " + b + ", " + c + ")";
      } else {
        return "translate(" + a + ", " + b + ")";
      }
    },

    extractCard: function extractCard(item, index) {
      var that = this;
      that.csh();

      console.log("that.userInfo", that.userInfo);
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == true) {
        console.log("操作を禁止しています1");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log(that.userInfo);
        console.log(that.userInfo.sort);
        console.log(that.playUser);
        console.log("操作を禁止しています2");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      that.discardCardInfo = {};

      var noCreatNum = [];
      that.cards.forEach(function (card, id) {
        noCreatNum.push(card.id);
      });
      console.log(noCreatNum);
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        noCreatNum: noCreatNum,

        operateType: 1,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    extractCardFromDiscards: function extractCardFromDiscards(item, index, location, event, discard, username) {
      var that = this;
      that.discardCardInfo = {};
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.extracting == true) {
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
        return false;
      }
      var checked = item.checked;
      that.csh();

      var user1id = [];
      for (var i = 0; i < that.user1.cards.length; i++) {
        user1id.push(that.user1.cards[i].id);
      }
      if (user1id.indexOf(item.id) != -1) {
        that.$message({
          message: "既にこのカードを持っています",
          type: "error"
        });
        return;
      }
      var array = discard;
      for (var _i21 = 0; _i21 < array.length; _i21++) {
        if (_i21 == index) {
          if (!checked) {
            array[_i21].checked = true;
            that.discardCardInfo = {
              location: location,
              index: index,
              id: item.id,
              url: item.url
            };
          } else {
            array[_i21].checked = false;
            that.discardCardInfo = {};
          }
        } else {
          array[_i21].checked = false;
        }
      }
      console.log(array);
      if (username == "user1") {
        that.user1.discard = array;
        console.log("s", that.user1.discard);
      }
      var newCard = that.discardCardInfo;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        number: newCard.id,
        operateType: 3,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    changeOtherCard: function changeOtherCard(item, index, event, location, cards, player) {
      var that = this;
      var user1id = [];
      for (var i = 0; i < that.user1.cards.length; i++) {
        user1id.push(that.user1.cards[i].id);
      }
      if (user1id.indexOf(item.id) != -1) {
        that.$message({
          message: "既にこのカードを持っています",
          type: "error"
        });
        return;
      }
      if (that.extracting == true) {
        return;
      }
      that.csh();
      if (player == "user2") {
        for (var _i22 = 0; _i22 < cards.length; _i22++) {
          console.log(_i22);
          if (index == _i22) {
            if (cards[_i22].checked == true) {
              cards[_i22].checked = false;
            } else {
              cards[_i22].checked = true;
            }
          } else {
            cards[_i22].checked = false;
          }
        }
        that.user2.cards = cards;
      } else if (player == "user3") {
        for (var _i23 = 0; _i23 < cards.length; _i23++) {
          console.log(_i23);
          if (index == _i23) {
            if (cards[_i23].checked == true) {
              cards[_i23].checked = false;
            } else {
              cards[_i23].checked = true;
            }
          } else {
            cards[_i23].checked = false;
          }
        }
        that.user3.cards = cards;
      } else if (player == "user4") {
        for (var _i24 = 0; _i24 < cards.length; _i24++) {
          console.log(_i24);
          if (index == _i24) {
            if (cards[_i24].checked == true) {
              cards[_i24].checked = false;
            } else {
              cards[_i24].checked = true;
            }
          } else {
            cards[_i24].checked = false;
          }
        }
        that.user4.cards = cards;
      }
      if (that.info.isCopy == "あり") {
        var data = {
          number: item.id,
          operateType: 2,
          url: that.info.url,
          userId: that.userId,
          username: that.userEmail,
          roomId: that.roomId
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
      } else {}
    },

    changeSelfCard: function changeSelfCard(item, index, event, location) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        that.$message({
          message: "観戦中",
          type: "error"
        });
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");

        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      var newCard = {},
          oldCard = that.user1.cards[index],
          discardType = 0;

      if (that.extractCardInfo.id) {
        discardType = 1;
      } else if (that.discardCardInfo.id) {
        discardType = 2;
      } else if (that.copiedcard.id) {
        discardType = 3;
      }
      if (discardType == 0) {
        console.log("操作を禁止しています");

        return false;
      }

      if (discardType == 3) {
        if (location == 1) {
          newCard = that.copiedcard;
          var temp = [];
          temp.push(that.user1);
          temp.push(that.user2);
          temp.push(that.user3);
          temp.push(that.user4);
          var data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
        }
      } else {
        if (location == 1) {
          newCard = that.extractCardInfo;
          var _temp8 = [];
          _temp8.push(that.user1);
          _temp8.push(that.user2);
          _temp8.push(that.user3);
          _temp8.push(that.user4);
          var _data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(_data);
        }
      }
    },

    discardCard: function discardCard(location, event) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == false) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      var newCard = that.extractCardInfo;
      that.$options.methods.addDiscardCard(newCard, location, that);
      if (that.cards.length == 0) {
        that.dialogFinishVisible = true;
      }
    },

    addDiscardCard: function addDiscardCard(card, location, e) {
      var that = this;
      console.log("roomid", e.roomId);
      console.log(e);
      var arr = [];
      var syc = {};
      var temp = [];
      temp.push(e.user1);
      temp.push(e.user2);
      temp.push(e.user3);
      temp.push(e.user4);
      syc.temp = temp;
      syc.countdown = e.userTimes;
      syc.gameTime = e.gameTimes;
      syc.pk = e.cards;
      syc.users2 = e.users2;
      arr.push(syc);
      var ids = [];
      e.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: e.userId,
        roomId: e.roomId,
        username: e.userEmail,
        userIds: ids,
        customize: arr,
        url: e.info.url
      };

      var data = {
        foldNumber: card.id,
        operateType: 4,
        url: e.info.url,
        userId: e.userId,
        username: e.userEmail,
        roomId: e.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    delDiscardCard: function delDiscardCard(card, location, e) {
      switch (location) {
        case 1:
          e.user1.discard.splice(card.index, 1);
          break;
        case 2:
          e.user2.discard.splice(card.index, 1);
          break;
        case 3:
          e.user3.discard.splice(card.index, 1);
          break;
        case 4:
          e.user4.discard.splice(card.index, 1);
          break;
        case 5:
          e.user5.discard.splice(card.index, 1);
          break;
        case 6:
          e.user6.discard.splice(card.index, 1);
          break;
      }
    },

    copyCard: function copyCard() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      if (that.extracting = true) {
        that.$message({
          message: "已抽牌，请选择替换手牌",
          type: "error"
        });
      }
    },
    reStart: function reStart() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 11,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    discard_hover: function discard_hover(e) {
      var target = e.target.parentNode;
      var viewportOffset = target.getBoundingClientRect();
      var parent_viewport = target.parentNode.getBoundingClientRect();

      if (target.style.position === 'fixed') {
        return;
      }
      var top = parent_viewport.top;
      var left = parent_viewport.left;

      var cls = target.className;
      if (cls.indexOf('cardl') !== -1 || cls.indexOf('cardr') !== -1) {
        var w = Number(target.offsetWidth);
        var h = Number(target.offsetHeight);
        top -= (h - w) / 2;
        left += (h - w) / 2;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target.style, { position: 'fixed', left: left + 'px', top: top + 'px' });
    },
    discard_leave: function discard_leave(e) {
      var target = e.target.parentNode;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target.style, { position: 'relative', left: 0 + 'px', top: 0 + 'px' });
    },

    dragscroll: function dragscroll(e) {
      var el = e.currentTarget.parentElement;
      var disX = e.clientX;

      var disY = e.clientY;
      var originalScrollLeft = el.scrollLeft;
      var originalScrollTop = el.scrollTop;
      var originalScrollBehavior = el.style["scroll-behavior"];
      var originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
      document.onmousemove = function (e) {
        e.preventDefault();
        var distanceX = e.clientX - disX;
        var distanceY = e.clientY - disY;
        el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY);

        el.style["pointer-events"] = "none";
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        el.style["scroll-behavior"] = originalScrollBehavior;
        el.style["pointer-events"] = originalPointerEvents;
      };
    },
    dragscrollTouchStart: function dragscrollTouchStart(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      that.touch.disX = touch.clientX;

      that.touch.disY = touch.clientY;
      that.touch.originalScrollLeft = el.scrollLeft;
      that.touch.originalScrollTop = el.scrollTop;
      that.touch.originalScrollBehavior = el.style["scroll-behavior"];
      that.touch.originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
    },
    dragscrollTouchMove: function dragscrollTouchMove(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      var distanceX = touch.clientX - that.touch.disX;
      var distanceY = touch.clientY - that.touch.disY;
      el.scrollTo(that.touch.originalScrollLeft - distanceX, that.touch.originalScrollTop - distanceY);

      el.style["pointer-events"] = "none";
    },
    dragscrollTouchEnd: function dragscrollTouchEnd(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      document.ontouchmove = null;
      document.ontouchend = null;
      el.style["scroll-behavior"] = that.touch.originalScrollBehavior;
      el.style["pointer-events"] = that.touch.originalPointerEvents;
    },

    getRoomDetail: function getRoomDetail() {
      var that = this,
          roomId = that.roomId;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
        if (res) {
          if (res.code == 200 && res.result) {
            that.info = {
              homeowner: res.result.homeownerId,
              roomName: res.result.roomName,
              homeownerName: res.result.homeownerName,
              startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
              theme: res.result.theme,
              isCopy: res.result.isCopy == 1 ? "あり" : "なし",
              isPublic: res.result.isPublic,
              peopleNumber: res.result.peopleNumber,
              url: res.result.url
            };
            that.userTimes = res.result.turnTime;
            that.countsNumber = res.result.turnTime;
            that.gemePeople = res.result.peopleNumber;
            var pb = res.result.isPublic == 1 ? "公開" : "非公開";
            var copyInfo = res.result.homeownerName + "さんからの招待です。\n \n 以下から参加できます。\n URL: " + res.result.url + " \n \n パスワード：" + res.result.password + " \n \n ・ゲーム情報 \n ホスト名：" + res.result.homeownerName + "\n ルーム名：" + res.result.roomName + "\n 開始時刻：" + res.result.startTime + "\n \n ・ゲーム設定" + "\n 主题：" + res.result.theme + "\n 人数：" + res.result.peopleNumber + "\n 手札公開：" + pb + "\n 复制功能：" + res.result.isCopy;
            that.copyInfo = copyInfo;

            if (that.userId == res.result.homeownerId) that.isHomewer = true;

            var code = res.result.url;

            that.giveLocation(code, that.userEmail);
          }
        }
      });
    },

    getUserInfo: function getUserInfo() {
      var that = this,
          token = localStorage.getItem("Authorization");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
        console.log("userinfo", res.result);
        if (res) {
          that.userInfo = res.result;
        }
      });
    },

    doTimeOut: function doTimeOut() {
      var that = this;
      that.dialogPauseVisiblePre = true;
    },

    doPause: function doPause() {
      var that = this;
      that.dialogPauseVisiblePre = false;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    noDoTimeOut: function noDoTimeOut() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.dialogFinishVisible = true;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    doSelfSkip: function doSelfSkip() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      that.dialogSkipVisiblePre = true;
    },

    doPass: function doPass() {
      var that = this;
      that.dialogSkipVisiblePre = false;
      var arr = [];
      var syc = {};
      var temp = [];
      var ids = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      syc.temp = temp;
      syc.countdown = that.userTimes;
      syc.gameTime = that.gameTimes;
      syc.pk = that.cards;
      syc.users2 = that.users2;
      arr.push(syc);
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: that.userId,
        roomId: that.roomId,
        username: that.userEmail,
        userIds: ids,
        customize: arr,
        url: that.info.url
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    doPlay: function doPlay() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.play = true;
    },

    doSet: function doSet() {
      this.dialogSettingVisible = true;
    },

    toFinish: function toFinish() {
      this.dialogFinishVisible = true;
    },

    doFinish: function doFinish() {
      var that = this;
      console.log("usertime", that.userTimes);
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 8,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp),
        roomId: that.roomId,
        turnTime: that.gameTimes.minute * 60 + that.gameTimes.second
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["g" /* gamesOperate */])(data).then(function (res) {
        if (res && res.code == 200) {
          var result = {
            minute: that.gameTimes.minute,
            second: that.gameTimes.second
          };
          var users = [];
          if (that.user1.id) users.push(that.user1);
          if (that.user2.id) users.push(that.user2);
          if (that.user3.id) users.push(that.user3);
          if (that.user4.id) users.push(that.user4);
          if (that.user5.id) users.push(that.user5);
          if (that.user6.id) users.push(that.user6);
          result.users = users;
        }
      });
    },

    toGame: function toGame() {
      this.dialogFinishVisible = false;
      this.dialogSettingVisible = false;
      this.reStart();
    },

    toSkip: function toSkip() {
      this.dialogSkipVisible = true;
      this.dialogSettingVisible = false;
    },

    checkUser: function checkUser(item, index, checked) {
      var that = this;
      if (checked) {
        that.users2[index].checked = false;
      } else {
        that.users2[index].checked = true;
      }
    },
    doSkip: function doSkip() {
      var that = this;
      var ids = [];
      var names = [];
      var cur = "";
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          console.log(item);
          ids.push(item.id);
          names.push(item.username);
        }
        if (item.sort == that.playUser) {
          console.log(item);
          cur = item.id;
        }
      });
      var data = {
        operateType: 6,
        url: that.info.url,
        userId: cur,
        username: names[0],
        userIds: ids,
        usernames: names,
        currentUserId: cur
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
      that.dialogSkipVisible = false;
    },

    cancelSkip: function cancelSkip(name, id, location) {
      var that = this;
      var s = [];
      var n = [];
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      s.push(id);
      n.push(name);
      var data = {
        operateType: 7,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        userIds: s,
        usernames: n
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    countDown: function countDown() {
      var that = this,
          times = that.userTimes;
      that.timer = setInterval(function () {
        that.userTimes--;
      }, 1000);
    },

    goTimes: function goTimes() {
      var that = this;
      that.timer2 = setInterval(function () {
        that.gameTimes.second++;
        if (that.gameTimes.second == 60) {
          that.gameTimes.second = 0;
          that.gameTimes.minute++;
        }
        that.gameTimes.str = that.$options.methods.toDub(that.gameTimes.minute) + ":" + that.$options.methods.toDub(that.gameTimes.second);
      }, 1000);
    },

    toDub: function toDub(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    }
  })
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_global_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(52);












/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isUrl: "https",
      loading: false,
      tags: this.GLOBAL.tags,
      mode: "play",
      imgUrl: "://online.engagement-card.com/img/",
      cardsBack: __webpack_require__(123),
      scrollWidth: "900px",
      UID: "",

      userId: "",
      userEmail: "",
      userName: "",
      allCards: [],
      cards: [],
      cardsNum: 89,
      isfinish: 0,
      lastDiscardNum: 0,
      touch: {
        disX: 0,
        disY: 0,
        originalScrollLeft: 0,
        originalScrollTop: 0,
        originalScrollBehavior: '',
        originalPointerEvents: ''
      },

      users: [],

      users2: [],

      roomId: "",
      play: true,
      isHomewer: false,
      info: {
        homeowner: "",
        roomName: "",
        homeownerName: "",
        startTime: "",
        theme: "",
        isCopy: true,
        isPublic: false,
        peopleNumber: 4,
        url: ""
      },

      userInfo: {},

      user1: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user2: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user3: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user4: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user5: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user6: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },

      userCards: [],

      extracting: false,
      extractCardInfo: {},
      discardCardInfo: {},

      copiedcard: {},

      playUser: 1,
      gemePeople: 0,

      dialogSettingVisible: false,
      dialogFinishVisible: false,
      dialogSkipVisible: false,
      dialogPauseVisible: false,
      dialogSkipVisiblePre: false,
      dialogPauseVisiblePre: false,

      userTimes: 0,
      totalPerson: 0,
      countsNumber: 0,
      gameTimes: {
        str: "00:00",
        hour: 0,
        minute: 0,
        second: 0,
        ms: 0
      },
      watchCount: 0 };
  },

  watch: {
    user1: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        var that = this;

        setTimeout(function () {
          if (val.hasOwnProperty("discard")) {
            var el = that.$refs.location1,
                discardCount = val.discard.length,
                clientWidth = 0;
            if (discardCount > 7) {
              clientWidth = (el.children[0].clientWidth + 25) * discardCount;
              el.style["width"] = clientWidth + "px";
            }
          }
        }, 1500);
      }
    },
    user3: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        if (val.hasOwnProperty("discard")) {
          var el = this.$refs.location3,
              discardCount = val.discard.length,
              clientWidth = 0;
          if (discardCount > 7) {
            clientWidth = (el.children[0].clientWidth + 25) * discardCount;
            el.style["width"] = clientWidth + "px";
          }
        }
      }
    },
    users2: {
      immediate: true,

      deep: true,
      handler: function handler(val) {}
    },
    cards: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        console.log("监听卡牌", val);
      }
    }
  },
  components: {},
  created: function created() {
    this.updateFooter(false);
    this.roomId = this.$route.query.roomId;
    this.userId = localStorage.getItem("homeowner");
    this.userEmail = localStorage.getItem("userEmail");
    this.getRoomDetail();
  },
  mounted: function mounted() {
    this.users = JSON.parse(localStorage.getItem("room_" + this.roomId));

    this.getUserInfo();
    this.goTimes();
    this.countDown();
    window.addEventListener("onmessageWS", this.getsocketData);
    if (document.getElementById('app')) {
      document.getElementById('app').style.overflow = 'hidden';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapMutations */])(["updateFooter"]), {
    goPage: function goPage(page) {
      this.$router.push(page);
    },

    createSocket: function createSocket(code, userEmail) {
      var that = this;
      var wsUrl = "";
      var ishttps = "https:" == document.location.protocol ? true : false;

      if (ishttps) wsUrl = "wss://" + __WEBPACK_IMPORTED_MODULE_8__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;else wsUrl = "ws://" + __WEBPACK_IMPORTED_MODULE_8__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["a" /* createSocket */])(wsUrl);
    },
    csh: function csh() {
      var that = this;
      that.discardCardInfo = {};
      that.copiedcard = {};
      for (var i = 0; i < that.user1.cards.length; i++) {
        that.user1.cards[i].checked = false;
      }
      for (var _i = 0; _i < that.user1.discard.length; _i++) {
        that.user1.discard[_i].checked = false;
      }
      for (var _i2 = 0; _i2 < that.user2.cards.length; _i2++) {
        that.user2.cards[_i2].checked = false;
      }
      for (var _i3 = 0; _i3 < that.user2.discard.length; _i3++) {
        that.user2.discard[_i3].checked = false;
      }
      for (var _i4 = 0; _i4 < that.user3.cards.length; _i4++) {
        that.user3.cards[_i4].checked = false;
      }
      for (var _i5 = 0; _i5 < that.user3.discard.length; _i5++) {
        that.user3.discard[_i5].checked = false;
      }
      for (var _i6 = 0; _i6 < that.user4.cards.length; _i6++) {
        that.user4.cards[_i6].checked = false;
      }
      for (var _i7 = 0; _i7 < that.user4.discard.length; _i7++) {
        that.user4.discard[_i7].checked = false;
      }
      for (var _i8 = 0; _i8 < that.user5.cards.length; _i8++) {
        that.user5.cards[_i8].checked = false;
      }
      for (var _i9 = 0; _i9 < that.user5.discard.length; _i9++) {
        that.user5.discard[_i9].checked = false;
      }
      for (var _i10 = 0; _i10 < that.user6.cards.length; _i10++) {
        that.user6.cards[_i10].checked = false;
      }
      for (var _i11 = 0; _i11 < that.user6.discard.length; _i11++) {
        that.user6.discard[_i11].checked = false;
      }
    },
    getSame: function getSame() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["d" /* getSame */])(that.roomId).then(function (res) {
        console.log("same", res);
        if (res.result) {
          if (res.result.customize) {
            var samedata = JSON.parse(res.result.customize);
            var re = samedata[0];
            console.log("re", re);

            setTimeout(function () {
              for (var i = 0; i < re.temp.length; i++) {
                if (that.user1.sort == re.temp[i].sort) {
                  that.user1 = re.temp[i];
                }
                if (that.user2.sort == re.temp[i].sort) {
                  that.user2 = re.temp[i];
                }
                if (that.user3.sort == re.temp[i].sort) {
                  that.user3 = re.temp[i];
                }
                if (that.user4.sort == re.temp[i].sort) {
                  that.user4 = re.temp[i];
                }
              }
              that.cards = re.pk;
              that.userTimes = re.countdown;
              that.gameTimes = re.gameTime;
              that.playUser = re.usersort;
            }, 1000);
          }
        }
      });
    },

    discard_hover: function discard_hover(e) {
      var target = e.target.parentNode;
      var viewportOffset = target.getBoundingClientRect();
      var parent_viewport = target.parentNode.getBoundingClientRect();
      if (target.style.position === 'fixed') {
        return;
      }
      var top = parent_viewport.top;
      var left = parent_viewport.left;
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(target.style, { position: 'fixed', left: left + 'px', top: top + 'px' });
    },
    discard_leave: function discard_leave(e) {
      var target = e.target.parentNode;
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(target.style, { position: 'relative', left: 0 + 'px', top: 0 + 'px' });
    },
    getsocketData: function getsocketData(e) {
      var that = this;
      if (e.detail.data == "发生连接错误") return false;
      var data = JSON.parse(e.detail.data),
          newUser = {},
          isNew = true;
      if (data.onlineNumber > 0) {
        that.totalPerson = data.onlineNumber;
        that.getSame();
      }
      console.log(data.operateMsg);
      if (data.operateMsg == "从卡堆抽牌") {
        that.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            that.extractCardInfo = {
              index: index,
              id: data.number,
              url: item.url
            };
            that.extracting = true;
            return true;
          }
        });
      }
      if (data.operateMsg == "从弃卡堆里抽牌") {
        var newCard = {},
            location = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            newCard = card;
          }
        });

        that.user1.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 1;
            newCard.index = index;
          }
        });
        that.user2.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 2;
            newCard.index = index;
          }
        });
        that.user3.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 3;
            newCard.index = index;
          }
        });
        that.user4.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 4;
            newCard.index = index;
          }
        });

        that.discardCardInfo = newCard;
      }
      if (data.operateMsg == "替换手牌") {
        that.users2.forEach(function (item, index) {
          console.log(item);
          console.log(that.users2);
          console.log("data.userId", data.userId);
          console.log("item.userId", item.id);
          if (data.userId == item.id) {
            var _location = item.location,
                userCards = [];
            switch (_location) {
              case 1:
                userCards = that.user1.cards;
                break;
              case 2:
                userCards = that.user2.cards;
                break;
              case 3:
                userCards = that.user3.cards;
                break;
              case 4:
                userCards = that.user4.cards;
                break;
              case 5:
                userCards = that.user5.cards;
                break;
              case 6:
                userCards = that.user6.cards;
                break;
            }
            if (that.extractCardInfo.id) {
              var _newCard = that.extractCardInfo,
                  oldCard = {};
              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(oldCard, _location, that);
                  }
                  that.cards.splice(_newCard.index, 1);
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            } else if (that.discardCardInfo.id) {
              var _newCard2 = that.discardCardInfo,
                  _oldCard = {};

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard2;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard2;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard2;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard2;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard2;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard2;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(_oldCard, _newCard2.location, that);
                  }

                  that.$options.methods.delDiscardCard(_newCard2, _newCard2.location, that);
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            } else if (that.copiedcard.id) {
              var _newCard3 = that.copiedcard,
                  _oldCard2 = {};

              console.log("新手牌信息", _newCard3);


              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard2 = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard3;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard3;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard3;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard3;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard3;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard3;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(_oldCard2, _newCard3.location, that);
                  }

                  that.copiedcard = {};
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            }
          }
        });
      }
      if (data.operateMsg == "弃牌") {
        console.log("已经弃牌");
        if (that.extractCardInfo.id) {
          var _newCard4 = that.extractCardInfo;
          _newCard4.checked = false;
          console.log(that.users2);
          that.users2.forEach(function (item, index) {
            var location = item.location;
            if (item.id == data.userId) {
              console.log(item.id, data.userId);
              that.cards.splice(_newCard4.index, 1);
              console.log("newCard", _newCard4);
              console.log("discard", that.user1.discard);
              console.log(that.user1.discard.indexOf(_newCard4));
              switch (location) {
                case 1:
                  if (that.user1.discard.indexOf(_newCard4) == -1) {
                    that.user1.discard.splice(0, 0, _newCard4);
                    that.user1.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user1.discard)));
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(_newCard4) == -1) {
                    that.user2.discard.splice(0, 0, _newCard4);
                    that.user2.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user2.discard)));
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(_newCard4) == -1) {
                    that.user3.discard.splice(0, 0, _newCard4);
                    that.user3.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user3.discard)));
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(_newCard4) == -1) {
                    that.user4.discard.splice(0, 0, _newCard4);
                    that.user4.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user4.discard)));
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(_newCard4) == -1) {
                    that.user5.discard.splice(0, 0, _newCard4);
                    that.user5.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(_newCard4) == -1) {
                    that.user6.discard.splice(0, 0, _newCard4);
                    that.user6.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
              }
            }
          });
        } else if (that.discardCardInfo.id) {
          var _newCard5 = that.discardCardInfo;
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location2 = item.location,
                  userCards = [];

              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location2) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                    that.user1.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user1.discard)));
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                    that.user2.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user2.discard)));
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                    that.user3.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user3.discard)));
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                    that.user4.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user4.discard)));
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                    that.user5.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                    that.user6.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user6.discard)));
                  }
                  break;
              }
            }
          });
        } else {
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location3 = item.location;
              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location3) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                    that.user1.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user1.discard)));
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                    that.user2.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user2.discard)));
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                    that.user3.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user3.discard)));
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                    that.user4.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user4.discard)));
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                    that.user5.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user5.discard)));
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                    that.user6.discard = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(that.user6.discard)));
                  }
                  break;
              }
            }
          });
        }
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.lastDiscardNum = data.foldNumber;
      }
      if (data.operateMsg == "下一用户操作") {
        var num = 1;
        that.csh();
        if (that.isHomewer == true && that.cards.length == 0 && that.isfinish == 0) {
          that.isfinish = 1;
          that.noDoTimeOut();
        }
        that.UID = data.userId;

        var ids = [];
        that.userTimes = that.countsNumber;
        that.$options.methods.countDown();
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.users2.forEach(function (item, index) {
          if (item.id == data.userId) {
            that.playUser = item.sort;
          }
          if (item.checked == true) {
            ids.push(item.id);
          }
        });
        var arr = [];
        var syc = {};
        var temp = [];
        temp.push(that.user1);
        temp.push(that.user2);
        temp.push(that.user3);
        temp.push(that.user4);
        syc.temp = temp;
        syc.countdown = that.userTimes;
        syc.gameTime = that.gameTimes;
        syc.pk = that.cards;
        syc.users2 = that.users2;
        syc.usersort = that.playUser;
        syc.UId = that.UID;
        arr.push(syc);
        var next = {
          operateType: 13,
          userId: that.userId,
          roomId: that.roomId,
          username: that.userEmail,
          userIds: ids,
          customize: arr,
          url: that.info.url
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(next);
      }
      if (data.operateMsg == "游戏暂停") {
        that.play = false;
        that.dialogPauseVisible = true;
        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "继续游戏") {
        that.play = true;
        that.dialogPauseVisible = false;
        that.countDown();
        that.goTimes();
      }

      if (data.operateMsg == "等待房主操作") {
        that.play = false;

        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "跳过用户") {
        console.log("users2", that.users2);
        that.users2.forEach(function (item, index) {
          console.log("item", item);
          console.log("sdata", data);
          if (data.userIds.indexOf(item.id) != -1) {
            item.checked = true;
            item.isSkip = true;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = true;
                break;
              case 2:
                that.user2.isSkip = true;
                break;
              case 3:
                that.user3.isSkip = true;
                break;
              case 4:
                that.user4.isSkip = true;
                break;
              case 5:
                that.user5.isSkip = true;
                break;
              case 6:
                that.user6.isSkip = true;
                break;
            }
          }
        });
        var _arr = [];
        var _syc = {};
        var _temp = [];
        _temp.push(that.user1);
        _temp.push(that.user2);
        _temp.push(that.user3);
        _temp.push(that.user4);
        _syc.temp = _temp;
        _syc.countdown = that.userTimes;
        _syc.gameTime = that.gameTimes;
        _syc.pk = that.cards;
        _syc.users2 = that.users2;
        _arr.push(_syc);
        var _ids = [];
        that.users2.forEach(function (item, index) {
          if (item.checked == true) {
            _ids.push(item.id);
          }
        });
        console.log("saaaaaa");
        var _next = {
          operateType: 12,
          userId: that.userId,
          roomId: that.roomId,
          username: that.userEmail,
          userIds: _ids,
          customize: _arr,
          url: that.info.url
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(_next);
      }

      if (data.operateMsg == "解除跳过用户") {
        that.users2.forEach(function (item, index) {
          if (data.userIds.indexOf(item.id) != -1) {
            item.checked = false;
            item.isSkip = false;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = false;
                break;
              case 2:
                that.user2.isSkip = false;
                break;
              case 3:
                that.user3.isSkip = false;
                break;
              case 4:
                that.user4.isSkip = false;
                break;
              case 5:
                that.user5.isSkip = false;
                break;
              case 6:
                that.user6.isSkip = false;
                break;
            }
          }
        });
      }

      if (data.operateMsg == "复制其他用户的牌") {
        var _newCard6 = {},
            _location4 = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            _newCard6 = card;
          }
        });

        that.user1.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 1;
            _newCard6.index = index;
          }
        });
        that.user2.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 2;
            _newCard6.index = index;
          }
        });
        that.user3.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 3;
            _newCard6.index = index;
          }
        });
        that.user4.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 4;
            _newCard6.index = index;
          }
        });

        that.copiedcard = _newCard6;
      }

      if (data.operateMsg == "游戏结束") {
        var result = {
          minute: that.gameTimes.minute,
          second: that.gameTimes.second
        };
        var users = [];
        localStorage.removeItem("hasStart");
        if (that.user1.id) users.push(that.user1);
        if (that.user2.id) users.push(that.user2);
        if (that.user3.id) users.push(that.user3);
        if (that.user4.id) users.push(that.user4);
        if (that.user5.id) users.push(that.user5);
        if (that.user6.id) users.push(that.user6);
        result.users = users;
        var addResultParamList = [];
        if (that.user1.id) {
          var _temp2 = [];
          var obj = {};
          for (var i = 0; i < that.user1.cards.length; i++) {
            if (that.user1.cards[i].id < 10) {
              _temp2.push("0" + that.user1.cards[i].id);
            } else {
              _temp2.push(that.user1.cards[i].id);
            }
          }
          obj.userCard = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_temp2);
          obj.userName = that.user1.nickname;
          obj.userRole = that.user1.tag == "房主" ? 1 : 0;
          obj.roomId = that.roomId;
          addResultParamList.push(obj);
        }
        if (that.user2.id) {
          var _temp3 = [];
          var _obj = {};
          for (var _i12 = 0; _i12 < that.user2.cards.length; _i12++) {
            if (that.user2.cards[_i12].id < 10) {
              _temp3.push("0" + that.user2.cards[_i12].id);
            } else {
              _temp3.push(that.user2.cards[_i12].id);
            }
          }
          _obj.userCard = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_temp3);
          _obj.userName = that.user2.nickname;
          _obj.userRole = that.user2.tag == "房主" ? 1 : 0;
          _obj.roomId = that.roomId;
          addResultParamList.push(_obj);
        }
        if (that.user3.id) {
          var _temp4 = [];
          var _obj2 = {};
          for (var _i13 = 0; _i13 < that.user3.cards.length; _i13++) {
            if (that.user3.cards[_i13].id < 10) {
              _temp4.push("0" + that.user3.cards[_i13].id);
            } else {
              _temp4.push(that.user3.cards[_i13].id);
            }
          }
          _obj2.userCard = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_temp4);
          _obj2.userName = that.user3.nickname;
          _obj2.userRole = that.user3.tag == "房主" ? 1 : 0;
          _obj2.roomId = that.roomId;
          addResultParamList.push(_obj2);
        }
        if (that.user4.id) {
          var _temp5 = [];
          var _obj3 = {};
          for (var _i14 = 0; _i14 < that.user4.cards.length; _i14++) {
            if (that.user4.cards[_i14].id < 10) {
              _temp5.push("0" + that.user4.cards[_i14].id);
            } else {
              _temp5.push(that.user4.cards[_i14].id);
            }
          }
          _obj3.userCard = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_temp5);
          _obj3.userName = that.user4.nickname;
          _obj3.userRole = that.user4.tag == "房主" ? 1 : 0;
          _obj3.roomId = that.roomId;
          addResultParamList.push(_obj3);
        }
        if (that.user5.id) {
          var _temp6 = [];
          var _obj4 = {};
          for (var _i15 = 0; _i15 < that.user5.cards.length; _i15++) {
            if (that.user5.cards[_i15].id < 10) {
              _temp6.push("0" + that.user5.cards[_i15].id);
            } else {
              _temp6.push(that.user5.cards[_i15].id);
            }
          }
          _obj4.userCard = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_temp6);
          _obj4.userName = that.user5.nickname;
          _obj4.userRole = that.user5.tag == "房主" ? 1 : 0;
          _obj4.roomId = that.roomId;
          addResultParamList.push(_obj4);
        }
        if (that.user6.id) {
          var _temp7 = [];
          var _obj5 = {};
          for (var _i16 = 0; _i16 < that.user6.cards.length; _i16++) {
            if (that.user6.cards[_i16].id < 10) {
              _temp7.push("0" + that.user6.cards[_i16].id);
            } else {
              _temp7.push(that.user6.cards[_i16].id);
            }
          }
          _obj5.userCard = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_temp7);
          _obj5.userName = that.user6.nickname;
          _obj5.userRole = that.user6.tag == "房主" ? 1 : 0;
          _obj5.roomId = that.roomId;
          addResultParamList.push(_obj5);
        }
        console.log("result", addResultParamList);
        localStorage.setItem("room_result_" + that.roomId, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(result));
        localStorage.setItem("addResultParamList", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(addResultParamList));
        that.$router.push({
          path: "/game/result",
          query: {
            roomId: that.roomId
          }
        });
      }
    },

    giveLocation: function giveLocation(code, email) {
      var that = this,
          giveNum = 1,
          isPlayer = false,
          players = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";

      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }
      var playerIds = [];
      var playerIdsBox = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(userCards);

      playerIdsBox.forEach(function (key, index) {
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        playerIds.push(key);
      });

      that.UID = playerIds[0];
      var playersCount = playerIds.length,
          num = 1;
      playerIds.forEach(function (key, index) {
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["e" /* getUserInfoById */])(key).then(function (res) {
          if (res.code == 200 && res.result) {
            var sort = index + 1,
                tag = that.tags[index],
                isHomewer = false;
            if (key == that.info.homeowner) {
              tag = "房主";
              isHomewer = true;
            }
            var userInfo = {
              email: res.result.email,
              id: res.result.id,
              realname: res.result.realname,
              nickname: res.result.nickname,
              username: res.result.username,
              sort: index + 1,
              tag: tag,
              isHomewer: isHomewer,
              isSkip: false,
              checked: false
            };
            that.users2.push(userInfo);
            players.push(userInfo);

            if (num == playersCount) {
              players.forEach(function (item, index) {
                if (that.userId == item.id) {
                  that.userInfo = item;
                  that.userInfo.isPlayer = isPlayer = true;
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                  players.splice(index, 1);
                }
              });
              if (!isPlayer) {
                players.forEach(function (item, index) {
                  if (1 == item.sort) {
                    giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                    players.splice(index, 1);
                  }
                });
                that.mode = "watch";
              }
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user2, 2, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user3, 3, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user4, 4, giveNum, that);
                  players.splice(index, 1);
                }
              });


              var cards = [],
                  cardsNum = that.cardsNum;
              for (var i = 1; i <= cardsNum; i++) {
                var url = "",
                    style = "";
                if (i < 10) {
                  url = that.isUrl + that.imgUrl + "card_0" + i + ".png";
                } else {
                  url = that.isUrl + that.imgUrl + "card_" + i + ".png";
                }
                var z = (that.cardsNum - i) / 8;

                style = "transform: translate3d(" + z + "px, " + z + "px, " + z + "px);";
                var card = {
                  id: i,
                  url: url,
                  style: style
                };

                cards[i] = card;
              }
              that.allCards = cards;

              that.user1.cards = [];
              that.user2.cards = [];
              that.user3.cards = [];
              that.user4.cards = [];

              var _userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
              if (!_userCards) {
                that.$message({
                  message: "カード情報に誤りがあるため、ゲームを再起動してください",
                  type: "error"
                });
              }

              var newCards = [],
                  noCards = [];
              playerIds.forEach(function (key) {
                var cardLists = _userCards[key],
                    userCard = [];
                cardLists.forEach(function (item, index) {
                  noCards.push(item);
                });

                cards.forEach(function (item, index) {
                  if (cardLists.indexOf(item.id) >= 0) {
                    userCard.push(item);
                  }
                });
                if (key == that.user1.id) that.user1.cards = userCard;
                if (key == that.user2.id) that.user2.cards = userCard;
                if (key == that.user3.id) that.user3.cards = userCard;
                if (key == that.user4.id) that.user4.cards = userCard;
                if (key == that.user5.id) that.user5.cards = userCard;
                if (key == that.user6.id) that.user6.cards = userCard;
              });

              cards.forEach(function (item, index) {
                if (noCards.indexOf(item.id) < 0) {
                  newCards.push(item);
                }
              });

              that.cards = newCards;
            }
            num++;
          }
        });
      });
      that.$options.methods.createSocket(code, email);
    },

    giveLocationData: function giveLocationData(item, index, obj, location, giveNum, e) {
      if (item.sort < e.info.peopleNumber) {
        giveNum = item.sort + 1;
      } else {
        giveNum = 1;
      }
      obj.email = item.email;
      obj.id = item.id;
      obj.username = item.username;
      obj.nickname = item.nickname;
      obj.realname = item.realname;
      obj.lineStatus = item.lineStatus;
      obj.sort = item.sort;
      obj.tag = item.tag;
      obj.location = location;
      obj.isSkip = item.isSkip;
      e.users2.forEach(function (item2, index2) {
        if (item2.id == item.id) {
          e.users2[index2].location = location;
        }
      });
      return giveNum;
    },

    getCards: function getCards() {
      var cards = [],
          that = this,
          cardsNum = that.cardsNum;
      for (var i = 1; i <= cardsNum; i++) {
        var url = "";
        if (i < 10) {
          url = that.imgUrl + "card_0" + i + ".png";
        } else {
          url = that.imgUrl + "card_" + i + ".png";
        }
        var card = {
          id: i,
          url: url
        };

        cards[i] = card;
      }

      that.user1.cards = [];
      that.user2.cards = [];
      that.user3.cards = [];
      that.user4.cards = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }

      var newCards = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(userCards).forEach(function (key) {
        var cardLists = userCards[key],
            userCard = [];
        cards.forEach(function (item, index) {
          if (cardLists.indexOf(item.id) >= 0) {
            userCard.push(item);
          } else {
            newCards.push(item);
          }
        });
        if (key == that.user1.id) that.user1.cards = userCard;
        if (key == that.user2.id) that.user2.cards = userCard;
        if (key == that.user3.id) that.user3.cards = userCard;
        if (key == that.user4.id) that.user4.cards = userCard;
        if (key == that.user5.id) that.user5.cards = userCard;
        if (key == that.user6.id) that.user6.cards = userCard;
      });

      newCards.sort(function () {
        return Math.random() - 0.5;
      });
      that.cards = newCards;
    },

    shuffle: function shuffle() {
      var that = this;
      var cards = that.cards;

      var cardBoxObj = that.$refs.gamecardslists,
          cardLists = that.$refs.gamecardslists.children;
      cards.sort(function () {
        return Math.random() - 0.5;
      });
      cards.forEach(function (item, index) {
        var cardObj = cardLists[index],
            z = (that.cardsNum - index) / 8;

        cardObj.style["transform"] = "translate3d(" + z + "px, " + z + "px, -" + z + "px)";
      });
    },
    translate: function translate(a, b, c) {
      c = c || 0;
      if (has3d) {
        return "translate3d(" + a + ", " + b + ", " + c + ")";
      } else {
        return "translate(" + a + ", " + b + ")";
      }
    },

    extractCard: function extractCard(item, index) {
      var that = this;
      that.csh();

      if (that.mode == "watch") {
        return false;
      }
      if (that.extracting == true) {
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      that.discardCardInfo = {};

      var noCreatNum = [];
      that.cards.forEach(function (card, id) {
        noCreatNum.push(card.id);
      });

      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        noCreatNum: noCreatNum,

        operateType: 1,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    extractCardFromDiscards: function extractCardFromDiscards(item, index, location, event, discard, username) {
      var that = this;
      that.discardCardInfo = {};
      if (that.mode == "watch") {
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        return false;
      }
      if (that.extracting == true) {
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
        return false;
      }
      var array = discard;
      for (var i = 0; i < array.length; i++) {
        if (i == index) {
          if (array[i].checked == false) {
            array[i].checked = true;
            that.discardCardInfo = {
              location: location,
              index: index,
              id: item.id,
              url: item.url
            };
          } else {
            array[i].checked = false;
            that.discardCardInfo = {};
          }
        } else {
          array[i].checked = false;
        }
      }

      if (username == "user1") {
        that.user1.discard = array;
      }

      var newCard = that.discardCardInfo;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        number: newCard.id,
        operateType: 3,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    changeOtherCard: function changeOtherCard(item, index, event, location) {
      var that = this;
      if (that.extracting == true) {
        return false;
      }
      if (that.info.isCopy == "あり") {
        var data = {
          number: item.id,
          operateType: 2,
          url: that.info.url,
          userId: that.userId,
          username: that.userEmail,
          roomId: that.roomId
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
      } else {}
    },

    changeSelfCard: function changeSelfCard(item, index, event, location) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        that.$message({
          message: "観戦中",
          type: "error"
        });
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");

        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      var newCard = {},
          oldCard = that.user1.cards[index],
          discardType = 0;
      if (that.extractCardInfo.id) {
        discardType = 1;
      } else if (that.discardCardInfo.id) {
        discardType = 2;
      } else if (that.copiedcard.id) {
        discardType = 3;
      }
      if (discardType == 0) {
        console.log("操作を禁止しています");

        return false;
      }

      if (discardType == 3) {
        if (location == 1) {
          newCard = that.copiedcard;
          var temp = [];
          temp.push(that.user1);
          temp.push(that.user2);
          temp.push(that.user3);
          temp.push(that.user4);
          var data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
          console.log("替换手牌3");
        }
      } else {
        if (location == 1) {
          newCard = that.extractCardInfo;
          var _temp8 = [];
          _temp8.push(that.user1);
          _temp8.push(that.user2);
          _temp8.push(that.user3);
          _temp8.push(that.user4);
          var _data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          console.log("替换手牌1");
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(_data);
        }
      }
    },

    discardCard: function discardCard(location, event) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == false) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      var newCard = that.extractCardInfo;
      that.$options.methods.addDiscardCard(newCard, location, that);
      if (that.cards.length == 0) {}
    },

    addDiscardCard: function addDiscardCard(card, location, e) {
      var that = this;

      var arr = [];
      var syc = {};
      var temp = [];
      temp.push(e.user1);
      temp.push(e.user2);
      temp.push(e.user3);
      temp.push(e.user4);
      syc.temp = temp;
      syc.countdown = e.userTimes;
      syc.gameTime = e.gameTimes;
      syc.pk = e.cards;
      syc.users2 = e.users2;
      arr.push(syc);
      var ids = [];
      e.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: e.userId,
        roomId: e.roomId,
        username: e.userEmail,
        userIds: ids,
        customize: arr,
        url: e.info.url
      };

      var data = {
        foldNumber: card.id,
        operateType: 4,
        url: e.info.url,
        userId: e.userId,
        username: e.userEmail,
        roomId: e.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
      console.log("发送弃牌请求");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    delDiscardCard: function delDiscardCard(card, location, e) {
      switch (location) {
        case 1:
          e.user1.discard.splice(card.index, 1);
          break;
        case 2:
          e.user2.discard.splice(card.index, 1);
          break;
        case 3:
          e.user3.discard.splice(card.index, 1);
          break;
        case 4:
          e.user4.discard.splice(card.index, 1);
          break;
        case 5:
          e.user5.discard.splice(card.index, 1);
          break;
        case 6:
          e.user6.discard.splice(card.index, 1);
          break;
      }
    },

    copyCard: function copyCard() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      if (that.extracting = true) {
        that.$message({
          message: "已抽牌，请选择替换手牌",
          type: "error"
        });
      }
    },
    reStart: function reStart() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 11,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    dragscroll: function dragscroll(e) {
      var el = e.currentTarget.parentElement;
      var disX = e.clientX;

      var disY = e.clientY;
      var originalScrollLeft = el.scrollLeft;
      var originalScrollTop = el.scrollTop;
      var originalScrollBehavior = el.style["scroll-behavior"];
      var originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
      document.onmousemove = function (e) {
        e.preventDefault();
        var distanceX = e.clientX - disX;
        var distanceY = e.clientY - disY;
        el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY);

        el.style["pointer-events"] = "none";
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        el.style["scroll-behavior"] = originalScrollBehavior;
        el.style["pointer-events"] = originalPointerEvents;
      };
    },
    dragscrollTouchStart: function dragscrollTouchStart(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      that.touch.disX = touch.clientX;

      that.touch.disY = touch.clientY;
      that.touch.originalScrollLeft = el.scrollLeft;
      that.touch.originalScrollTop = el.scrollTop;
      that.touch.originalScrollBehavior = el.style["scroll-behavior"];
      that.touch.originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
    },
    dragscrollTouchMove: function dragscrollTouchMove(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      var distanceX = touch.clientX - that.touch.disX;
      var distanceY = touch.clientY - that.touch.disY;
      el.scrollTo(that.touch.originalScrollLeft - distanceX, that.touch.originalScrollTop - distanceY);

      el.style["pointer-events"] = "none";
    },
    dragscrollTouchEnd: function dragscrollTouchEnd(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      document.ontouchmove = null;
      document.ontouchend = null;
      el.style["scroll-behavior"] = that.touch.originalScrollBehavior;
      el.style["pointer-events"] = that.touch.originalPointerEvents;
    },

    getRoomDetail: function getRoomDetail() {
      var that = this,
          roomId = that.roomId;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
        if (res) {
          if (res.code == 200 && res.result) {
            that.info = {
              homeowner: res.result.homeownerId,
              roomName: res.result.roomName,
              homeownerName: res.result.homeownerName,
              startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
              theme: res.result.theme,
              isCopy: res.result.isCopy == 1 ? "あり" : "なし",
              isPublic: res.result.isPublic,
              peopleNumber: res.result.peopleNumber,
              url: res.result.url
            };
            that.userTimes = res.result.turnTime;
            that.countsNumber = res.result.turnTime;
            that.gemePeople = res.result.peopleNumber;
            var copyInfo = res.result.homeownerName + "さんからの招待です。\n \n 以下から参加できます。\n URL: " + res.result.url + " \n \n パスワード：" + res.result.password + " \n \n ・ゲーム情報 \n ホスト名：" + res.result.homeownerName + "\n ルーム名：" + res.result.roomName + "\n 開始時刻：" + res.result.startTime + "\n \n ・ゲーム設定" + "\n 主题：" + res.result.theme + "\n 人数：" + res.result.peopleNumber + "\n 手札公開：" + res.result.isPublic + "\n 复制功能：" + res.result.isCopy;
            that.copyInfo = copyInfo;

            if (that.userId == res.result.homeownerId) that.isHomewer = true;

            var code = res.result.url;

            that.giveLocation(code, that.userEmail);
          }
        }
      });
    },

    getUserInfo: function getUserInfo() {
      var that = this,
          token = localStorage.getItem("Authorization");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
        if (res) {
          that.userInfo = res.result;
        }
      });
    },

    doTimeOut: function doTimeOut() {
      var that = this;
      that.dialogPauseVisiblePre = true;
    },

    doPause: function doPause() {
      var that = this;
      that.dialogPauseVisiblePre = false;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    noDoTimeOut: function noDoTimeOut() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.dialogFinishVisible = true;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    doSelfSkip: function doSelfSkip() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      that.dialogSkipVisiblePre = true;
    },

    doPass: function doPass() {
      var that = this;
      that.dialogSkipVisiblePre = false;
      var arr = [];
      var syc = {};
      var temp = [];
      var ids = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      syc.temp = temp;
      syc.countdown = that.userTimes;
      syc.gameTime = that.gameTimes;
      syc.pk = that.cards;
      syc.users2 = that.users2;
      arr.push(syc);
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: that.userId,
        roomId: that.roomId,
        username: that.userEmail,
        userIds: ids,
        customize: arr,
        url: that.info.url
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    doPlay: function doPlay() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.play = true;
    },

    doSet: function doSet() {
      this.dialogSettingVisible = true;
    },

    toFinish: function toFinish() {
      this.dialogFinishVisible = true;
    },

    doFinish: function doFinish() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 8,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(temp),
        roomId: that.roomId,
        turnTime: that.gameTimes.minute * 60 + that.gameTimes.second
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__api_api_js__["g" /* gamesOperate */])(data).then(function (res) {
        if (res && res.code == 200) {
          var result = {
            minute: that.gameTimes.minute,
            second: that.gameTimes.second
          };
          var users = [];
          if (that.user1.id) users.push(that.user1);
          if (that.user2.id) users.push(that.user2);
          if (that.user3.id) users.push(that.user3);
          if (that.user4.id) users.push(that.user4);
          if (that.user5.id) users.push(that.user5);
          if (that.user6.id) users.push(that.user6);
          result.users = users;
        }
      });
    },

    toGame: function toGame() {
      this.dialogFinishVisible = false;
      this.dialogSettingVisible = false;
      this.reStart();
    },

    toSkip: function toSkip() {
      this.dialogSkipVisible = true;
      this.dialogSettingVisible = false;
    },

    checkUser: function checkUser(item, index, checked) {
      var that = this;
      if (checked) {
        that.users2[index].checked = false;
      } else {
        that.users2[index].checked = true;
      }
    },

    doSkip: function doSkip() {
      var that = this;
      var ids = [];
      var names = [];
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          setTimeout(function () {
            var temp = [];
            temp.push(that.user1);
            temp.push(that.user2);
            temp.push(that.user3);
            temp.push(that.user4);
            ids.push(item.id);
            names.push(item.username);
            var data = {
              operateType: 6,
              url: that.info.url,
              userId: item.id,
              username: item.username,
              userIds: ids,
              usernames: names
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
          }, 1000);
        }
      });
      that.dialogSkipVisible = false;
    },

    cancelSkip: function cancelSkip(name, id, location) {
      var that = this;
      var s = [];
      var n = [];
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      s.push(id);
      n.push(name);
      var data = {
        operateType: 7,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        userIds: s,
        usernames: n
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    countDown: function countDown() {
      var that = this,
          times = that.userTimes;
      that.timer = setInterval(function () {
        that.userTimes--;
      }, 1000);
    },

    goTimes: function goTimes() {
      var that = this;
      that.timer2 = setInterval(function () {
        that.gameTimes.second++;
        if (that.gameTimes.second == 60) {
          that.gameTimes.second = 0;
          that.gameTimes.minute++;
        }
        that.gameTimes.str = that.$options.methods.toDub(that.gameTimes.minute) + ":" + that.$options.methods.toDub(that.gameTimes.second);
      }, 1000);
    },

    toDub: function toDub(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    }
  })
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_global_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(52);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isUrl: "https",
      loading: false,
      tags: this.GLOBAL.tags,
      mode: "play",
      imgUrl: "://online.engagement-card.com/img/",
      cardsBack: __webpack_require__(123),
      scrollWidth: "900px",
      UID: "",

      userId: "1505124724596801538",
      userEmail: "2856678408@qq.com",
      userName: "",
      allCards: [],
      cards: [],
      cardsNum: 89,
      isfinish: 0,
      lastDiscardNum: 0,
      touch: {
        disX: 0,
        disY: 0,
        originalScrollLeft: 0,
        originalScrollTop: 0,
        originalScrollBehavior: '',
        originalPointerEvents: ''
      },

      users: [],

      users2: [],

      roomId: "",
      play: true,
      isHomewer: false,
      info: {
        homeowner: "",
        roomName: "",
        homeownerName: "",
        startTime: "",
        theme: "",
        isCopy: true,
        isPublic: false,
        peopleNumber: 4,
        url: ""
      },

      userInfo: {},

      user1: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user2: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user3: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user4: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user5: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user6: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },

      userCards: [],

      extracting: false,
      extractCardInfo: {},
      discardCardInfo: {},

      copiedcard: {},

      playUser: 1,
      gemePeople: 0,

      dialogSettingVisible: false,
      dialogFinishVisible: false,
      dialogSkipVisible: false,
      dialogPauseVisible: false,
      dialogSkipVisiblePre: false,
      dialogPauseVisiblePre: false,

      userTimes: 0,
      totalPerson: 0,
      countsNumber: 0,
      gameTimes: {
        str: "00:00",
        hour: 0,
        minute: 0,
        second: 0,
        ms: 0
      },
      watchCount: 0 };
  },

  watch: {
    user1: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        if (val.hasOwnProperty("discard")) {
          var el = this.$refs.location1,
              discardCount = val.discard.length,
              clientWidth = 0;
          if (discardCount > 7) {
            clientWidth = (el.children[0].clientWidth + 25) * discardCount;
            el.style["width"] = clientWidth + "px";
          }
        }
      }
    },
    user3: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        if (val.hasOwnProperty("discard")) {
          var el = this.$refs.location3,
              discardCount = val.discard.length,
              clientWidth = 0;
          if (discardCount > 7) {
            clientWidth = (el.children[0].clientWidth + 25) * discardCount;
            el.style["width"] = clientWidth + "px";
          }
        }
      }
    },
    users2: {
      immediate: true,

      deep: true,
      handler: function handler(val) {}
    },
    cards: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        console.log("监听卡牌", val);
      }
    }
  },
  components: {},
  created: function created() {
    this.isUrl = this.GLOBAL.getHttps();
    this.updateFooter(false);
    this.roomId = this.$route.query.roomId;
    this.userId = localStorage.getItem("homeowner");
    this.userEmail = localStorage.getItem("userEmail");
    this.getRoomDetail();
  },
  mounted: function mounted() {
    this.users = JSON.parse(localStorage.getItem("room_" + this.roomId));

    this.getUserInfo();
    this.goTimes();
    this.countDown();
    window.addEventListener("onmessageWS", this.getsocketData);
    if (document.getElementById('app')) {
      document.getElementById('app').style.overflow = 'hidden';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapMutations */])(["updateFooter"]), {
    goPage: function goPage(page) {
      this.$router.push(page);
    },

    createSocket: function createSocket(code, userEmail) {
      var that = this;
      var wsUrl = "";
      var ishttps = "https:" == document.location.protocol ? true : false;

      if (ishttps) wsUrl = "wss://" + __WEBPACK_IMPORTED_MODULE_6__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;else wsUrl = "ws://" + __WEBPACK_IMPORTED_MODULE_6__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["a" /* createSocket */])(wsUrl);
    },
    csh: function csh() {
      var that = this;
      that.discardCardInfo = {};
      that.copiedcard = {};
      for (var i = 0; i < that.user1.cards.length; i++) {
        that.user1.cards[i].checked = false;
      }
      for (var _i = 0; _i < that.user1.discard.length; _i++) {
        that.user1.discard[_i].checked = false;
      }
      for (var _i2 = 0; _i2 < that.user2.cards.length; _i2++) {
        that.user2.cards[_i2].checked = false;
      }
      for (var _i3 = 0; _i3 < that.user2.discard.length; _i3++) {
        that.user2.discard[_i3].checked = false;
      }
      for (var _i4 = 0; _i4 < that.user3.cards.length; _i4++) {
        that.user3.cards[_i4].checked = false;
      }
      for (var _i5 = 0; _i5 < that.user3.discard.length; _i5++) {
        that.user3.discard[_i5].checked = false;
      }
      for (var _i6 = 0; _i6 < that.user4.cards.length; _i6++) {
        that.user4.cards[_i6].checked = false;
      }
      for (var _i7 = 0; _i7 < that.user4.discard.length; _i7++) {
        that.user4.discard[_i7].checked = false;
      }
      for (var _i8 = 0; _i8 < that.user5.cards.length; _i8++) {
        that.user5.cards[_i8].checked = false;
      }
      for (var _i9 = 0; _i9 < that.user5.discard.length; _i9++) {
        that.user5.discard[_i9].checked = false;
      }
      for (var _i10 = 0; _i10 < that.user6.cards.length; _i10++) {
        that.user6.cards[_i10].checked = false;
      }
      for (var _i11 = 0; _i11 < that.user6.discard.length; _i11++) {
        that.user6.discard[_i11].checked = false;
      }
    },
    getSame: function getSame() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["d" /* getSame */])(that.roomId).then(function (res) {
        console.log("same", res);
        if (res.result) {
          if (res.result.customize) {
            var samedata = JSON.parse(res.result.customize);
            console.log("re", res.result.customize);
            var re = samedata[0];

            setTimeout(function () {
              for (var i = 0; i < re.temp.length; i++) {
                if (that.user1.sort == re.temp[i].sort) {
                  that.user1 = re.temp[i];
                }
                if (that.user2.sort == re.temp[i].sort) {
                  that.user2 = re.temp[i];
                }
                if (that.user3.sort == re.temp[i].sort) {
                  that.user3 = re.temp[i];
                }
                if (that.user4.sort == re.temp[i].sort) {
                  that.user4 = re.temp[i];
                }
              }
              that.cards = re.pk;
              that.userTimes = re.countdown;
              that.gameTimes = re.gameTime;
              that.playUser = re.usersort;
              that.UID = re.UID;
            }, 1000);
          }
        }
      });
    },

    getsocketData: function getsocketData(e) {
      var that = this;
      if (e.detail.data == "发生连接错误") return false;
      var data = JSON.parse(e.detail.data),
          newUser = {},
          isNew = true;
      console.log('getsocketData: ', data);
      if (data.onlineNumber > 0) {
        that.totalPerson = data.onlineNumber;
        that.getSame();
      }
      if (data.operateMsg == "从卡堆抽牌") {
        that.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            that.extractCardInfo = {
              index: index,
              id: data.number,
              url: item.url
            };
            that.extracting = true;
            return true;
          }
        });
      }
      if (data.operateMsg == "从弃卡堆里抽牌") {
        var newCard = {},
            location = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            newCard = card;
          }
        });

        that.user1.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 1;
            newCard.index = index;
          }
        });
        that.user2.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 2;
            newCard.index = index;
          }
        });
        that.user3.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 3;
            newCard.index = index;
          }
        });
        that.user4.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 4;
            newCard.index = index;
          }
        });

        that.discardCardInfo = newCard;
      }
      if (data.operateMsg == "替换手牌") {
        console.log("收到替换手牌的推送");
        that.users2.forEach(function (item, index) {
          if (data.userId == item.id) {
            var _location = item.location,
                userCards = [];
            switch (_location) {
              case 1:
                userCards = that.user1.cards;
                break;
              case 2:
                userCards = that.user2.cards;
                break;
              case 3:
                userCards = that.user3.cards;
                break;
              case 4:
                userCards = that.user4.cards;
                break;
              case 5:
                userCards = that.user5.cards;
                break;
              case 6:
                userCards = that.user6.cards;
                break;
            }
            if (that.extractCardInfo.id) {
              var _newCard = that.extractCardInfo,
                  oldCard = {};
              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard;
                      break;
                  }
                  console.log("that.userInfo.sort", that.userInfo.sort);
                  console.log("that.playUser", that.playUser);
                  if (that.userInfo.sort == that.playUser) {
                    console.log("执行替换手牌操作1");
                    that.$options.methods.addDiscardCard(oldCard, _location, that);
                  }
                  that.cards.splice(_newCard.index, 1);
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            } else if (that.discardCardInfo.id) {
              var _newCard2 = that.discardCardInfo,
                  _oldCard = {};
              console.log("新手牌信息", _newCard2);
              console.log("替换手牌ID", data.number);

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard2;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard2;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard2;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard2;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard2;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard2;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    console.log("执行替换手牌操作2");
                    that.$options.methods.addDiscardCard(_oldCard, _newCard2.location, that);
                  }

                  that.$options.methods.delDiscardCard(_newCard2, _newCard2.location, that);
                }
              });
            } else if (that.copiedcard.id) {
              var _newCard3 = that.copiedcard,
                  _oldCard2 = {};

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard2 = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard3;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard3;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard3;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard3;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard3;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard3;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    console.log("执行替换手牌操作3");
                    that.$options.methods.addDiscardCard(_oldCard2, _newCard3.location, that);
                  }

                  that.copiedcard = {};
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            }
          }
        });
      }
      if (data.operateMsg == "弃牌") {
        console.log("已经弃牌");
        if (that.extractCardInfo.id) {
          var _newCard4 = that.extractCardInfo;
          _newCard4.checked = false;
          console.log(that.users2);
          that.users2.forEach(function (item, index) {
            var location = item.location;
            if (item.id == data.userId) {
              console.log(item.id, data.userId);
              that.cards.splice(_newCard4.index, 1);
              console.log("newCard", _newCard4);
              console.log("discard", that.user1.discard);
              console.log(that.user1.discard.indexOf(_newCard4));
              switch (location) {
                case 1:
                  if (that.user1.discard.indexOf(_newCard4) == -1) {
                    that.user1.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(_newCard4) == -1) {
                    that.user2.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(_newCard4) == -1) {
                    that.user3.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(_newCard4) == -1) {
                    that.user4.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(_newCard4) == -1) {
                    that.user5.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(_newCard4) == -1) {
                    that.user6.discard.splice(0, 0, _newCard4);
                  }
                  break;
              }
            }
          });
        } else if (that.discardCardInfo.id) {
          var _newCard5 = that.discardCardInfo;
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location2 = item.location,
                  userCards = [];

              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location2) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                  }
                  break;
              }
            }
          });
        } else {
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location3 = item.location;
              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location3) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                  }
                  break;
              }
            }
          });
        }
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.lastDiscardNum = data.foldNumber;
      }
      if (data.operateMsg == "下一用户操作") {
        if (that.isHomewer == true && that.cards.length == 0 && that.isfinish == 0) {
          that.isfinish = 1;
          that.noDoTimeOut();
        }

        that.UID = data.userId;
        if (data.userId == that.userId) {
          that.$notify({
            title: "通知",
            message: "あなたの番です"
          });
        }
        for (var i = 0; i < that.user1.cards.length; i++) {
          that.user1.cards[i].checked = false;
        }
        for (var _i12 = 0; _i12 < that.user2.cards.length; _i12++) {
          that.user2.cards[_i12].checked = false;
        }
        for (var _i13 = 0; _i13 < that.user3.cards.length; _i13++) {
          that.user3.cards[_i13].checked = false;
        }
        for (var _i14 = 0; _i14 < that.user4.cards.length; _i14++) {
          that.user4.cards[_i14].checked = false;
        }
        var ids = [];
        that.userTimes = that.countsNumber;
        that.$options.methods.countDown();
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.users2.forEach(function (item, index) {
          if (item.id == data.userId) {
            that.playUser = item.sort;
          }
          if (item.checked == true) {
            ids.push(item.id);
          }
        });
        var arr = [];
        var syc = {};
        var temp = [];
        temp.push(that.user1);
        temp.push(that.user2);
        temp.push(that.user3);
        temp.push(that.user4);
        syc.temp = temp;
        syc.countdown = that.userTimes;
        syc.gameTime = that.gameTimes;
        syc.pk = that.cards;
        syc.users2 = that.users2;
        syc.usersort = that.playUser;
        syc.UId = that.UID;
        arr.push(syc);
        var next = {
          operateType: 13,
          userId: that.userId,
          roomId: that.roomId,
          username: that.userEmail,
          userIds: ids,
          customize: arr,
          url: that.info.url
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(next);
      }
      if (data.operateMsg == "游戏暂停") {
        that.play = false;
        that.dialogPauseVisible = true;
        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "继续游戏") {
        that.play = true;
        that.dialogPauseVisible = false;
        that.countDown();
        that.goTimes();
      }

      if (data.operateMsg == "等待房主操作") {
        that.play = false;

        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "跳过用户") {
        var cur = "";
        var cname = "";
        that.users2.forEach(function (item, index) {
          if (that.playUser == item.sort) {
            cur = item.id;
            cname = item.username;
          }
          if (data.userIds.indexOf(item.id) != -1) {
            item.checked = true;
            item.isSkip = true;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = true;
                break;
              case 2:
                that.user2.isSkip = true;
                break;
              case 3:
                that.user3.isSkip = true;
                break;
              case 4:
                that.user4.isSkip = true;
                break;
              case 5:
                that.user5.isSkip = true;
                break;
              case 6:
                that.user6.isSkip = true;
                break;
            }
          }
        });

        if (data.nextFlag) {
          var _arr = [];
          var _syc = {};
          var _temp = [];
          _temp.push(that.user1);
          _temp.push(that.user2);
          _temp.push(that.user3);
          _temp.push(that.user4);
          _syc.temp = _temp;
          _syc.countdown = that.userTimes;
          _syc.gameTime = that.gameTimes;
          _syc.pk = that.cards;
          _syc.users2 = that.users2;
          _arr.push(_syc);
          var _ids = [];
          that.users2.forEach(function (item, index) {
            if (item.checked == true) {
              _ids.push(item.id);
            }
          });
          var _next = {
            operateType: 12,
            userId: cur,
            roomId: that.roomId,
            username: cname,
            userIds: _ids,
            customize: _arr,
            url: that.info.url
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(_next);
        }
      }
      if (data.operateMsg == "解除跳过用户") {
        console.log("users2", that.users2);
        that.users2.forEach(function (item, index) {
          console.log("item", item);
          console.log("sdata", data);
          if (data.userIds.indexOf(item.id) != -1) {
            console.log("sa");
            item.checked = false;
            item.isSkip = false;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = false;
                break;
              case 2:
                that.user2.isSkip = false;
                break;
              case 3:
                that.user3.isSkip = false;
                break;
              case 4:
                that.user4.isSkip = false;
                break;
              case 5:
                that.user5.isSkip = false;
                break;
              case 6:
                that.user6.isSkip = false;
                break;
            }
          }
        });
      }

      if (data.operateMsg == "复制其他用户的牌") {
        var _newCard6 = {},
            _location4 = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            _newCard6 = card;
          }
        });

        that.user1.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 1;
            _newCard6.index = index;
          }
        });
        that.user2.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 2;
            _newCard6.index = index;
          }
        });
        that.user3.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 3;
            _newCard6.index = index;
          }
        });
        that.user4.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 4;
            _newCard6.index = index;
          }
        });

        that.copiedcard = _newCard6;
      }

      if (data.operateMsg == "游戏结束") {
        var result = {
          minute: that.gameTimes.minute,
          second: that.gameTimes.second
        };
        var users = [];
        localStorage.removeItem("hasStart");
        if (that.user1.id) users.push(that.user1);
        if (that.user2.id) users.push(that.user2);
        if (that.user3.id) users.push(that.user3);
        if (that.user4.id) users.push(that.user4);
        if (that.user5.id) users.push(that.user5);
        if (that.user6.id) users.push(that.user6);
        result.users = users;
        var addResultParamList = [];
        if (that.user1.id) {
          var _temp2 = [];
          var obj = {};
          for (var _i15 = 0; _i15 < that.user1.cards.length; _i15++) {
            if (that.user1.cards[_i15].id < 10) {
              _temp2.push("0" + that.user1.cards[_i15].id);
            } else {
              _temp2.push(that.user1.cards[_i15].id);
            }
          }
          obj.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp2);
          obj.userName = that.user1.nickname;
          obj.userRole = that.user1.tag == "房主" ? 1 : 0;
          obj.roomId = that.roomId;
          addResultParamList.push(obj);
        }
        if (that.user2.id) {
          var _temp3 = [];
          var _obj = {};
          for (var _i16 = 0; _i16 < that.user2.cards.length; _i16++) {
            if (that.user2.cards[_i16].id < 10) {
              _temp3.push("0" + that.user2.cards[_i16].id);
            } else {
              _temp3.push(that.user2.cards[_i16].id);
            }
          }
          _obj.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp3);
          _obj.userName = that.user2.nickname;
          _obj.userRole = that.user2.tag == "房主" ? 1 : 0;
          _obj.roomId = that.roomId;
          addResultParamList.push(_obj);
        }
        if (that.user3.id) {
          var _temp4 = [];
          var _obj2 = {};
          for (var _i17 = 0; _i17 < that.user3.cards.length; _i17++) {
            if (that.user3.cards[_i17].id < 10) {
              _temp4.push("0" + that.user3.cards[_i17].id);
            } else {
              _temp4.push(that.user3.cards[_i17].id);
            }
          }
          _obj2.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp4);
          _obj2.userName = that.user3.nickname;
          _obj2.userRole = that.user3.tag == "房主" ? 1 : 0;
          _obj2.roomId = that.roomId;
          addResultParamList.push(_obj2);
        }
        if (that.user4.id) {
          var _temp5 = [];
          var _obj3 = {};
          for (var _i18 = 0; _i18 < that.user4.cards.length; _i18++) {
            if (that.user4.cards[_i18].id < 10) {
              _temp5.push("0" + that.user4.cards[_i18].id);
            } else {
              _temp5.push(that.user4.cards[_i18].id);
            }
          }
          _obj3.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp5);
          _obj3.userName = that.user4.nickname;
          _obj3.userRole = that.user4.tag == "房主" ? 1 : 0;
          _obj3.roomId = that.roomId;
          addResultParamList.push(_obj3);
        }
        if (that.user5.id) {
          var _temp6 = [];
          var _obj4 = {};
          for (var _i19 = 0; _i19 < that.user5.cards.length; _i19++) {
            if (that.user5.cards[_i19].id < 10) {
              _temp6.push("0" + that.user5.cards[_i19].id);
            } else {
              _temp6.push(that.user5.cards[_i19].id);
            }
          }
          _obj4.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp6);
          _obj4.userName = that.user5.nickname;
          _obj4.userRole = that.user5.tag == "房主" ? 1 : 0;
          _obj4.roomId = that.roomId;
          addResultParamList.push(_obj4);
        }
        if (that.user6.id) {
          var _temp7 = [];
          var _obj5 = {};
          for (var _i20 = 0; _i20 < that.user6.cards.length; _i20++) {
            if (that.user6.cards[_i20].id < 10) {
              _temp7.push("0" + that.user6.cards[_i20].id);
            } else {
              _temp7.push(that.user6.cards[_i20].id);
            }
          }
          _obj5.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp7);
          _obj5.userName = that.user6.nickname;
          _obj5.userRole = that.user6.tag == "房主" ? 1 : 0;
          _obj5.roomId = that.roomId;
          addResultParamList.push(_obj5);
        }

        localStorage.setItem("room_result_" + that.roomId, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(result));
        localStorage.setItem("addResultParamList", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(addResultParamList));
        that.$router.push({
          path: "/game/result",
          query: {
            roomId: that.roomId
          }
        });
      }
    },

    giveLocation: function giveLocation(code, email) {
      var that = this,
          giveNum = 1,
          isPlayer = false,
          players = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";

      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }
      var playerIds = [];
      var playerIdsBox = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards);

      playerIdsBox.forEach(function (key, index) {
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        playerIds.push(key);
      });
      console.log("玩家ID顺序", playerIds);
      that.UID = playerIds[0];
      var playersCount = playerIds.length,
          num = 1;
      playerIds.forEach(function (key, index) {
        console.log(key);
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["e" /* getUserInfoById */])(key).then(function (res) {
          console.log("getUserInfoById", res);
          if (res.code == 200 && res.result) {
            var sort = index + 1,
                tag = that.tags[index],
                isHomewer = false;
            if (key == that.info.homeowner) {
              tag = "房主";
              isHomewer = true;
            }
            var userInfo = {
              email: res.result.email,
              id: res.result.id,
              realname: res.result.realname,
              nickname: res.result.nickname,
              username: res.result.username,
              sort: index + 1,
              tag: tag,
              isHomewer: isHomewer,
              isSkip: false,
              checked: false
            };
            that.users2.push(userInfo);
            players.push(userInfo);
            console.log(players, "sss");
            console.log("num", num);

            if (num == playersCount) {
              players.forEach(function (item, index) {
                if (that.userId == item.id) {
                  that.userInfo = item;
                  that.userInfo.isPlayer = isPlayer = true;
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                  players.splice(index, 1);
                }
              });
              if (!isPlayer) {
                players.forEach(function (item, index) {
                  if (1 == item.sort) {
                    giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                    players.splice(index, 1);
                  }
                });
                that.mode = "watch";
              }
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user2, 2, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user3, 3, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user4, 4, giveNum, that);
                  players.splice(index, 1);
                }
              });
              console.log("玩家", players);

              var cards = [],
                  cardsNum = that.cardsNum;
              for (var i = 1; i <= cardsNum; i++) {
                var url = "",
                    style = "";
                if (i < 10) {
                  url = that.isUrl + that.imgUrl + "card_0" + i + ".png";
                } else {
                  url = that.isUrl + that.imgUrl + "card_" + i + ".png";
                }

                var z = (that.cardsNum - i) / 8;

                style = "transform: translate3d(" + z + "px, " + z + "px, " + z + "px);";
                var card = {
                  id: i,
                  url: url,
                  style: style
                };

                cards[i] = card;
              }
              that.allCards = cards;

              that.user1.cards = [];
              that.user2.cards = [];
              that.user3.cards = [];
              that.user4.cards = [];

              var _userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
              if (!_userCards) {
                that.$message({
                  message: "カード情報に誤りがあるため、ゲームを再起動してください",
                  type: "error"
                });
              }

              var newCards = [],
                  noCards = [];
              playerIds.forEach(function (key) {
                var cardLists = _userCards[key],
                    userCard = [];
                cardLists.forEach(function (item, index) {
                  noCards.push(item);
                });

                cards.forEach(function (item, index) {
                  if (cardLists.indexOf(item.id) >= 0) {
                    userCard.push(item);
                  }
                });
                if (key == that.user1.id) that.user1.cards = userCard;
                if (key == that.user2.id) that.user2.cards = userCard;
                if (key == that.user3.id) that.user3.cards = userCard;
                if (key == that.user4.id) that.user4.cards = userCard;
                if (key == that.user5.id) that.user5.cards = userCard;
                if (key == that.user6.id) that.user6.cards = userCard;
              });

              cards.forEach(function (item, index) {
                if (noCards.indexOf(item.id) < 0) {
                  newCards.push(item);
                }
              });

              that.cards = newCards;
            }
            num++;
          }
        });
      });
      that.$options.methods.createSocket(code, email);
    },

    giveLocationData: function giveLocationData(item, index, obj, location, giveNum, e) {
      if (item.sort < e.info.peopleNumber) {
        giveNum = item.sort + 1;
      } else {
        giveNum = 1;
      }
      obj.email = item.email;
      obj.id = item.id;
      obj.username = item.username;
      obj.nickname = item.nickname;
      obj.realname = item.realname;
      obj.lineStatus = item.lineStatus;
      obj.sort = item.sort;
      obj.tag = item.tag;
      obj.location = location;
      obj.isSkip = item.isSkip;
      e.users2.forEach(function (item2, index2) {
        if (item2.id == item.id) {
          e.users2[index2].location = location;
        }
      });
      return giveNum;
    },

    getCards: function getCards() {
      var cards = [],
          that = this,
          cardsNum = that.cardsNum;
      for (var i = 1; i <= cardsNum; i++) {
        var url = "";
        if (i < 10) {
          url = that.imgUrl + "card_0" + i + ".png";
        } else {
          url = that.imgUrl + "card_" + i + ".png";
        }
        var card = {
          id: i,
          url: url
        };

        cards[i] = card;
      }

      that.user1.cards = [];
      that.user2.cards = [];
      that.user3.cards = [];
      that.user4.cards = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }

      var newCards = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards).forEach(function (key) {
        var cardLists = userCards[key],
            userCard = [];
        cards.forEach(function (item, index) {
          if (cardLists.indexOf(item.id) >= 0) {
            userCard.push(item);
          } else {
            newCards.push(item);
          }
        });
        if (key == that.user1.id) that.user1.cards = userCard;
        if (key == that.user2.id) that.user2.cards = userCard;
        if (key == that.user3.id) that.user3.cards = userCard;
        if (key == that.user4.id) that.user4.cards = userCard;
        if (key == that.user5.id) that.user5.cards = userCard;
        if (key == that.user6.id) that.user6.cards = userCard;
      });

      newCards.sort(function () {
        return Math.random() - 0.5;
      });
      that.cards = newCards;
    },

    shuffle: function shuffle() {
      var that = this;
      var cards = that.cards;

      var cardBoxObj = that.$refs.gamecardslists,
          cardLists = that.$refs.gamecardslists.children;
      cards.sort(function () {
        return Math.random() - 0.5;
      });
      cards.forEach(function (item, index) {
        var cardObj = cardLists[index],
            z = (that.cardsNum - index) / 8;

        cardObj.style["transform"] = "translate3d(" + z + "px, " + z + "px, -" + z + "px)";
      });
    },
    translate: function translate(a, b, c) {
      c = c || 0;
      if (has3d) {
        return "translate3d(" + a + ", " + b + ", " + c + ")";
      } else {
        return "translate(" + a + ", " + b + ")";
      }
    },

    extractCard: function extractCard(item, index) {
      var that = this;
      that.csh();

      console.log("that.userInfo", that.userInfo);
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == true) {
        console.log("操作を禁止しています1");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log(that.userInfo);
        console.log(that.userInfo.sort);
        console.log(that.playUser);
        console.log("操作を禁止しています2");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      that.discardCardInfo = {};

      var noCreatNum = [];
      that.cards.forEach(function (card, id) {
        noCreatNum.push(card.id);
      });
      console.log(noCreatNum);
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        noCreatNum: noCreatNum,

        operateType: 1,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    extractCardFromDiscards: function extractCardFromDiscards(item, index, location, event, discard, username) {
      var that = this;
      that.discardCardInfo = {};
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.extracting == true) {
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
        return false;
      }
      var checked = item.checked;
      that.csh();
      var user1id = [];
      for (var i = 0; i < that.user1.cards.length; i++) {
        user1id.push(that.user1.cards[i].id);
      }
      if (user1id.indexOf(item.id) != -1) {
        that.$message({
          message: "既にこのカードを持っています",
          type: "error"
        });
        return;
      }
      var array = discard;
      for (var _i21 = 0; _i21 < array.length; _i21++) {
        if (_i21 == index) {
          if (!checked) {
            array[_i21].checked = true;
            that.discardCardInfo = {
              location: location,
              index: index,
              id: item.id,
              url: item.url
            };
          } else {
            array[_i21].checked = false;
            that.discardCardInfo = {};
          }
        } else {
          array[_i21].checked = false;
        }
      }
      console.log(array);
      if (username == "user1") {
        that.user1.discard = array;
        console.log("s", that.user1.discard);
      }
      var newCard = that.discardCardInfo;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        number: newCard.id,
        operateType: 3,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    changeOtherCard: function changeOtherCard(item, index, event, location, cards, player) {
      var that = this;

      var user1id = [];
      for (var i = 0; i < that.user1.cards.length; i++) {
        user1id.push(that.user1.cards[i].id);
      }
      if (user1id.indexOf(item.id) != -1) {
        return;
      }
      if (that.extracting == true) {
        return false;
      }
      that.csh();
      if (player == "user2") {
        for (var _i22 = 0; _i22 < cards.length; _i22++) {
          console.log(_i22);
          if (index == _i22) {
            if (cards[_i22].checked == true) {
              cards[_i22].checked = false;
            } else {
              cards[_i22].checked = true;
            }
          } else {
            cards[_i22].checked = false;
          }
        }
        that.user2.cards = cards;
      } else if (player == "user3") {
        for (var _i23 = 0; _i23 < cards.length; _i23++) {
          console.log(_i23);
          if (index == _i23) {
            if (cards[_i23].checked == true) {
              cards[_i23].checked = false;
            } else {
              cards[_i23].checked = true;
            }
          } else {
            cards[_i23].checked = false;
          }
        }
        that.user3.cards = cards;
      } else if (player == "user4") {
        for (var _i24 = 0; _i24 < cards.length; _i24++) {
          console.log(_i24);
          if (index == _i24) {
            if (cards[_i24].checked == true) {
              cards[_i24].checked = false;
            } else {
              cards[_i24].checked = true;
            }
          } else {
            cards[_i24].checked = false;
          }
        }
        that.user4.cards = cards;
      }
      if (that.info.isCopy == "あり") {
        var data = {
          number: item.id,
          operateType: 2,
          url: that.info.url,
          userId: that.userId,
          username: that.userEmail,
          roomId: that.roomId
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
      } else {}
    },

    changeSelfCard: function changeSelfCard(item, index, event, location) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        that.$message({
          message: "観戦中",
          type: "error"
        });
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");

        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      var newCard = {},
          oldCard = that.user1.cards[index],
          discardType = 0;

      if (that.extractCardInfo.id) {
        discardType = 1;
      } else if (that.discardCardInfo.id) {
        discardType = 2;
      } else if (that.copiedcard.id) {
        discardType = 3;
      }
      if (discardType == 0) {
        console.log("操作を禁止しています");

        return false;
      }

      if (discardType == 3) {
        if (location == 1) {
          newCard = that.copiedcard;
          var temp = [];
          temp.push(that.user1);
          temp.push(that.user2);
          temp.push(that.user3);
          temp.push(that.user4);
          var data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
        }
      } else {
        if (location == 1) {
          newCard = that.extractCardInfo;
          var _temp8 = [];
          _temp8.push(that.user1);
          _temp8.push(that.user2);
          _temp8.push(that.user3);
          _temp8.push(that.user4);
          var _data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(_data);
        }
      }
    },

    discardCard: function discardCard(location, event) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == false) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      var newCard = that.extractCardInfo;
      that.$options.methods.addDiscardCard(newCard, location, that);
      if (that.cards.length == 0) {
        that.dialogFinishVisible = true;
      }
    },

    addDiscardCard: function addDiscardCard(card, location, e) {
      var that = this;
      console.log("roomid", e.roomId);
      console.log(e);
      var arr = [];
      var syc = {};
      var temp = [];
      temp.push(e.user1);
      temp.push(e.user2);
      temp.push(e.user3);
      temp.push(e.user4);
      syc.temp = temp;
      syc.countdown = e.userTimes;
      syc.gameTime = e.gameTimes;
      syc.pk = e.cards;
      syc.users2 = e.users2;
      arr.push(syc);
      var ids = [];
      e.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: e.userId,
        roomId: e.roomId,
        username: e.userEmail,
        userIds: ids,
        customize: arr,
        url: e.info.url
      };

      var data = {
        foldNumber: card.id,
        operateType: 4,
        url: e.info.url,
        userId: e.userId,
        username: e.userEmail,
        roomId: e.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    delDiscardCard: function delDiscardCard(card, location, e) {
      switch (location) {
        case 1:
          e.user1.discard.splice(card.index, 1);
          break;
        case 2:
          e.user2.discard.splice(card.index, 1);
          break;
        case 3:
          e.user3.discard.splice(card.index, 1);
          break;
        case 4:
          e.user4.discard.splice(card.index, 1);
          break;
        case 5:
          e.user5.discard.splice(card.index, 1);
          break;
        case 6:
          e.user6.discard.splice(card.index, 1);
          break;
      }
    },

    copyCard: function copyCard() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      if (that.extracting = true) {
        that.$message({
          message: "已抽牌，请选择替换手牌",
          type: "error"
        });
      }
    },
    reStart: function reStart() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 11,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    discard_hover: function discard_hover(e) {
      var target = e.target.parentNode;
      var viewportOffset = target.getBoundingClientRect();
      var parent_viewport = target.parentNode.getBoundingClientRect();

      if (target.style.position === 'fixed') {
        return;
      }
      var top = parent_viewport.top;
      var left = parent_viewport.left;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target.style, { position: 'fixed', left: left + 'px', top: top + 'px' });
    },
    discard_leave: function discard_leave(e) {
      var target = e.target.parentNode;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target.style, { position: 'relative', left: 0 + 'px', top: 0 + 'px' });
    },

    dragscroll: function dragscroll(e) {
      var el = e.currentTarget.parentElement;
      var disX = e.clientX;

      var disY = e.clientY;
      var originalScrollLeft = el.scrollLeft;
      var originalScrollTop = el.scrollTop;
      var originalScrollBehavior = el.style["scroll-behavior"];
      var originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
      document.onmousemove = function (e) {
        e.preventDefault();
        var distanceX = e.clientX - disX;
        var distanceY = e.clientY - disY;
        el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY);

        el.style["pointer-events"] = "none";
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        el.style["scroll-behavior"] = originalScrollBehavior;
        el.style["pointer-events"] = originalPointerEvents;
      };
    },
    dragscrollTouchStart: function dragscrollTouchStart(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      that.touch.disX = touch.clientX;

      that.touch.disY = touch.clientY;
      that.touch.originalScrollLeft = el.scrollLeft;
      that.touch.originalScrollTop = el.scrollTop;
      that.touch.originalScrollBehavior = el.style["scroll-behavior"];
      that.touch.originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
    },
    dragscrollTouchMove: function dragscrollTouchMove(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      var distanceX = touch.clientX - that.touch.disX;
      var distanceY = touch.clientY - that.touch.disY;
      el.scrollTo(that.touch.originalScrollLeft - distanceX, that.touch.originalScrollTop - distanceY);

      el.style["pointer-events"] = "none";
    },
    dragscrollTouchEnd: function dragscrollTouchEnd(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      document.ontouchmove = null;
      document.ontouchend = null;
      el.style["scroll-behavior"] = that.touch.originalScrollBehavior;
      el.style["pointer-events"] = that.touch.originalPointerEvents;
    },

    getRoomDetail: function getRoomDetail() {
      var that = this,
          roomId = that.roomId;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
        if (res) {
          if (res.code == 200 && res.result) {
            that.info = {
              homeowner: res.result.homeownerId,
              roomName: res.result.roomName,
              homeownerName: res.result.homeownerName,
              startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
              theme: res.result.theme,
              isCopy: res.result.isCopy == 1 ? "あり" : "なし",
              isPublic: res.result.isPublic,
              peopleNumber: res.result.peopleNumber,
              url: res.result.url
            };
            that.userTimes = res.result.turnTime;
            that.countsNumber = res.result.turnTime;
            that.gemePeople = res.result.peopleNumber;
            var pb = res.result.isPublic == 1 ? "公開" : "非公開";
            var copyInfo = res.result.homeownerName + "さんからの招待です。\n \n 以下から参加できます。\n URL: " + res.result.url + " \n \n パスワード：" + res.result.password + " \n \n ・ゲーム情報 \n ホスト名：" + res.result.homeownerName + "\n ルーム名：" + res.result.roomName + "\n 開始時刻：" + res.result.startTime + "\n \n ・ゲーム設定" + "\n 主题：" + res.result.theme + "\n 人数：" + res.result.peopleNumber + "\n 手札公開：" + pb + "\n 复制功能：" + res.result.isCopy;
            that.copyInfo = copyInfo;

            if (that.userId == res.result.homeownerId) that.isHomewer = true;

            var code = res.result.url;

            that.giveLocation(code, that.userEmail);
          }
        }
      });
    },

    getUserInfo: function getUserInfo() {
      var that = this,
          token = localStorage.getItem("Authorization");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
        console.log("userinfo", res.result);
        if (res) {
          that.userInfo = res.result;
        }
      });
    },

    doTimeOut: function doTimeOut() {
      var that = this;
      that.dialogPauseVisiblePre = true;
    },

    doPause: function doPause() {
      var that = this;
      that.dialogPauseVisiblePre = false;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    noDoTimeOut: function noDoTimeOut() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.dialogFinishVisible = true;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    doSelfSkip: function doSelfSkip() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      that.dialogSkipVisiblePre = true;
    },

    doPass: function doPass() {
      var that = this;
      that.dialogSkipVisiblePre = false;
      var arr = [];
      var syc = {};
      var temp = [];
      var ids = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      syc.temp = temp;
      syc.countdown = that.userTimes;
      syc.gameTime = that.gameTimes;
      syc.pk = that.cards;
      syc.users2 = that.users2;
      arr.push(syc);
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: that.userId,
        roomId: that.roomId,
        username: that.userEmail,
        userIds: ids,
        customize: arr,
        url: that.info.url
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    doPlay: function doPlay() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.play = true;
    },

    doSet: function doSet() {
      this.dialogSettingVisible = true;
    },

    toFinish: function toFinish() {
      this.dialogFinishVisible = true;
    },

    doFinish: function doFinish() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 8,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp),
        roomId: that.roomId,
        turnTime: that.gameTimes.minute * 60 + that.gameTimes.second
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["g" /* gamesOperate */])(data).then(function (res) {
        if (res && res.code == 200) {
          var result = {
            minute: that.gameTimes.minute,
            second: that.gameTimes.second
          };
          var users = [];
          if (that.user1.id) users.push(that.user1);
          if (that.user2.id) users.push(that.user2);
          if (that.user3.id) users.push(that.user3);
          if (that.user4.id) users.push(that.user4);
          if (that.user5.id) users.push(that.user5);
          if (that.user6.id) users.push(that.user6);
          result.users = users;
        }
      });
    },

    toGame: function toGame() {
      this.dialogFinishVisible = false;
      this.dialogSettingVisible = false;
      this.reStart();
    },

    toSkip: function toSkip() {
      this.dialogSkipVisible = true;
      this.dialogSettingVisible = false;
    },

    checkUser: function checkUser(item, index, checked) {
      var that = this;
      if (checked) {
        that.users2[index].checked = false;
      } else {
        that.users2[index].checked = true;
      }
    },
    doSkip: function doSkip() {
      var that = this;
      var ids = [];
      var names = [];
      var cur = "";
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          console.log(item);
          ids.push(item.id);
          names.push(item.username);
        }
        if (item.sort == that.playUser) {
          console.log(item);
          cur = item.id;
        }
      });
      var data = {
        operateType: 6,
        url: that.info.url,
        userId: cur,
        username: names[0],
        userIds: ids,
        usernames: names,
        currentUserId: cur
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
      that.dialogSkipVisible = false;
    },

    cancelSkip: function cancelSkip(name, id, location) {
      var that = this;
      var s = [];
      var n = [];
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      s.push(id);
      n.push(name);
      var data = {
        operateType: 7,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        userIds: s,
        usernames: n
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    countDown: function countDown() {
      var that = this,
          times = that.userTimes;
      that.timer = setInterval(function () {
        that.userTimes--;
      }, 1000);
    },

    goTimes: function goTimes() {
      var that = this;
      that.timer2 = setInterval(function () {
        that.gameTimes.second++;
        if (that.gameTimes.second == 60) {
          that.gameTimes.second = 0;
          that.gameTimes.minute++;
        }
        that.gameTimes.str = that.$options.methods.toDub(that.gameTimes.minute) + ":" + that.$options.methods.toDub(that.gameTimes.second);
      }, 1000);
    },

    toDub: function toDub(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    }
  })
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_global_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(52);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isUrl: "https",
      loading: false,
      tags: this.GLOBAL.tags,
      mode: "play",
      imgUrl: "://online.engagement-card.com/img/",
      cardsBack: __webpack_require__(123),
      scrollWidth: "900px",
      UID: "",

      userId: "1505124724596801538",
      userEmail: "2856678408@qq.com",
      userName: "",
      allCards: [],
      cards: [],
      cardsNum: 89,
      isfinish: 0,
      lastDiscardNum: 0,
      touch: {
        disX: 0,
        disY: 0,
        originalScrollLeft: 0,
        originalScrollTop: 0,
        originalScrollBehavior: '',
        originalPointerEvents: ''
      },

      users: [],

      users2: [],

      roomId: "c0e6b1e56ed0141b000650f2ec5232d9",
      play: true,
      isHomewer: false,
      info: {
        homeowner: "1505124724596801538",
        roomName: "测试房间1",
        homeownerName: "戸田勇大1",
        startTime: "2022-4-6 10:00",
        theme: "人生",
        isCopy: true,
        isPublic: false,
        peopleNumber: 4,
        url: ""
      },

      userInfo: {},

      user1: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user2: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user3: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user4: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user5: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },
      user6: {
        email: "",
        id: "",
        username: "",
        realname: "",
        lineStatus: "",
        sort: 0,
        location: 0,
        isSkip: false,
        cards: [],
        discard: []
      },

      userCards: [],

      extracting: false,
      extractCardInfo: {},
      discardCardInfo: {},

      playUser: 1,
      gemePeople: 0,

      dialogSettingVisible: false,
      dialogFinishVisible: false,
      dialogSkipVisible: false,
      dialogPauseVisible: false,
      dialogSkipVisiblePre: false,
      dialogPauseVisiblePre: false,

      userTimes: 0,
      totalPerson: 0,
      countsNumber: 0,
      gameTimes: {
        str: "00:00",
        hour: 0,
        minute: 0,
        second: 0,
        ms: 0
      },
      watchCount: 0 };
  },

  watch: {
    user1: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        if (val.hasOwnProperty("discard")) {
          var el = this.$refs.location1,
              discardCount = val.discard.length,
              clientWidth = 0;
          if (discardCount > 7) {
            clientWidth = (el.children[0].clientWidth + 25) * discardCount;
            el.style["width"] = clientWidth + "px";
          }
        }
      }
    },
    users2: {
      immediate: true,

      deep: true,
      handler: function handler(val) {}
    },
    cards: {
      immediate: true,

      deep: true,
      handler: function handler(val) {
        console.log("监听卡牌", val);
      }
    }
  },
  components: {},
  created: function created() {
    this.isUrl = this.GLOBAL.getHttps();
    this.updateFooter(false);
    this.roomId = this.$route.query.roomId;
    this.userId = localStorage.getItem("homeowner");
    this.userEmail = localStorage.getItem("userEmail");
    this.getRoomDetail();
  },
  mounted: function mounted() {
    this.users = JSON.parse(localStorage.getItem("room_" + this.roomId));

    this.getUserInfo();
    this.goTimes();
    this.countDown();
    window.addEventListener("onmessageWS", this.getsocketData);
    if (document.getElementById('app')) {
      document.getElementById('app').style.overflow = 'hidden';
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapMutations */])(["updateFooter"]), {
    goPage: function goPage(page) {
      this.$router.push(page);
    },

    createSocket: function createSocket(code, userEmail) {
      var that = this;
      var wsUrl = "";
      var ishttps = "https:" == document.location.protocol ? true : false;

      if (ishttps) wsUrl = "wss://" + __WEBPACK_IMPORTED_MODULE_6__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;else wsUrl = "ws://" + __WEBPACK_IMPORTED_MODULE_6__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["a" /* createSocket */])(wsUrl);
    },
    csh: function csh() {
      var that = this;
      that.discardCardInfo = {};
      that.copiedcard = {};
      for (var i = 0; i < that.user1.cards.length; i++) {
        that.user1.cards[i].checked = false;
      }
      for (var _i = 0; _i < that.user1.discard.length; _i++) {
        that.user1.discard[_i].checked = false;
      }
      for (var _i2 = 0; _i2 < that.user2.cards.length; _i2++) {
        that.user2.cards[_i2].checked = false;
      }
      for (var _i3 = 0; _i3 < that.user2.discard.length; _i3++) {
        that.user2.discard[_i3].checked = false;
      }
      for (var _i4 = 0; _i4 < that.user3.cards.length; _i4++) {
        that.user3.cards[_i4].checked = false;
      }
      for (var _i5 = 0; _i5 < that.user3.discard.length; _i5++) {
        that.user3.discard[_i5].checked = false;
      }
      for (var _i6 = 0; _i6 < that.user4.cards.length; _i6++) {
        that.user4.cards[_i6].checked = false;
      }
      for (var _i7 = 0; _i7 < that.user4.discard.length; _i7++) {
        that.user4.discard[_i7].checked = false;
      }
      for (var _i8 = 0; _i8 < that.user5.cards.length; _i8++) {
        that.user5.cards[_i8].checked = false;
      }
      for (var _i9 = 0; _i9 < that.user5.discard.length; _i9++) {
        that.user5.discard[_i9].checked = false;
      }
      for (var _i10 = 0; _i10 < that.user6.cards.length; _i10++) {
        that.user6.cards[_i10].checked = false;
      }
      for (var _i11 = 0; _i11 < that.user6.discard.length; _i11++) {
        that.user6.discard[_i11].checked = false;
      }
    },
    getSame: function getSame() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["d" /* getSame */])(that.roomId).then(function (res) {
        console.log("same", res);
        if (res.result) {
          if (res.result.customize) {
            var samedata = JSON.parse(res.result.customize);
            var re = samedata[0];
            console.log("re", re);

            setTimeout(function () {
              for (var i = 0; i < re.temp.length; i++) {
                if (that.user1.sort == re.temp[i].sort) {
                  that.user1 = re.temp[i];
                }
                if (that.user2.sort == re.temp[i].sort) {
                  that.user2 = re.temp[i];
                }
                if (that.user3.sort == re.temp[i].sort) {
                  that.user3 = re.temp[i];
                }
                if (that.user4.sort == re.temp[i].sort) {
                  that.user4 = re.temp[i];
                }
              }
              that.cards = re.pk;
              that.userTimes = re.countdown;
              that.gameTimes = re.gameTime;
              that.playUser = re.usersort;
            }, 1000);
          }
        }
      });
    },

    getsocketData: function getsocketData(e) {
      var that = this;
      if (e.detail.data == "发生连接错误") return false;
      var data = JSON.parse(e.detail.data),
          newUser = {},
          isNew = true;
      if (data.onlineNumber > 0) {
        that.totalPerson = data.onlineNumber;
        that.getSame();
      }
      if (data.operateMsg == "从卡堆抽牌") {
        that.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            that.extractCardInfo = {
              index: index,
              id: data.number,
              url: item.url
            };
            that.extracting = true;
            return true;
          }
        });
      }
      if (data.operateMsg == "从弃卡堆里抽牌") {
        var newCard = {},
            location = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            newCard = card;
          }
        });

        that.user1.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 1;
            newCard.index = index;
          }
        });
        that.user2.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 2;
            newCard.index = index;
          }
        });
        that.user3.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 3;
            newCard.index = index;
          }
        });
        that.user4.discard.forEach(function (item, index) {
          if (item.id == data.number) {
            newCard.location = 4;
            newCard.index = index;
          }
        });

        that.discardCardInfo = newCard;
      }
      if (data.operateMsg == "替换手牌") {
        that.users2.forEach(function (item, index) {
          console.log(item.id);
          console.log(data.userId);
          if (data.userId == item.id) {
            var _location = item.location,
                userCards = [];
            switch (_location) {
              case 1:
                userCards = that.user1.cards;
                break;
              case 2:
                userCards = that.user2.cards;
                break;
              case 3:
                userCards = that.user3.cards;
                break;
              case 4:
                userCards = that.user4.cards;
                break;
              case 5:
                userCards = that.user5.cards;
                break;
              case 6:
                userCards = that.user6.cards;
                break;
            }
            if (that.extractCardInfo.id) {
              var _newCard = that.extractCardInfo,
                  oldCard = {};
              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(oldCard, _location, that);
                  }
                  that.cards.splice(_newCard.index, 1);
                  that.extracting = false;
                  that.extractCardInfo = {};
                  that.discardCardInfo = {};
                }
              });
            } else if (that.discardCardInfo.id) {
              var _newCard2 = that.discardCardInfo,
                  _oldCard = {};
              console.log("新手牌信息", _newCard2);
              console.log("替换手牌ID", data.number);

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard2;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard2;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard2;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard2;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard2;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard2;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(_oldCard, _newCard2.location, that);
                  }

                  that.$options.methods.delDiscardCard(_newCard2, _newCard2.location, that);
                }
              });
            } else if (that.copiedcard.id) {
              var _newCard3 = that.copiedcard,
                  _oldCard2 = {};

              userCards.forEach(function (card, key) {
                if (card.id == data.number) {
                  _oldCard2 = userCards[key];
                  switch (_location) {
                    case 1:
                      that.user1.cards[key] = _newCard3;
                      break;
                    case 2:
                      that.user2.cards[key] = _newCard3;
                      break;
                    case 3:
                      that.user3.cards[key] = _newCard3;
                      break;
                    case 4:
                      that.user4.cards[key] = _newCard3;
                      break;
                    case 5:
                      that.user5.cards[key] = _newCard3;
                      break;
                    case 6:
                      that.user6.cards[key] = _newCard3;
                      break;
                  }
                  if (that.userInfo.sort == that.playUser) {
                    that.$options.methods.addDiscardCard(_oldCard2, _newCard3.location, that);
                  }

                  that.$options.methods.delDiscardCard(_newCard3, _newCard3.location, that);
                  that.copiedcard = {};
                }
              });
            }
          }
        });
      }
      if (data.operateMsg == "弃牌") {
        console.log("已经弃牌");
        if (that.extractCardInfo.id) {
          var _newCard4 = that.extractCardInfo;
          _newCard4.checked = false;
          console.log(that.users2);
          that.users2.forEach(function (item, index) {
            var location = item.location;
            if (item.id == data.userId) {
              console.log(item.id, data.userId);
              that.cards.splice(_newCard4.index, 1);
              console.log("newCard", _newCard4);
              console.log("discard", that.user1.discard);
              console.log(that.user1.discard.indexOf(_newCard4));
              switch (location) {
                case 1:
                  if (that.user1.discard.indexOf(_newCard4) == -1) {
                    that.user1.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(_newCard4) == -1) {
                    that.user2.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(_newCard4) == -1) {
                    that.user3.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(_newCard4) == -1) {
                    that.user4.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(_newCard4) == -1) {
                    that.user5.discard.splice(0, 0, _newCard4);
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(_newCard4) == -1) {
                    that.user6.discard.splice(0, 0, _newCard4);
                  }
                  break;
              }
            }
          });
        } else if (that.discardCardInfo.id) {
          var _newCard5 = that.discardCardInfo;
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location2 = item.location,
                  userCards = [];

              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location2) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                  }
                  break;
              }
            }
          });
        } else {
          that.users2.forEach(function (item, index) {
            if (item.id == data.userId) {
              var _location3 = item.location;
              var oldCard = {};
              that.allCards.forEach(function (card, key) {
                if (card.id == data.foldNumber) {
                  oldCard = card;
                  oldCard.checked = false;
                }
              });
              switch (_location3) {
                case 1:
                  if (that.user1.discard.indexOf(oldCard) == -1) {
                    that.user1.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 2:
                  if (that.user2.discard.indexOf(oldCard) == -1) {
                    that.user2.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 3:
                  if (that.user3.discard.indexOf(oldCard) == -1) {
                    that.user3.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 4:
                  if (that.user4.discard.indexOf(oldCard) == -1) {
                    that.user4.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 5:
                  if (that.user5.discard.indexOf(oldCard) == -1) {
                    that.user5.discard.splice(0, 0, oldCard);
                  }
                  break;
                case 6:
                  if (that.user6.discard.indexOf(oldCard) == -1) {
                    that.user6.discard.splice(0, 0, oldCard);
                  }
                  break;
              }
            }
          });
        }
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.lastDiscardNum = data.foldNumber;
      }
      if (data.operateMsg == "下一用户操作") {
        if (that.isHomewer == true && that.cards.length == 0 && that.isfinish == 0) {
          that.isfinish = 1;
          that.noDoTimeOut();
        }

        that.UID = data.userId;
        if (data.userId == that.userId) {
          that.$notify({
            title: "通知",
            message: "あなたの番です"
          });
        }
        for (var i = 0; i < that.user1.cards.length; i++) {
          that.user1.cards[i].checked = false;
        }
        for (var _i12 = 0; _i12 < that.user2.cards.length; _i12++) {
          that.user2.cards[_i12].checked = false;
        }
        for (var _i13 = 0; _i13 < that.user3.cards.length; _i13++) {
          that.user3.cards[_i13].checked = false;
        }
        for (var _i14 = 0; _i14 < that.user4.cards.length; _i14++) {
          that.user4.cards[_i14].checked = false;
        }
        var ids = [];
        that.userTimes = that.countsNumber;
        that.$options.methods.countDown();
        that.extracting = false;
        that.extractCardInfo = {};
        that.discardCardInfo = {};
        that.users2.forEach(function (item, index) {
          if (item.id == data.userId) {
            that.playUser = item.sort;
          }
          if (item.checked == true) {
            ids.push(item.id);
          }
        });
        var arr = [];
        var syc = {};
        var temp = [];
        temp.push(that.user1);
        temp.push(that.user2);
        temp.push(that.user3);
        temp.push(that.user4);
        syc.temp = temp;
        syc.countdown = that.userTimes;
        syc.gameTime = that.gameTimes;
        syc.pk = that.cards;
        syc.users2 = that.users2;
        syc.usersort = that.playUser;
        syc.UId = that.UID;
        arr.push(syc);
        var next = {
          operateType: 13,
          userId: that.userId,
          roomId: that.roomId,
          username: that.userEmail,
          userIds: ids,
          customize: arr,
          url: that.info.url
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(next);
      }
      if (data.operateMsg == "游戏暂停") {
        that.play = false;
        that.dialogPauseVisible = true;
        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "继续游戏") {
        that.play = true;
        that.dialogPauseVisible = false;
        that.countDown();
        that.goTimes();
      }

      if (data.operateMsg == "等待房主操作") {
        that.play = false;

        clearInterval(that.timer);
        clearInterval(that.timer2);
      }

      if (data.operateMsg == "跳过用户") {
        var cur = "";
        var cname = "";
        that.users2.forEach(function (item, index) {
          if (that.playUser == item.sort) {
            cur = item.id;
            cname = item.username;
          }
          if (data.userIds.indexOf(item.id) != -1) {
            item.checked = true;
            item.isSkip = true;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = true;
                break;
              case 2:
                that.user2.isSkip = true;
                break;
              case 3:
                that.user3.isSkip = true;
                break;
              case 4:
                that.user4.isSkip = true;
                break;
              case 5:
                that.user5.isSkip = true;
                break;
              case 6:
                that.user6.isSkip = true;
                break;
            }
          }
        });

        if (data.nextFlag) {
          var _arr = [];
          var _syc = {};
          var _temp = [];
          _temp.push(that.user1);
          _temp.push(that.user2);
          _temp.push(that.user3);
          _temp.push(that.user4);
          _syc.temp = _temp;
          _syc.countdown = that.userTimes;
          _syc.gameTime = that.gameTimes;
          _syc.pk = that.cards;
          _syc.users2 = that.users2;
          _arr.push(_syc);
          var _ids = [];
          that.users2.forEach(function (item, index) {
            if (item.checked == true) {
              _ids.push(item.id);
            }
          });
          var _next = {
            operateType: 12,
            userId: cur,
            roomId: that.roomId,
            username: cname,
            userIds: _ids,
            customize: _arr,
            url: that.info.url
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(_next);
        }
      }

      if (data.operateMsg == "解除跳过用户") {
        console.log("users2", that.users2);
        that.users2.forEach(function (item, index) {
          if (data.userIds.indexOf(item.id) != -1) {
            console.log("解除用户");
            console.log(item);
            console.log(item.location);
            item.checked = false;
            item.isSkip = false;
            that.users2[index] = item;

            switch (item.location) {
              case 1:
                that.user1.isSkip = false;
                break;
              case 2:
                that.user2.isSkip = false;
                break;
              case 3:
                that.user3.isSkip = false;
                break;
              case 4:
                that.user4.isSkip = false;
                break;
              case 5:
                that.user5.isSkip = false;
                break;
              case 6:
                that.user6.isSkip = false;
                break;
            }
          }
        });
      }

      if (data.operateMsg == "复制其他用户的牌") {
        var _newCard6 = {},
            _location4 = 0;
        that.allCards.forEach(function (card, key) {
          if (card.id == data.number) {
            _newCard6 = card;
          }
        });

        that.user1.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 1;
            _newCard6.index = index;
          }
        });
        that.user2.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 2;
            _newCard6.index = index;
          }
        });
        that.user3.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 3;
            _newCard6.index = index;
          }
        });
        that.user4.cards.forEach(function (item, index) {
          if (item.id == data.number) {
            _newCard6.location = 4;
            _newCard6.index = index;
          }
        });

        that.copiedcard = _newCard6;
      }

      if (data.operateMsg == "游戏结束") {
        var result = {
          minute: that.gameTimes.minute,
          second: that.gameTimes.second
        };
        var users = [];
        localStorage.removeItem("hasStart");
        if (that.user1.id) users.push(that.user1);
        if (that.user2.id) users.push(that.user2);
        if (that.user3.id) users.push(that.user3);
        if (that.user4.id) users.push(that.user4);
        if (that.user5.id) users.push(that.user5);
        if (that.user6.id) users.push(that.user6);
        result.users = users;
        var addResultParamList = [];
        if (that.user1.id) {
          var _temp2 = [];
          var obj = {};
          for (var _i15 = 0; _i15 < that.user1.cards.length; _i15++) {
            if (that.user1.cards[_i15].id < 10) {
              _temp2.push("0" + that.user1.cards[_i15].id);
            } else {
              _temp2.push(that.user1.cards[_i15].id);
            }
          }
          obj.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp2);
          obj.userName = that.user1.nickname;
          obj.userRole = that.user1.tag == "房主" ? 1 : 0;
          obj.roomId = that.roomId;
          addResultParamList.push(obj);
        }
        if (that.user2.id) {
          var _temp3 = [];
          var _obj = {};
          for (var _i16 = 0; _i16 < that.user2.cards.length; _i16++) {
            if (that.user2.cards[_i16].id < 10) {
              _temp3.push("0" + that.user2.cards[_i16].id);
            } else {
              _temp3.push(that.user2.cards[_i16].id);
            }
          }
          _obj.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp3);
          _obj.userName = that.user2.nickname;
          _obj.userRole = that.user2.tag == "房主" ? 1 : 0;
          _obj.roomId = that.roomId;
          addResultParamList.push(_obj);
        }
        if (that.user3.id) {
          var _temp4 = [];
          var _obj2 = {};
          for (var _i17 = 0; _i17 < that.user3.cards.length; _i17++) {
            if (that.user3.cards[_i17].id < 10) {
              _temp4.push("0" + that.user3.cards[_i17].id);
            } else {
              _temp4.push(that.user3.cards[_i17].id);
            }
          }
          _obj2.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp4);
          _obj2.userName = that.user3.nickname;
          _obj2.userRole = that.user3.tag == "房主" ? 1 : 0;
          _obj2.roomId = that.roomId;
          addResultParamList.push(_obj2);
        }
        if (that.user4.id) {
          var _temp5 = [];
          var _obj3 = {};
          for (var _i18 = 0; _i18 < that.user4.cards.length; _i18++) {
            if (that.user4.cards[_i18].id < 10) {
              _temp5.push("0" + that.user4.cards[_i18].id);
            } else {
              _temp5.push(that.user4.cards[_i18].id);
            }
          }
          _obj3.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp5);
          _obj3.userName = that.user4.nickname;
          _obj3.userRole = that.user4.tag == "房主" ? 1 : 0;
          _obj3.roomId = that.roomId;
          addResultParamList.push(_obj3);
        }
        if (that.user5.id) {
          var _temp6 = [];
          var _obj4 = {};
          for (var _i19 = 0; _i19 < that.user5.cards.length; _i19++) {
            if (that.user5.cards[_i19].id < 10) {
              _temp6.push("0" + that.user5.cards[_i19].id);
            } else {
              _temp6.push(that.user5.cards[_i19].id);
            }
          }
          _obj4.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp6);
          _obj4.userName = that.user5.nickname;
          _obj4.userRole = that.user5.tag == "房主" ? 1 : 0;
          _obj4.roomId = that.roomId;
          addResultParamList.push(_obj4);
        }
        if (that.user6.id) {
          var _temp7 = [];
          var _obj5 = {};
          for (var _i20 = 0; _i20 < that.user6.cards.length; _i20++) {
            if (that.user6.cards[_i20].id < 10) {
              _temp7.push("0" + that.user6.cards[_i20].id);
            } else {
              _temp7.push(that.user6.cards[_i20].id);
            }
          }
          _obj5.userCard = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_temp7);
          _obj5.userName = that.user6.nickname;
          _obj5.userRole = that.user6.tag == "房主" ? 1 : 0;
          _obj5.roomId = that.roomId;
          addResultParamList.push(_obj5);
        }
        console.log("result", addResultParamList);
        localStorage.setItem("room_result_" + that.roomId, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(result));
        localStorage.setItem("addResultParamList", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(addResultParamList));
        that.$router.push({
          path: "/game/result",
          query: {
            roomId: that.roomId
          }
        });
      }
    },

    giveLocation: function giveLocation(code, email) {
      var that = this,
          giveNum = 1,
          isPlayer = false,
          players = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";

      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }
      var playerIds = [];
      var playerIdsBox = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards);

      playerIdsBox.forEach(function (key, index) {
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        playerIds.push(key);
      });
      console.log("玩家ID顺序", playerIds);
      that.UID = playerIds[0];
      var playersCount = playerIds.length,
          num = 1;
      playerIds.forEach(function (key, index) {
        console.log(key);
        if (key == "userId" || key == "email" || key == "username") {
          return true;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["e" /* getUserInfoById */])(key).then(function (res) {
          console.log("getUserInfoById", res);
          if (res.code == 200 && res.result) {
            var sort = index + 1,
                tag = that.tags[index],
                isHomewer = false;
            if (key == that.info.homeowner) {
              tag = "房主";
              isHomewer = true;
            }
            var userInfo = {
              email: res.result.email,
              id: res.result.id,
              realname: res.result.realname,
              nickname: res.result.nickname,
              username: res.result.username,
              sort: index + 1,
              tag: tag,
              isHomewer: isHomewer,
              isSkip: false,
              checked: false
            };
            that.users2.push(userInfo);
            players.push(userInfo);

            if (num == playersCount) {
              players.forEach(function (item, index) {
                if (that.userId == item.id) {
                  that.userInfo = item;
                  that.userInfo.isPlayer = isPlayer = true;
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                  players.splice(index, 1);
                }
              });
              if (!isPlayer) {
                players.forEach(function (item, index) {
                  if (1 == item.sort) {
                    giveNum = that.$options.methods.giveLocationData(item, index, that.user1, 1, giveNum, that);
                    players.splice(index, 1);
                  }
                });
                that.mode = "watch";
              }
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user2, 2, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user3, 3, giveNum, that);
                  players.splice(index, 1);
                }
              });
              players.forEach(function (item, index) {
                if (giveNum == item.sort) {
                  giveNum = that.$options.methods.giveLocationData(item, index, that.user4, 4, giveNum, that);
                  players.splice(index, 1);
                }
              });
              console.log("玩家", players);

              var cards = [],
                  cardsNum = that.cardsNum;
              for (var i = 1; i <= cardsNum; i++) {
                var url = "",
                    style = "";
                if (i < 10) url = that.isUrl + that.imgUrl + "card_0" + i + ".png";else url = that.isUrl + that.imgUrl + "card_" + i + ".png";
                var z = (that.cardsNum - i) / 8;

                style = "transform: translate3d(" + z + "px, " + z + "px, " + z + "px);";
                var card = {
                  id: i,
                  url: url,
                  style: style
                };

                cards[i] = card;
              }
              that.allCards = cards;

              that.user1.cards = [];
              that.user2.cards = [];
              that.user3.cards = [];
              that.user4.cards = [];

              var _userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
              if (!_userCards) {
                that.$message({
                  message: "カード情報に誤りがあるため、ゲームを再起動してください",
                  type: "error"
                });
              }

              var newCards = [],
                  noCards = [];
              playerIds.forEach(function (key) {
                var cardLists = _userCards[key],
                    userCard = [];
                cardLists.forEach(function (item, index) {
                  noCards.push(item);
                });

                cards.forEach(function (item, index) {
                  if (cardLists.indexOf(item.id) >= 0) {
                    userCard.push(item);
                  }
                });
                if (key == that.user1.id) that.user1.cards = userCard;
                if (key == that.user2.id) that.user2.cards = userCard;
                if (key == that.user3.id) that.user3.cards = userCard;
                if (key == that.user4.id) that.user4.cards = userCard;
                if (key == that.user5.id) that.user5.cards = userCard;
                if (key == that.user6.id) that.user6.cards = userCard;
              });

              cards.forEach(function (item, index) {
                if (noCards.indexOf(item.id) < 0) {
                  newCards.push(item);
                }
              });

              that.cards = newCards;
            }
            num++;
          }
        });
      });
      that.$options.methods.createSocket(code, email);
    },

    giveLocationData: function giveLocationData(item, index, obj, location, giveNum, e) {
      if (item.sort < e.info.peopleNumber) {
        giveNum = item.sort + 1;
      } else {
        giveNum = 1;
      }
      obj.email = item.email;
      obj.id = item.id;
      obj.username = item.username;
      obj.nickname = item.nickname;
      obj.realname = item.realname;
      obj.lineStatus = item.lineStatus;
      obj.sort = item.sort;
      obj.tag = item.tag;
      obj.location = location;
      obj.isSkip = item.isSkip;
      e.users2.forEach(function (item2, index2) {
        if (item2.id == item.id) {
          e.users2[index2].location = location;
        }
      });
      return giveNum;
    },

    getCards: function getCards() {
      var cards = [],
          that = this,
          cardsNum = that.cardsNum;
      for (var i = 1; i <= cardsNum; i++) {
        var url = "";
        if (i < 10) url = that.imgUrl + "card_0" + i + ".png";else url = that.imgUrl + "card_" + i + ".png";
        var card = {
          id: i,
          url: url
        };

        cards[i] = card;
      }

      that.user1.cards = [];
      that.user2.cards = [];
      that.user3.cards = [];
      that.user4.cards = [];

      var userCards = localStorage.getItem("room_usercards" + that.roomId) ? JSON.parse(localStorage.getItem("room_usercards" + that.roomId)) : "";
      if (!userCards) {
        that.$message({
          message: "カード情報に誤りがあるため、ゲームを再起動してください",
          type: "error"
        });
      }

      var newCards = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards).forEach(function (key) {
        var cardLists = userCards[key],
            userCard = [];
        cards.forEach(function (item, index) {
          if (cardLists.indexOf(item.id) >= 0) {
            userCard.push(item);
          } else {
            newCards.push(item);
          }
        });
        if (key == that.user1.id) that.user1.cards = userCard;
        if (key == that.user2.id) that.user2.cards = userCard;
        if (key == that.user3.id) that.user3.cards = userCard;
        if (key == that.user4.id) that.user4.cards = userCard;
        if (key == that.user5.id) that.user5.cards = userCard;
        if (key == that.user6.id) that.user6.cards = userCard;
      });

      newCards.sort(function () {
        return Math.random() - 0.5;
      });
      that.cards = newCards;
    },

    shuffle: function shuffle() {
      var that = this;
      var cards = that.cards;

      var cardBoxObj = that.$refs.gamecardslists,
          cardLists = that.$refs.gamecardslists.children;
      cards.sort(function () {
        return Math.random() - 0.5;
      });
      cards.forEach(function (item, index) {
        var cardObj = cardLists[index],
            z = (that.cardsNum - index) / 8;

        cardObj.style["transform"] = "translate3d(" + z + "px, " + z + "px, -" + z + "px)";
      });
    },
    translate: function translate(a, b, c) {
      c = c || 0;
      if (has3d) {
        return "translate3d(" + a + ", " + b + ", " + c + ")";
      } else {
        return "translate(" + a + ", " + b + ")";
      }
    },

    extractCard: function extractCard(item, index) {
      var that = this;
      that.csh();
      console.log("that.userInfo", that.userInfo);
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == true) {
        console.log("操作を禁止しています1");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log(that.userInfo);
        console.log(that.userInfo.sort);
        console.log(that.playUser);
        console.log("操作を禁止しています2");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      that.discardCardInfo = {};

      var noCreatNum = [];
      that.cards.forEach(function (card, id) {
        noCreatNum.push(card.id);
      });
      console.log(noCreatNum);
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        noCreatNum: noCreatNum,

        operateType: 1,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    extractCardFromDiscards: function extractCardFromDiscards(item, index, location, event, discard, username) {
      var that = this;
      that.discardCardInfo = {};
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.extracting == true) {
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
        return false;
      }
      that.csh();
      var user1id = [];
      for (var i = 0; i < that.user1.cards.length; i++) {
        user1id.push(that.user1.cards[i].id);
      }
      if (user1id.indexOf(item.id) != -1) {
        that.$message({
          message: "既にこのカードを持っています",
          type: "error"
        });
        return;
      }
      var array = discard;
      for (var _i21 = 0; _i21 < array.length; _i21++) {
        if (_i21 == index) {
          if (array[_i21].checked == false) {
            array[_i21].checked = true;
            that.discardCardInfo = {
              location: location,
              index: index,
              id: item.id,
              url: item.url
            };
          } else {
            array[_i21].checked = false;
            that.discardCardInfo = {};
          }
        } else {
          array[_i21].checked = false;
        }
      }
      console.log(array);
      if (username == "user1") {
        that.user1.discard = array;
        console.log("s", that.user1.discard);
      }
      var newCard = that.discardCardInfo;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);

      var data = {
        foldNumber: "",
        number: newCard.id,
        operateType: 3,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    changeOtherCard: function changeOtherCard(item, index, event, location, cards, player) {
      var that = this;
      var user1id = [];
      for (var i = 0; i < that.user1.cards.length; i++) {
        user1id.push(that.user1.cards[i].id);
      }
      if (user1id.indexOf(item.id) != -1) {
        that.$message({
          message: "既にこのカードを持っています",
          type: "error"
        });
        return;
      }
      if (that.extracting == true) {
        return false;
      }
      that.csh();
      if (player == "user2") {
        for (var _i22 = 0; _i22 < cards.length; _i22++) {
          if (index == _i22) {
            if (cards[_i22].checked == true) {
              cards[_i22].checked = false;
            } else {
              cards[_i22].checked = true;
            }
          } else {
            cards[_i22].checked = false;
          }
        }
        that.user2.cards = cards;
      } else if (player == "user3") {
        for (var _i23 = 0; _i23 < cards.length; _i23++) {
          console.log(_i23);
          if (index == _i23) {
            if (cards[_i23].checked == true) {
              cards[_i23].checked = false;
            } else {
              cards[_i23].checked = true;
            }
          } else {
            cards[_i23].checked = false;
          }
        }
        that.user3.cards = cards;
      } else if (player == "user4") {
        for (var _i24 = 0; _i24 < cards.length; _i24++) {
          console.log(_i24);
          if (index == _i24) {
            if (cards[_i24].checked == true) {
              cards[_i24].checked = false;
            } else {
              cards[_i24].checked = true;
            }
          } else {
            cards[_i24].checked = false;
          }
        }
        that.user4.cards = cards;
      }
      if (that.info.isCopy == "あり") {
        var data = {
          number: item.id,
          operateType: 2,
          url: that.info.url,
          userId: that.userId,
          username: that.userEmail,
          roomId: that.roomId
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
      } else {}
    },

    changeSelfCard: function changeSelfCard(item, index, event, location) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        that.$message({
          message: "観戦中",
          type: "error"
        });
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");

        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }

      var newCard = {},
          oldCard = that.user1.cards[index],
          discardType = 0;

      if (that.extractCardInfo.id) {
        discardType = 1;
      } else if (that.discardCardInfo.id) {
        discardType = 2;
      } else if (that.copiedcard.id) {
        discardType = 3;
      }
      if (discardType == 0) {
        console.log("操作を禁止しています");

        return false;
      }

      if (discardType == 3) {
        if (location == 1) {
          newCard = that.copiedcard;
          var temp = [];
          temp.push(that.user1);
          temp.push(that.user2);
          temp.push(that.user3);
          temp.push(that.user4);
          var data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
        }
      } else {
        if (location == 1) {
          newCard = that.extractCardInfo;
          var _temp8 = [];
          _temp8.push(that.user1);
          _temp8.push(that.user2);
          _temp8.push(that.user3);
          _temp8.push(that.user4);
          var _data = {
            number: item.id,
            operateType: 10,
            url: that.info.url,
            userId: that.userId,
            username: that.userEmail
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(_data);
        }
      }
    },

    discardCard: function discardCard(location, event) {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.extracting == false) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      var newCard = that.extractCardInfo;
      that.$options.methods.addDiscardCard(newCard, location, that);
      if (that.cards.length == 0) {
        that.dialogFinishVisible = true;
      }
    },

    addDiscardCard: function addDiscardCard(card, location, e) {
      var that = this;
      console.log("roomid", e.roomId);
      console.log(e);
      var arr = [];
      var syc = {};
      var temp = [];
      temp.push(e.user1);
      temp.push(e.user2);
      temp.push(e.user3);
      temp.push(e.user4);
      syc.temp = temp;
      syc.countdown = e.userTimes;
      syc.gameTime = e.gameTimes;
      syc.pk = e.cards;
      syc.users2 = e.users2;
      arr.push(syc);
      var ids = [];
      e.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: e.userId,
        roomId: e.roomId,
        username: e.userEmail,
        userIds: ids,
        customize: arr,
        url: e.info.url
      };

      var data = {
        foldNumber: card.id,
        operateType: 4,
        url: e.info.url,
        userId: e.userId,
        username: e.userEmail,
        roomId: e.roomId,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp)
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    delDiscardCard: function delDiscardCard(card, location, e) {
      switch (location) {
        case 1:
          e.user1.discard.splice(card.index, 1);
          break;
        case 2:
          e.user2.discard.splice(card.index, 1);
          break;
        case 3:
          e.user3.discard.splice(card.index, 1);
          break;
        case 4:
          e.user4.discard.splice(card.index, 1);
          break;
        case 5:
          e.user5.discard.splice(card.index, 1);
          break;
        case 6:
          e.user6.discard.splice(card.index, 1);
          break;
      }
    },

    copyCard: function copyCard() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.play == false) {
        that.$message({
          message: "ゲームが中断中です",
          type: "error"
        });
      }
      if (that.extracting = true) {
        that.$message({
          message: "已抽牌，请选择替换手牌",
          type: "error"
        });
      }
    },
    reStart: function reStart() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 11,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        roomId: that.roomId,
        customize: temp
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    discard_hover: function discard_hover(e) {
      var target = e.target.parentNode;
      var viewportOffset = target.getBoundingClientRect();
      var parent_viewport = target.parentNode.getBoundingClientRect();

      if (target.style.position === 'fixed') {
        return;
      }
      var top = parent_viewport.top;
      var left = parent_viewport.left;

      var cls = target.className;
      if (cls.indexOf('cardl') !== -1 || cls.indexOf('cardr') !== -1) {
        var w = Number(target.offsetWidth);
        var h = Number(target.offsetHeight);
        top -= (h - w) / 2;
        left += (h - w) / 2;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target.style, { position: 'fixed', left: left + 'px', top: top + 'px' });
    },
    discard_leave: function discard_leave(e) {
      var target = e.target.parentNode;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(target.style, { position: 'relative', left: 0 + 'px', top: 0 + 'px' });
    },

    dragscroll: function dragscroll(e) {
      var el = e.currentTarget.parentElement;
      var disX = e.clientX;

      var disY = e.clientY;
      var originalScrollLeft = el.scrollLeft;
      var originalScrollTop = el.scrollTop;
      var originalScrollBehavior = el.style["scroll-behavior"];
      var originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
      document.onmousemove = function (e) {
        e.preventDefault();
        var distanceX = e.clientX - disX;
        var distanceY = e.clientY - disY;
        el.scrollTo(originalScrollLeft - distanceX, originalScrollTop - distanceY);

        el.style["pointer-events"] = "none";
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
        el.style["scroll-behavior"] = originalScrollBehavior;
        el.style["pointer-events"] = originalPointerEvents;
      };
    },
    dragscrollTouchStart: function dragscrollTouchStart(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      that.touch.disX = touch.clientX;

      that.touch.disY = touch.clientY;
      that.touch.originalScrollLeft = el.scrollLeft;
      that.touch.originalScrollTop = el.scrollTop;
      that.touch.originalScrollBehavior = el.style["scroll-behavior"];
      that.touch.originalPointerEvents = el.style["pointer-events"];
      el.style["scroll-behavior"] = "auto";
    },
    dragscrollTouchMove: function dragscrollTouchMove(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      var touch = e.targetTouches[0];
      var distanceX = touch.clientX - that.touch.disX;
      var distanceY = touch.clientY - that.touch.disY;
      el.scrollTo(that.touch.originalScrollLeft - distanceX, that.touch.originalScrollTop - distanceY);

      el.style["pointer-events"] = "none";
    },
    dragscrollTouchEnd: function dragscrollTouchEnd(e) {
      var that = this;
      var el = e.currentTarget.parentElement;
      document.ontouchmove = null;
      document.ontouchend = null;
      el.style["scroll-behavior"] = that.touch.originalScrollBehavior;
      el.style["pointer-events"] = that.touch.originalPointerEvents;
    },

    getRoomDetail: function getRoomDetail() {
      var that = this,
          roomId = that.roomId;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
        if (res) {
          if (res.code == 200 && res.result) {
            that.info = {
              homeowner: res.result.homeownerId,
              roomName: res.result.roomName,
              homeownerName: res.result.homeownerName,
              startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
              theme: res.result.theme,
              isCopy: res.result.isCopy == 1 ? "あり" : "なし",
              isPublic: res.result.isPublic,
              peopleNumber: res.result.peopleNumber,
              url: res.result.url
            };
            that.userTimes = res.result.turnTime;
            that.countsNumber = res.result.turnTime;
            that.gemePeople = res.result.peopleNumber;
            var pb = res.result.isPublic == 1 ? "公開" : "非公開";
            var copyInfo = res.result.homeownerName + "さんからの招待です。\n \n 以下から参加できます。\n URL: " + res.result.url + " \n \n パスワード：" + res.result.password + " \n \n ・ゲーム情報 \n ホスト名：" + res.result.homeownerName + "\n ルーム名：" + res.result.roomName + "\n 開始時刻：" + res.result.startTime + "\n \n ・ゲーム設定" + "\n 主题：" + res.result.theme + "\n 人数：" + res.result.peopleNumber + "\n 手札公開：" + pb + "\n 复制功能：" + res.result.isCopy;
            that.copyInfo = copyInfo;

            if (that.userId == res.result.homeownerId) that.isHomewer = true;

            var code = res.result.url;

            that.giveLocation(code, that.userEmail);
          }
        }
      });
    },

    getUserInfo: function getUserInfo() {
      var that = this,
          token = localStorage.getItem("Authorization");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
        console.log("userinfo", res.result);
        if (res) {
          that.userInfo = res.result;
        }
      });
    },

    doTimeOut: function doTimeOut() {
      var that = this;
      that.dialogPauseVisiblePre = true;
    },

    doPause: function doPause() {
      var that = this;
      that.dialogPauseVisiblePre = false;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    noDoTimeOut: function noDoTimeOut() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.dialogFinishVisible = true;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 5,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: temp,
        roomId: that.roomId
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    doSelfSkip: function doSelfSkip() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      if (that.userInfo.sort != that.playUser) {
        console.log("操作を禁止しています");
        return false;
      }
      that.dialogSkipVisiblePre = true;
    },

    doPass: function doPass() {
      var that = this;
      that.dialogSkipVisiblePre = false;
      var arr = [];
      var syc = {};
      var temp = [];
      var ids = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      syc.temp = temp;
      syc.countdown = that.userTimes;
      syc.gameTime = that.gameTimes;
      syc.pk = that.cards;
      syc.users2 = that.users2;
      arr.push(syc);
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          ids.push(item.id);
        }
      });
      var next = {
        operateType: 12,
        userId: that.userId,
        roomId: that.roomId,
        username: that.userEmail,
        userIds: ids,
        customize: arr,
        url: that.info.url
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(next);
    },

    doPlay: function doPlay() {
      var that = this;
      if (that.mode == "watch") {
        console.log("観戦中");
        return false;
      }
      that.play = true;
    },

    doSet: function doSet() {
      this.dialogSettingVisible = true;
    },

    toFinish: function toFinish() {
      this.dialogFinishVisible = true;
    },

    doFinish: function doFinish() {
      var that = this;
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      var data = {
        operateType: 8,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        customize: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(temp),
        roomId: that.roomId,
        turnTime: that.gameTimes.minute * 60 + that.gameTimes.second
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_api_js__["g" /* gamesOperate */])(data).then(function (res) {
        if (res && res.code == 200) {
          var result = {
            minute: that.gameTimes.minute,
            second: that.gameTimes.second
          };
          var users = [];
          if (that.user1.id) users.push(that.user1);
          if (that.user2.id) users.push(that.user2);
          if (that.user3.id) users.push(that.user3);
          if (that.user4.id) users.push(that.user4);
          if (that.user5.id) users.push(that.user5);
          if (that.user6.id) users.push(that.user6);
          result.users = users;
        }
      });
    },

    toGame: function toGame() {
      this.dialogFinishVisible = false;
      this.dialogSettingVisible = false;
      this.reStart();
    },

    toSkip: function toSkip() {
      this.dialogSkipVisible = true;
      this.dialogSettingVisible = false;
    },

    checkUser: function checkUser(item, index, checked) {
      var that = this;
      if (checked) {
        that.users2[index].checked = false;
      } else {
        that.users2[index].checked = true;
      }
    },

    doSkip: function doSkip() {
      var that = this;
      var ids = [];
      var names = [];
      var cur = "";
      that.users2.forEach(function (item, index) {
        if (item.checked == true) {
          console.log(item);
          ids.push(item.id);
          names.push(item.username);
        }
        if (item.sort == that.playUser) {
          console.log(item);
          cur = item.id;
        }
      });
      var data = {
        operateType: 6,
        url: that.info.url,
        userId: cur,
        username: names[0],
        userIds: ids,
        usernames: names,
        currentUserId: cur
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
      that.dialogSkipVisible = false;
    },

    cancelSkip: function cancelSkip(name, id, location) {
      var that = this;
      var s = [];
      var n = [];
      var temp = [];
      temp.push(that.user1);
      temp.push(that.user2);
      temp.push(that.user3);
      temp.push(that.user4);
      s.push(id);
      n.push(name);
      var data = {
        operateType: 7,
        url: that.info.url,
        userId: that.userId,
        username: that.userEmail,
        userIds: s,
        usernames: n
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_websocket_js__["b" /* sendWSPush */])(data);
    },

    countDown: function countDown() {
      var that = this,
          times = that.userTimes;
      that.timer = setInterval(function () {
        that.userTimes--;
      }, 1000);
    },

    goTimes: function goTimes() {
      var that = this;
      that.timer2 = setInterval(function () {
        that.gameTimes.second++;
        if (that.gameTimes.second == 60) {
          that.gameTimes.second = 0;
          that.gameTimes.minute++;
        }
        that.gameTimes.str = that.$options.methods.toDub(that.gameTimes.minute) + ":" + that.$options.methods.toDub(that.gameTimes.second);
      }, 1000);
    },

    toDub: function toDub(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    }
  })
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      isUrl: "https",
      roomId: "",
      room: {},
      timeStr: "",
      users: []
    };
  },

  components: {},
  created: function created() {
    this.roomId = this.$route.query.roomId;
    this.userId = localStorage.getItem("homeowner");
    this.userEmail = localStorage.getItem("userEmail");
    this.getRoom(this.roomId);

    var data = JSON.parse(localStorage.getItem("room_result_" + this.roomId));
    console.log('created:', data);
    if (data.minute > 0) this.timeStr = data.minute + "分";
    this.timeStr += data.second + "秒";
    this.users = data.users;

    if (localStorage.getItem("addResultParamList")) this.addRe();
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("beforeunload", function (e) {
      return _this.beforeunloadHandler(e);
    });
  },

  methods: {
    getRoom: function getRoom(id) {
      var _this2 = this;

      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["a" /* getRoomDetail */])(id).then(function (res) {
        console.log(res);
        if (res.code == 200) {
          _this2.room = res.result;
        }
      });
    },

    toRoom: function toRoom(id) {
      var that = this;
      that.$router.push({
        path: "/room/info",
        params: {
          roomId: id
        }
      });
    },
    addRe: function addRe() {
      var addResultParamList = localStorage.getItem("addResultParamList");
      var data = JSON.parse(addResultParamList);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["k" /* addGameRecord */])(data).then(function (res) {
        console.log('addRe', res);
        if (res.code == 200) {
          console.log("提交成功");
          localStorage.removeItem("addResultParamList");
        }
      });
    },

    toMy: function toMy() {
      localStorage.removeItem("room_result_" + this.roomId);
      this.$router.push("/my");
    },
    fenxi: function fenxi(e) {
      var str = "";
      for (var i = 0; i < e.cards.length; i++) {
        if (i == e.userCard.length - 1) {
          str += e.userCard[i];
        } else {
          str += e.userCard[i] + ",";
        }
      }
      console.log(str);
      this.$router.push({
        path: "/game/analysis",
        query: {
          id: str
        }
      });
    }
  }
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_echarts_vue__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_echarts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_echarts_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      isUrl: '',
      roomId: '',
      idx: 0,
      timeStr: '',
      users: [],
      width: "32rem",
      height: "32rem",
      id: "rad",
      ids: "",
      details: [{
        title: "専門",
        inner: "専門知識力",
        text1: "自身の専門分野において、知識・技能を高めることが好き。その力を発揮することで人の役に立ち、頼ってもらえる存在になることに価値を感じます。",
        text2: "モチベーションが上がる言葉「頼りにしてます！」"
      }, {
        title: "組織",
        inner: "リーダーシップ力",
        text1: "仲間とともに勝利や達成目標を目指すことが好き。組織において、周囲を鼓舞し統率することで共通の目的を成しえることに価値を感じます。",
        text2: "モチベーションが上がる言葉「ついていきます！」"
      }, {
        title: "独自",
        inner: "独自性発揮力",
        text1: "指示や束縛を受けず、自身の考えで筋道や方法を考えるのが好き。自分の信念をもって仕事を完遂させ、周囲を納得させることに価値を感じます。",
        text2: "モチベーションが上がる言葉「あなたに任せます！」"
      }, {
        title: "安心、安定",
        inner: "確実的安定力",
        text1: "将来に不安のない安心できる状態が好き。目的が明確で、繰り返すこと、続けることで確実に成果が得られる心に余裕をもって就ける仕事に価値を感じます。",
        text2: "モチベーションが上がる言葉「大丈夫です！」"
      }, {
        title: "創造",
        inner: "新規事業創造力",
        text1: "自らの着眼や発想で新しいものを生み出すことが好き。これまでにないユニークな商品やサービスの開発などで、世の中に画期的な変化をもたらす活動に価値を感じます。",
        text2: "モチベーションが上がる言葉「こんなの初めて！」"
      }, {
        title: "社会貢献",
        inner: "社会的貢献力",
        text1: "困っている人への手助けを行い、喜んでもらえることが好き。世の中をよりよくするための活動に尽力・協力し、他者を救う社会活動に携わることに価値を感じます。",
        text2: "モチベーションが上がる言葉「感謝しています！」"
      }, {
        title: "挑戦、問題解決",
        inner: "挑戦的解決力",
        text1: "目の前にある困難な状況に挑み、解決することが好き。これまで解決に至っていない社会や事業上の問題を克服し、新たな道筋を切り拓くことに価値を感じます。",
        text2: "モチベーションが上がる言葉「チャレンジですね！」"
      }, {
        title: "自然体",
        inner: "合理的柔軟力",
        text1: "仕事も日々の暮らしも自然体で柔軟にこなすことが好き。合理性も踏まえながら、暮らしと仕事をうまく融合し、相乗効果でよりよい結果を出すことに価値を感じます。",
        text2: "モチベーションが上がる言葉「いい感じですね！」"
      }, {
        title: "伝達",
        inner: "伝達表現力",
        text1: "自身のパフォーマンスで、人を喜ばせることが好き。物事の事象やメッセージを自身の好みの表現方法で、人に伝え、心を揺り動かすことに価値を感じます。",
        text2: "モチベーションが上がる言葉「感動しました！」"
      }]
    };
  },

  components: {
    echarts: __WEBPACK_IMPORTED_MODULE_0__components_echarts_vue___default.a
  },
  created: function created() {
    console.log(this.$route.query.id);
    this.ids = this.$route.query.id;
    this.roomId = this.$route.query.roomid;
  },
  mounted: function mounted() {},

  methods: {
    toRoom: function toRoom(id) {
      var that = this;
      that.$router.push({
        path: '/room/info',
        params: {
          roomId: id
        }
      });
    },
    toMy: function toMy() {
      var that = this;
      this.$router.push({ path: '/room/resu', query: { roomId: that.roomId } });
    },
    choose: function choose(e) {
      var that = this;
      that.idx = e;
    }
  }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    var _this = this;

    var passwordValidator = function passwordValidator(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error("6文字以上のパスワードを入力"));
      } else {
        callback();
      }
    };
    var repasswordValidator = function repasswordValidator(rule, value, callback) {
      if (value === "") {
        callback(new Error("確認のためパスワードを再入力"));
      } else if (value !== _this.passForm.password) {
        callback(new Error("パスワードが一致していません!"));
      } else {
        callback();
      }
    };
    return {
      region: this.GLOBAL.region,
      job: this.GLOBAL.job,
      sexBox: this.GLOBAL.sexBox,
      dialogFormVisible: false,
      choosedate: 30,

      ruleForm: {
        realname: "",
        falsename: "",
        nickname: "",
        sex: 0,
        year: "",
        month: "",
        day: "1",
        birthday: "",
        address: "",
        job: "",
        email: "",
        password: "",
        repassword: ""
      },
      rules: {
        realname: [{
          required: true,
          message: "お名前を入力",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (/^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf-\u0009\u0020\u00A0\u2002-\u200B\u3000\uFEFF]+$/.test(value) == true || /^[a-zA-Z]+$/.test(value) == true || /^[(?!."#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~)]+$/.test(value) == true || value.trim().includes(" ") || value.trim().includes(" ") || value.trim().includes(" ")) {
              callback();
            } else {
              return callback(new Error("お名前を入力してください"));
            }
          },
          trigger: "blur"
        }],
        falsename: [{
          required: true,
          message: "フリガナを入力",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (/^[\u30A1-\u30F6\u30FC]+$/.test(value) == true || /^ [\uFF66-\uFF9F]+$/.test(value) == true || value.trim().includes(" ") || value.trim().includes("　")) {
              callback();
            } else {
              return callback(new Error("カタカナを入力してください"));
            }
          },
          trigger: "blur"
        }],
        nickname: [{ required: true, message: "ニックネームを入力", trigger: "blur" }],
        sex: [{
          required: true,
          message: "性別を選択してください",
          trigger: "change"
        }],
        year: [{
          required: true,
          message: "年を選択してください",
          trigger: "change"
        }],
        month: [{
          required: true,
          message: "月を選択してください",
          trigger: "change"
        }],
        day: [{
          required: true,
          message: "日を選択してください",
          trigger: "change"
        }],
        address: [{
          required: true,
          message: "都道府県を選択",
          trigger: "change"
        }],
        job: [{
          required: true,
          message: "職業を選択",
          trigger: "change"
        }],
        email: [{
          type: "email",
          required: true,
          message: "メールアドレスを入力",
          trigger: "blur"
        }]
      },
      passForm: {
        oldpassword: "",
        password: "",
        confirmpassword: "" },
      passRules: {
        oldpassword: [{ required: true, message: "元のパスワード", trigger: "blur" }],
        password: [{
          required: true,
          message: "6文字以上のパスワードを入力",
          validator: passwordValidator,
          trigger: "blur"
        }],
        confirmpassword: [{
          required: true,
          validator: repasswordValidator,
          message: "確認のためパスワードを再入力",
          trigger: "blur"
        }]
      },
      id: "",
      isSocial: false,
      socialType: null
    };
  },

  components: {},
  mounted: function mounted() {
    this.getUserInfo();
  },

  methods: {
    monthChange: function monthChange(e) {
      console.log(e);
      var that = this;
      var year = that.ruleForm.year;
      if (year % 100 != 0 && year % 4 == 0 || year % 400 == 0) {
        if (e == 1 || e == 3 || e == 5 || e == 7 || e == 8 || e == 10 || e == 12) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 29;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      } else {
        if (e == 1 || e == 3 || e == 5 || e == 7 || e == 8 || e == 10 || e == 12) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 28;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      }
    },

    getUserInfo: function getUserInfo() {
      var that = this,
          userId = localStorage.getItem("homeowner");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["e" /* getUserInfoById */])(userId).then(function (res) {
        console.log(res);
        if (res) {
          that.id = res.result.id;
          if (res.result.sex === null) {
            that.isSocial = true;
          }
          that.socialType = res.result.thirdType;
          var birthday = new Date(res.result.birthday);
          that.ruleForm = {
            realname: that.isSocial ? that.socialType == "google" ? "" : res.result.realname : res.result.realname,
            falsename: res.result.falsename,
            nickname: that.isSocial ? "" : res.result.nickname,
            sex: res.result.sex,
            year: birthday.getFullYear(),
            month: birthday.getMonth() + 1,
            day: 1,
            address: res.result.address,
            job: res.result.job,
            email: that.isSocial ? that.socialType == "google" ? res.result.email : "" : res.result.email };
        }
      });
    },
    changePass: function changePass() {
      this.dialogFormVisible = true;
    },
    doChangePass: function doChangePass(formName) {
      var that = this;
      var data = that.passForm;
      that.$refs[formName].validate(function (valid) {
        if (valid) {
          var formData = {
            oldpassword: data.oldpassword,
            password: data.password,
            confirmpassword: data.confirmpassword
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["A" /* changPassword */])(formData).then(function (res) {
            console.log(res);
            if (res) {
              that.$message({
                message: "パスワードを再設定しました",
                type: "success",
                onClose: function onClose() {
                  that.dialogFormVisible = false;
                }
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toMy: function toMy() {
      this.$router.push("/my");
    },
    doSub: function doSub(formName) {
      var that = this;
      var data = that.ruleForm;
      var email = data.email;
      console.log("www");
      var reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (reg.test(email)) {
        console.log("验证成功");
      } else {
        console.log("邮箱認証に失敗しました");
        return false;
      }
      console.log(that);

      that.$refs[formName].validate(function (valid) {
        console.log("valid", valid);
        if (valid) {
          var formData = {
            id: that.id,
            realname: data.realname,
            falsename: data.falsename,
            nickname: data.nickname,
            sex: data.sex,
            birthday: data.year + "-" + data.month + "-" + data.day,
            address: data.address,
            job: data.job,
            email: data.email,
            password: data.password ? data.password : "" };
          console.log(formData);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["B" /* editUserInfo */])(formData).then(function (res) {
            if (res.code == 200) {
              that.$message({
                message: "データは正しく保存されました",
                type: "success"
              });
              console.log(res);
              that.$router.push("/my");
            } else {
              if (res.message != null && res.message != "") {
                that.$message({
                  message: res.message,
                  type: "error"
                });
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_global_js__ = __webpack_require__(47);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "login",
	data: function data() {
		return {
			form: {
				username: "",
				password: "",
				login: false
			},
			time: 60,
			timeShow: false,
			aginPass: "",
			newPass: "",
			yzm: "",
			phone: "",
			shows: 0,
			invite: "",
			code: "",
			email: "",
			vyzm: "",
			thirdType: null
		};
	},

	components: {},
	beforeCreate: function beforeCreate() {
		var that = this;
		var token = that.$route.query.token;
		if (token) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["F" /* otherLogin */])(token).then(function (res) {
				if (res.code == 200) {
					that.changeLogin({
						Authorization: res.result.token,
						homeowner: res.result.userInfo.id,
						userEmail: res.result.userInfo.email,
						userName: res.result.userInfo.username
					});
					that.$message({
						message: "ログインしました",
						type: "success",
						onClose: function onClose() {
							if (that.invite && that.code) {
								that.$router.push({
									path: "/room/info",
									query: {
										invite: that.invite,
										code: that.code
									}
								});
							} else {
								var _token = localStorage.getItem("Authorization");
								__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["f" /* getUserInfo */])(_token).then(function (_res) {
									if (_res) {
										if (_res.result.sex === null) that.$router.push("/info");else that.$router.push("/my");
									}
								});
							}
						}
					});
				}
			});
		}
	},
	created: function created() {
		this.invite = this.$route.query.invite;
		this.code = this.$route.query.code;
		document.addEventListener("keyup", this.ss);
	},
	beforeUnmount: function beforeUnmount() {
		console.log('de;e');
		document.removeEventListener("keyup", this.ss);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(["changeLogin"]), {
		ss: function ss(e) {
			var that = this;
			if (e.keyCode == 13) {
				that.doLogin();
				document.removeEventListener("keyup", this.ss);
			}
		},
		hidemask: function hidemask() {
			this.shows = 0;
		},

		doLogin: function doLogin() {
			var _this = this;

			var that = this;
			var data = this.form;
			if (!data.username) {
				that.$message({
					message: "メールアドレスを入力してください",
					type: "warning"
				});
				return false;
			}
			if (!data.password) {
				that.$message({
					message: "パスワードを入力してください",
					type: "warning"
				});
				return false;
			}
			console.log(data);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["D" /* doLogin */])(data).then(function (res) {
				if (res) {
					console.log(res.result.token);
					document.removeEventListener("keyup", _this.ss);
					that.changeLogin({
						Authorization: res.result.token,
						homeowner: res.result.userInfo.id,
						userEmail: res.result.userInfo.email,
						userName: res.result.userInfo.username
					});
					if (that.invite && that.code) {
						that.$router.push({
							path: "/room/info",
							query: {
								invite: that.invite,
								code: that.code
							}
						});
					} else {
						that.$router.push("/my");
					}
				}
			});
		},
		sendEmail: function sendEmail() {
			var _this2 = this;

			var that = this;
			if (that.phone == "") {
				that.$message({
					message: 'メールアドレスを入力してください。',
					type: "warning"
				});
			} else {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["G" /* getUserInfoByEmail */])(that.phone.trim()).then(function (res) {
					console.log(res);
					if (res.code == 200 && res.result) {
						that.thirdType = res.result.thirdType;
						if (that.thirdType == null) {
							var data = {};
							data.to = that.phone.trim();
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["H" /* sendCode */])(data).then(function (res) {
								console.log(res);
								if (res.code == 200) {
									that.$message({
										message: res.message,
										type: "success"
									});

									_this2.shows = 2;
								} else {
									that.$message({
										message: res.message,
										type: "warning"
									});
								}
							});
						} else {
							if (that.thirdType == 'facebook') {
								that.$message({
									message: '「Facebookでログイン」からログインしてください',
									type: "warning"
								});
							} else {
								that.$message({
									message: '「Googleでログイン」からログインしてください',
									type: "warning"
								});
							}
							that.shows = 0;
						}
					} else {
						that.$message({
							message: '登録されていないメールアドレスです',
							type: "error"
						});
					}
				});
			}
		},
		sendXin: function sendXin() {
			var that = this;
			if (that.yzm == "") {
				that.$message({
					message: '認証コードを入力してください。',
					type: "success"
				});
			} else {
				this.shows = 3;
			}
		},
		edit: function edit() {
			var that = this;
			var aginPass = that.aginPass;
			var newPass = that.newPass;
			var yzm = that.yzm;
			var phone = that.phone;
			var data = {};
			data.code = yzm;
			data.password = newPass;
			data.email = phone;
			if (aginPass != "" && newPass != "" && yzm != "" && phone != "") {
				if (aginPass == newPass) {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["I" /* changepwd */])(data).then(function (res) {
						console.log(res);
						if (res.code == 200) {
							that.shows = 0;
							that.$message({
								message: res.message,
								type: "success"
							});
						} else {
							that.$message({
								message: res.message,
								type: "warning"
							});
						}
					});
				} else {
					that.$message({
						message: "パスワードが間違っています",
						type: "warning"
					});
				}
			}
		},
		googleLogin: function googleLogin() {
			var that = this;
			window.open("https://" + __WEBPACK_IMPORTED_MODULE_3__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/oauth/render/google");
		},
		faceLogin: function faceLogin() {
			var that = this;
			window.open("https://" + __WEBPACK_IMPORTED_MODULE_3__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/oauth/render/facebook");
		},


		toReg: function toReg() {
			var that = this;
			document.removeEventListener("keyup", this.ss);
			that.$router.push({
				path: "/register",
				query: {
					invite: that.invite,
					code: that.code
				}
			});
		},

		sendVEmail: function sendVEmail() {
			var _this3 = this;

			var that = this;
			if (that.email == "") {
				that.$message({
					message: 'メールアドレスを入力してください。',
					type: "warning"
				});
			} else {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["G" /* getUserInfoByEmail */])(that.email.trim()).then(function (res) {
					console.log(res);
					if (res.code == 200 && res.result) {
						that.$message({
							message: 'すでに登録されたメールアドレスです',
							type: "error"
						});
					} else {
						var data = {};
						data.to = that.email;
						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["J" /* sendVCode */])(data).then(function (res) {
							console.log(res);
							if (res.code == 200) {
								that.$message({
									message: res.message,
									type: "success"
								});
								_this3.shows = 5;
							} else {
								that.$message({
									message: res.message,
									type: "warning"
								});
							}
						});
					}
				});
			}
		},
		sendVXin: function sendVXin() {
			var that = this;
			if (that.vyzm == "") {
				that.$message({
					message: '認証コードを入力してください。',
					type: "warning"
				});
			} else {
				var data = {};
				data.to = that.email;
				data.code = that.vyzm;
				localStorage.removeItem("vemail");
				localStorage.removeItem("vcode");
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["K" /* confirmCode */])(data).then(function (res) {
					console.log(res);
					if (res.code == 200) {
						that.$message({
							message: res.message,
							type: "success"
						});
						that.shows = 0;
						localStorage.setItem("vemail", that.email);
						localStorage.setItem("vcode", that.vyzm);
						that.$router.push("/register");
					} else {
						that.$message({
							message: res.message,
							type: "warning"
						});
					}
				});
			}
		}
	})
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_global_js__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      realname: '',
      nickname: '',
      su: 1,
      record: 0
    };
  },
  created: function created() {
    this.userName = localStorage.getItem('userName');
    this.gGamesRecord();
  },

  components: {},
  mounted: function mounted() {
    this.getUserInfo();
  },

  methods: {
    check: function check(id) {
      var that = this;
      var data = {};
      data.customerId = id;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["j" /* checkSubscribe */])(id).then(function (res) {
        console.log(res);
        if (res) {
          if (res.code == 200) {
            if (res.result.productListVO.priceCount) {
              that.su = 1;
              localStorage.setItem("plan", res.result.productListVO.name);
            } else {
              that.su = __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["b" /* revertFreePlan */] ? 0 : 1;
              localStorage.setItem("plan", "1on1プラン");
            }
          }
        } else {}
      });
    },
    gGamesRecord: function gGamesRecord() {
      var that = this;
      var id = localStorage.getItem('homeowner');
      console.log(id, "id");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["C" /* getUn */])(id).then(function (res) {
        if (res.code == 200) {
          that.record = res.result;
        }
      }).catch(function (err) {});
    },

    getUserInfo: function getUserInfo() {
      var that = this,
          userId = localStorage.getItem('homeowner');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["e" /* getUserInfoById */])(userId).then(function (res) {
        console.log(res);
        if (res) {
          localStorage.setItem("customerId", res.result.customerId);
          that.realname = res.result.realname;
          that.nickname = res.result.nickname;
          that.check(res.result.customerId);
        }
      });
    },
    goPage: function goPage(page) {
      this.$router.push(page);
    },
    toRecord: function toRecord() {
      var that = this;
      if (that.su == 1) {
        that.$router.push("/room/Logs");
      } else {
        that.$router.push("/pay/index");
      }
    },

    doLogout: function doLogout() {
      localStorage.removeItem('Authorization');
      localStorage.removeItem('homeowner');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userName');
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 427:
/***/ (function(module, exports) {



/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(52);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "register",
  data: function data() {
    var _this = this;

    var reemailValidator = function reemailValidator(rule, value, callback) {
      if (value === "") {
        callback(new Error("確認のためメールアドレスを再入力"));
      } else if (value !== _this.ruleForm.email) {
        callback(new Error("メールアドレスが一致していません"));
      } else {
        callback();
      }
    };
    var passwordValidator = function passwordValidator(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error("6文字以上のパスワードを入力"));
      } else {
        callback();
      }
    };
    var repasswordValidator = function repasswordValidator(rule, value, callback) {
      if (value === "") {
        callback(new Error("確認のためパスワードを再入力"));
      } else if (value !== _this.ruleForm.password) {
        callback(new Error("パスワードが一致していません!"));
      } else {
        callback();
      }
    };
    return {
      invite: "",
      code: "",
      region: this.GLOBAL.region,
      job: this.GLOBAL.job,
      sexBox: this.GLOBAL.sexBox,
      choosedate: 30,
      isVerify: false,
      ruleForm: {
        realname: "",
        falsename: "",
        nickname: "",
        sex: 0,
        year: "",
        month: "",
        day: "1",
        birthday: "",
        address: "",
        job: "",
        email: "",
        reemail: "",
        password: "",
        repassword: "",
        agree: false },
      rules: {
        realname: [{
          required: true,
          message: "お名前を入力",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (/^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf-\u0009\u0020\u00A0\u2002-\u200B\u3000\uFEFF]+$/.test(value) == true || /^[a-zA-Z]+$/.test(value) == true || /^[(?!."#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~)]+$/.test(value) == true || value.trim().includes(" ") || value.trim().includes(" ") || value.trim().includes(" ")) {
              callback();
            } else {
              return callback(new Error("お名前を入力してください"));
            }
          },
          trigger: "blur"
        }],
        falsename: [{
          required: true,
          message: "フリガナを入力",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (/^[\u30A1-\u30F6\u30FC]+$/.test(value) == true || /^ [\uFF66-\uFF9F]+$/.test(value) == true || value.trim().includes(" ") || value.trim().includes("　")) {
              callback();
            } else {
              return callback(new Error("カタカナを入力してください"));
            }
          },
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "ニックネームを入力",
          trigger: "blur"
        }],
        sex: [{
          required: true,
          message: "性別を選択してください",
          trigger: "change"
        }],
        year: [{
          required: true,
          message: "年を選択してください",
          trigger: "change"
        }],
        month: [{
          required: true,
          message: "月を選択してください",
          trigger: "change"
        }],
        day: [{
          required: true,
          message: "日を選択してください",
          trigger: "change"
        }],
        address: [{
          required: true,
          message: "都道府県を選択",
          trigger: "change"
        }],
        job: [{
          required: true,
          message: "職業を選択",
          trigger: "change"
        }],
        email: [{
          type: "email",
          required: true,
          message: "メールアドレスを入力",
          trigger: "blur"
        }],
        reemail: [{
          type: "email",
          required: true,
          validator: reemailValidator,
          message: "確認のためメールアドレスを再入力",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "6文字以上のパスワードを入力",
          validator: passwordValidator,
          trigger: "blur"
        }],
        repassword: [{
          required: true,
          validator: repasswordValidator,
          message: "確認のためパスワードを再入力",
          trigger: "blur"
        }]
      }
    };
  },

  components: {},
  created: function created() {
    this.invite = this.$route.query.invite;
    this.code = this.$route.query.code;
    if (localStorage.getItem("vemail") == null || localStorage.getItem("vcode") == null) {
      this.$router.push("/login");
    } else {
      this.isVerify = true;
      this.ruleForm.email = localStorage.getItem("vemail");
      this.ruleForm.reemail = localStorage.getItem("vemail");
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(["changeLogin"]), {
    toLogin: function toLogin() {
      this.$router.push("/login");
    },
    monthChange: function monthChange(e) {
      console.log(e);
      var that = this;
      var year = that.ruleForm.year;
      if (year % 100 != 0 && year % 4 == 0 || year % 400 == 0) {
        if (e == 1 || e == 3 || e == 5 || e == 7 || e == 8 || e == 10 || e == 12) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 29;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      } else {
        if (e == 1 || e == 3 || e == 5 || e == 7 || e == 8 || e == 10 || e == 12) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 28;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      }
    },
    doLogin: function doLogin() {
      var that = this;
      var data = this.ruleForm;
      var sendData = {};
      sendData.username = data.email;
      sendData.password = data.password;
      sendData.login = false;
      console.log(sendData);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_js__["D" /* doLogin */])(sendData).then(function (res) {
        if (res) {
          console.log(res.result.token);

          that.changeLogin({
            Authorization: res.result.token,
            homeowner: res.result.userInfo.id,
            userEmail: res.result.userInfo.email,
            userName: res.result.userInfo.username
          });
          if (that.invite && that.code) {
            that.$router.push({
              path: "/room/info",
              query: {
                invite: that.invite,
                code: that.code
              }
            });
          } else {
            that.$router.push("/my");
          }
        }
      });
    },

    doReg: function doReg(formName) {
      var that = this;
      var data = that.ruleForm;
      var email = data.email;
      var reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (reg.test(email)) {
        console.log("验证成功");
      } else {
        console.log("邮箱認証に失敗しました");
        return false;
      }
      console.log(that);
      that.$refs[formName].validate(function (valid) {
        console.log("valid", valid);
        if (valid) {
          if (!data.agree) {
            that.$message({
              message: "利用規約をご覧ください",
              type: "warning"
            });
            return false;
          }
          var formData = {
            realname: data.realname,
            falsename: data.falsename,
            nickname: data.nickname,
            sex: data.sex,
            birthday: data.year + "-" + data.month + "-" + data.day,
            address: data.address,
            job: data.job,
            email: data.email,
            password: data.password };
          var ret = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_js__["E" /* doReg */])(formData).then(function (res) {
            console.log(res);
            if (res.code == 200) {
              that.$message({
                message: "登録しました",
                type: "success"
              });
              console.log(that);
              that.doLogin();
            } else {
              that.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  })
});

/***/ }),

/***/ 429:
/***/ (function(module, exports) {



/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_websocket_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_global_js__ = __webpack_require__(47);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	data: function data() {
		return {
			isUrl: '',
			tags: this.GLOBAL.tags,

			roomId: 'c0e6b1e56ed0141b000650f2ec5232d9',
			userId: '1505124724596801538',
			userEmail: '2856678408@qq.com',
			info: {
				homeowner: '1505124724596801538',
				roomName: '测试房间1',
				homeownerName: '戸田勇大1',
				startTime: '2022-4-6 10:00',
				theme: '仕事',
				isCopy: false,
				isPublic: false,
				peopleNumber: 4,
				url: 'http://' + __WEBPACK_IMPORTED_MODULE_4__utils_global_js__["c" /* domain */] + '/#/room/info?invite=1505124724596801538&code=123456'
			},

			copyInfo: '',

			lists: [],

			checkLists: [],
			checkNum: 0 };
	},
	created: function created() {
		this.isUrl = this.GLOBAL.getHttps();
		this.roomId = this.$route.query.roomId;
		this.userId = localStorage.getItem('homeowner');
		this.userEmail = localStorage.getItem('userEmail');
		this.userName = localStorage.getItem('userName');

		this.checkNum = this.checkLists.length;
		this.getRoomDetail();
		console.log('roomId: ', this.roomId);
	},

	components: {},
	mounted: function mounted() {
		window.addEventListener('onmessageWS', this.getsocketData);
	},

	methods: {
		createSocket: function createSocket(code, userEmail) {
			var that = this;
			var wsUrl = '';
			var ishttps = 'https:' == document.location.protocol ? true : false;

			if (ishttps) wsUrl = "wss://" + __WEBPACK_IMPORTED_MODULE_4__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;else wsUrl = "ws://" + __WEBPACK_IMPORTED_MODULE_4__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_websocket_js__["a" /* createSocket */])(wsUrl);
		},
		deleteRoom: function deleteRoom() {
			var _this = this;

			var that = this;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_js__["t" /* delRoom */])(that.roomId).then(function (res) {
				console.log(res);
				if (res.code == 200) {
					localStorage.removeItem('room_' + _this.roomId);
					that.$message({
						message: res.message,
						type: 'success'
					});
					setTimeout(function () {
						that.$router.push("/");
					}, 1000);
				}
			});
		},

		getsocketData: function getsocketData(e) {
			console.log('getsocketData: ', e.detail.data);

			if (e.detail.data == '发生连接错误') return false;
			var data = JSON.parse(e.detail.data),
			    newUser = {},
			    isNew = true,
			    that = this;

			if (Array.isArray(data)) {
				for (var i = 0; i < data.length; i++) {
					data[i].checked = false;
				}
				that.lists = data;
			} else {
				data.checked = false;
				var keyExist = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).some(function (key) {
					return key == 'userId';
				});
				if (keyExist) {
					var found = that.lists.some(function (el) {
						return el.userId == data.userId;
					});
					if (!found) that.lists.push(data);
				}
			}
			console.log(that.lists);

			if (data.result && data.operateMsg == '游戏开始，向每位玩家分牌') {
				var userCards = JSON.parse(data.result);
				console.log("result", data.result);

				var playerIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards),
				    players = [],
				    count = playerIds.length;
				console.log('房间ID', that.roomId);
				console.log('储存内容', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.result));
				localStorage.setItem('room_usercards' + that.roomId, data.result);
				if (that.checkNum == 1) {
					that.$router.push({
						path: '/game/index1',
						query: {
							roomId: that.roomId
						}
					});
				} else if (that.checkNum == 2) {
					that.$router.push({
						path: '/game/index2',
						query: {
							roomId: that.roomId
						}
					});
				} else if (that.checkNum == 3) {
					that.$router.push({
						path: '/game/index3',
						query: {
							roomId: that.roomId
						}
					});
				} else if (that.checkNum == 4) {
					that.$router.push({
						path: '/game/index',
						query: {
							roomId: that.roomId
						}
					});
				}
			}
		},
		goBack: function goBack() {
			localStorage.removeItem('room_' + this.roomId);
			this.$router.push({
				path: '/room/index'
			});
		},

		onCopy: function onCopy(e) {
			var that = this;
			that.$message({
				message: 'コピーしました',
				type: 'success'
			});
		},
		onError: function onError(e) {
			var that = this;
			that.$message({
				message: 'コピーできませんでした',
				type: 'error'
			});
		},

		checkUser: function checkUser(item, index, checked) {
			var that = this;
			console.log(item);
			console.log(index);
			console.log(checked);
			if (checked) {
				var i = 0;
				if (that.checkNum > 0) that.checkNum -= 1;

				that.checkLists.forEach(function (data, key) {
					if (item.id == data.id) {
						that.checkLists.splice(key, 1);
					}
				});
				that.checkLists.forEach(function (data, key) {
					i++;
					data.sort = i;
					that.lists.forEach(function (data2, key2) {
						if (data.id == data2.id) {
							data2.sort = i;
							data2.tag = that.tags[i - 1];

							that.lists[key2] = data2;
						}
					});
					that.checkLists[key] = data;
				});

				that.lists[index].checked = false;
				that.lists[index].sort = 0;
				that.lists[index].tag = '観戦者';
			} else {
				if (that.checkNum >= that.info.peopleNumber) {
					that.$message({
						message: that.info.peopleNumber + 'まで選択可能です',
						type: 'error'
					});
					return false;
				}

				that.checkNum += 1;
				var user = {
					id: item.id,
					email: item.email,
					lineStatus: item.lineStatus,
					onlineNumber: item.onlineNumber,
					realname: item.realname,
					username: item.username,
					sort: that.checkNum
				};
				that.lists[index].checked = true;
				that.lists[index].sort = that.checkNum;
				that.lists[index].tag = that.tags[that.checkNum - 1];
				that.checkLists.push(user);
			}
		},

		startGame: function startGame() {
			var that = this;
			if (that.checkNum < that.info.peopleNumber) {
				that.$message({
					message: '参加者が足りないためお待ちください',
					type: 'error'
				});
				return false;
			}
			var data = [];
			that.checkLists.forEach(function (item, index) {
				data.push({
					roomId: that.roomId,
					sequence: item.sort,
					userId: item.id
				});
			});

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_js__["x" /* startGame */])(data).then(function (res) {
				if (res) {
					if (res.code == 200 && res.result) {
						console.log("res", res);
						var createdNum = res.result.createdNum,
						    noCreatNum = res.result.noCreatNum;
					}
				}
			});
		},

		getRoomDetail: function getRoomDetail() {
			var that = this,
			    roomId = that.roomId;

			that.lists.forEach(function (item, index) {
				if (item.checked) {
					that.checkLists.push(item);
				}
			});
			that.checkNum = that.checkLists.length;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
				if (res) {
					if (res.code == 200 && res.result) {
						var code = res.result.url;

						var url = that.isUrl + '://' + __WEBPACK_IMPORTED_MODULE_4__utils_global_js__["c" /* domain */] + '/#/room/info?invite=' + res.result.homeownerId + '&code=' + code;

						that.info = {
							homeowner: res.result.homeownerId,
							roomName: res.result.roomName,
							homeownerName: res.result.homeownerName,
							startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
							theme: res.result.theme,
							isCopy: res.result.isCopy,
							isPublic: res.result.isPublic,
							peopleNumber: res.result.peopleNumber,
							url: url
						};
						var cpub = res.result.isPublic == 1 ? '公開' : '非公開';
						var jn = res.result.isCopy == 1 ? 'あり' : 'なし';
						var copyInfo = res.result.homeownerName + 'さんからの招待です。\n以下から参加できます。（初めての方は新規登録をお願いします）\n URL: ' + url + '\n \n 招待コード：' + res.result.password + '\n \n ・ゲーム情報 \n ホスト名：' + res.result.homeownerName + '\n ルーム名：' + res.result.roomName + '\n 開始時刻：' + that.GLOBAL.timeFormat(res.result.startTime * 1000) + '\n \n ・ゲーム設定' + '\n テーマ：' + res.result.theme + '\n 人数：' + res.result.peopleNumber + '\n 手札公開：' + cpub + '\n カードコピー機能：' + jn;
						that.copyInfo = copyInfo;

						that.$options.methods.createSocket(code, that.userEmail);
					}
				}
			});
		}
	}
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_global_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_footer_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_footer_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showinput: false,
      req: false,
      isUrl: "",
      peopleNumber: [1, 2, 3, 4],

      urlShow: true,
      urlSelectShow: false,
      showurl: "",

      theme: ["人生", "仕事", "恋愛", "家族", "子育て", "チームやコミュニティ", "求める人物像", "企業文化", "その他"],
      urls: [],
      diy: "",
      url: "",
      level: 0,
      hourrs: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      ruleForm: {
        homeowner: "1505124724596801538",
        roomName: "",
        year: "2023",
        month: "4",
        day: "6",
        hour: "0",
        min: "1",
        startTime: "",
        theme: "人生",
        isCopy: 0,
        isPublic: 0,
        peopleNumber: 1,
        isCustom: 1,
        urlCode: "",
        url: "",
        turnTime: "30"
      },
      turnTime: [15, 20, 25, 30, 35, 40, 45, 50, 55, 60],
      year: ["2023", "2024", "2025", "2026"],
      choosedate: 30,
      plan: localStorage.getItem("plan"),
      rules: {
        roomName: [{
          required: true,
          message: "ルーム名を入力",
          trigger: "blur"
        }],
        homeowner: [{
          required: true,
          message: "ルーム名を入力",
          trigger: "blur"
        }],
        year: [{
          required: true,
          message: "年を選択してください",
          trigger: "change"
        }],
        month: [{
          required: true,
          message: "月を選択してください",
          trigger: "change"
        }],
        day: [{
          required: true,
          message: "日を選択してください",
          trigger: "change"
        }],
        hour: [{
          required: true,
          message: "時を選択してください",
          trigger: "change"
        }],
        min: [{
          required: true,
          message: "分を選択してください",
          trigger: "change"
        }],
        theme: [{
          required: true,
          message: "テーマを選択してください",
          trigger: "change"
        }],
        isCopy: [{
          required: true,
          message: "コピー機能",
          trigger: "change"
        }],
        isPublic: [{
          required: true,
          message: "カード表示機能",
          trigger: "blur"
        }],
        peopleNumber: [{
          required: true,
          message: "人数を選択",
          trigger: "change"
        }],
        isCustom: [{
          required: true,
          message: "人数を選択",
          trigger: "change"
        }]
      }
    };
  },

  components: {},
  mounted: function mounted() {
    var that = this;
    this.isUrl = this.GLOBAL.getHttps();
    this.ruleForm.homeowner = localStorage.getItem("homeowner");
    this.getUserInfo();
    this.showUrl();
    this.choseM();
    this.getTime();
    document.addEventListener("visibilitychange", that.handleVisible);
  },
  destroyed: function destroyed() {
    var that = this;
    document.addEventListener("visibilitychange", that.handleVisible);
  },
  created: function created() {
    document.removeEventListener("keyup", this.ss);
  },

  methods: {
    Sechange: function Sechange(e) {
      console.log(e);
      var that = this;
      that.ruleForm.url = e;
      that.showurl = that.url + e;
    },
    otherInsert: function otherInsert(e) {
      var that = this;
      that.ruleForm.theme = e;
      console.log(e);
    },
    handleVisible: function handleVisible(e) {
      console.log("e", e);
    },
    publicChange: function publicChange(e) {
      console.log(e);
      var that = this;
    },
    getTime: function getTime() {
      var that = this;
      var date = new Date();
      console.log("date", date);
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      that.ruleForm.month = month;
      that.ruleForm.day = day;
      that.ruleForm.hour = hour;
      that.ruleForm.min = minute;
    },
    showUrl: function showUrl() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["l" /* showUrl */])({}).then(function (res) {
        console.log("url显示", res);
        if (res.code == 200) {
          that.urls = res.result.userUrlList;
        }
      });
    },
    choseM: function choseM() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["y" /* chooseMember */])({}).then(function (res) {
        console.log("res1", res);
        if (res.result == 0) {
          that.peopleNumber = __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["b" /* revertFreePlan */] ? [1, 2] : [1, 2, 3, 4];
        } else if (res.result == 1) {
          that.peopleNumber = [1, 2, 3, 4];
        }
      });
    },

    toRoom: function toRoom() {
      this.$router.push("/waiting");
    },
    toMy: function toMy() {
      this.$router.push("/my");
    },
    changeUrlType: function changeUrlType(e) {
      this.ruleForm.publicURLType = e;
      if (e === "2") {
        this.urlShow = true;
        this.rules.url = [];
        this.rules.url.push({
          required: true,
          message: "後ろの部分を入力",
          trigger: "blur"
        });
      } else {
        this.urlShow = false;
        this.rules.url = "";
      }
    },
    getUserInfo: function getUserInfo() {
      var that = this,
          token = localStorage.getItem("Authorization");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
        if (res) {
          that.ruleForm.homeowner = res.result.id;
          that.level = res.result.level;

          if (that.level == 0) {
            that.url = that.isUrl + "://" + __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["c" /* domain */] + "/#/room/info?invite=" + that.ruleForm.homeowner + "&" + "code=" + that.GLOBAL.randomString(8);
            that.urlShow = false;
            that.ruleForm.isCustom = 1;
          } else {
            that.url = that.isUrl + "://" + __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["c" /* domain */] + "/#/room/info?invite=" + that.ruleForm.homeowner + "&" + "code=" + that.ruleForm.url;
            that.showurl = that.isUrl + "://" + __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["c" /* domain */] + "/#/room/info?invite=" + that.ruleForm.homeowner + "&" + "code=" + that.ruleForm.url;
          }
        }
      });
    },
    chooseTheme: function chooseTheme(e) {
      var that = this;
      if (e == "その他") {
        that.showinput = true;
      } else {
        that.showinput = false;
      }
    },
    monthChange: function monthChange(e) {
      console.log(e);
      var that = this;
      var year = that.ruleForm.year;
      if (year % 100 != 0 && year % 4 == 0 || year % 400 == 0) {
        if (e == 1 || e == 3 || e == 5 || e == 7 || e == 8 || e == 10 || e == 12) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 29;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      } else {
        if (e == 1 || e == 3 || e == 5 || e == 7 || e == 8 || e == 10 || e == 12) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 28;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      }
    },

    doSub: function doSub(formName) {
      var that = this;
      var data = that.ruleForm;
      var password = that.GLOBAL.randomString(6);
      var url = that.isUrl + "://" + __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["c" /* domain */] + "/#/room/info?";
      var urlCode = that.GLOBAL.randomString(8);
      if (that.level == 0) {
        url += "invite=" + that.ruleForm.homeowner + "&" + "code=" + urlCode;
      } else {
        url += "invite=" + that.ruleForm.homeowner + "&" + "code=" + data.url;
        urlCode = data.url;
      }
      var timeStr = data.year + "-" + data.month + "-" + data.day + " " + data.hour + ":" + data.min;
      var startTime = that.GLOBAL.strToTime(timeStr);

      that.$refs[formName].validate(function (valid) {
        if (valid) {
          var formData = {
            homeowner: data.homeowner,
            isCopy: data.isCopy,
            isCustom: data.isCustom,
            isPublic: data.isPublic,
            password: password,
            peopleNumber: data.peopleNumber,
            roomName: data.roomName,
            startTime: startTime,
            theme: data.theme,
            url: urlCode,
            turnTime: data.turnTime
          };
          if (that.req == false) {
            that.req = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["z" /* createRoom */])(formData).then(function (res) {
              console.log(res);
              if (res) {
                that.$message({
                  message: "作成しました",
                  type: "success",
                  onClose: function onClose() {
                    that.req = false;
                    that.$router.push({
                      path: "/waiting",
                      query: {
                        roomId: res.result
                      }
                    });
                  }
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_js__ = __webpack_require__(20);


var _methods;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      links: [],
      centerDialogVisible: false,
      info: {},
      startTime: "1980-01-01",
      endTime: "1980-01-01",
      customerId: "",
      dialogSettingVisible: false,
      plan: localStorage.getItem("plan")
    };
  },
  created: function created() {},

  components: {},
  mounted: function mounted() {
    this.getUserInfo();
  },

  computed: {
    monthPlan: function monthPlan() {
      {
        if (this.info.priceCount) return this.numberWithCommas(this.info.priceCount) + "円/月払い";else return "";
      }
    },
    annualPlan: function annualPlan() {
      {
        if (this.info.priceYearCount) return this.numberWithCommas(this.info.priceYearCount) + "円/年払い";else return "";
      }
    }
  },
  methods: (_methods = {
    numberWithCommas: function numberWithCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    goPage: function goPage(page) {
      this.$router.push(page);
    },
    showMask: function showMask() {
      var that = this;
      that.dialogSettingVisible = true;
    },
    toClose: function toClose() {
      var that = this;
      that.dialogSettingVisible = false;
    },
    tobuy: function tobuy() {
      var that = this;
      that.centerDialogVisible = true;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "goPage", function goPage(page) {
    this.$router.push(page);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "rescind", function rescind() {
    var that = this;
    var data = {
      customerId: that.customerId
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_js__["i" /* canceld */])(data).then(function (res) {
      console.log(res);
      if (res.code == 200) {
        that.goPage("/");
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "check", function check(id) {
    var that = this;
    var data = {};
    data.customerId = id;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_js__["j" /* checkSubscribe */])(id).then(function (res) {
      console.log(111, res);
      if (res.code == 200) {
        that.info = res.result.productListVO;
        that.startTime = res.result.startTime;
        that.endTime = res.result.endTime;
        if (res) {
          if (res.code == 200) {
            if (res.result) {
              that.su = 1;
              localStorage.setItem("plan", res.result.productListVO.name);
              that.plan = res.result.productListVO.name;
            } else {
              that.su = 0;
              localStorage.setItem("plan", "1on1プラン");
              that.plan = "1on1プラン";
            }
          }
        }
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getUserInfo", function getUserInfo() {
    var that = this,
        token = localStorage.getItem("Authorization");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
      if (res) {
        localStorage.setItem("customerId", res.result.customerId);
        that.realname = res.result.realname;
        that.nickname = res.result.nickname;
        that.customerId = res.result.customerId;
        that.check(res.result.customerId);
      }
    });
  }), _methods)
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_global_js__ = __webpack_require__(47);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      links: [],
      centerDialogVisible: false,
      centerDialogVisible1: false,
      list: [],
      product_id: "",
      price: "",
      dtitle: "",
      dtitle1: "料金プランの変更",
      des: "",
      des1: "",
      priceYear: 0,
      my_plan: localStorage.getItem("plan"),
      isPaidPlan: false,
      period: "month",
      sub_id: "",
      fromPlan: null,
      toPlan: null,
      revert: __WEBPACK_IMPORTED_MODULE_1__utils_global_js__["b" /* revertFreePlan */]
    };
  },
  created: function created() {
    var that = this;
    console.log(that.my_plan);
    that.getList();
  },

  components: {},
  methods: {
    numberWithCommas: function numberWithCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    goPage: function goPage(page) {
      this.$router.push(page);
    },
    tobuy: function tobuy(id, price, des, title, priceYear) {
      var that = this;
      var customerId = localStorage.getItem("customerId");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["j" /* checkSubscribe */])(customerId).then(function (res) {
        console.log("ding", res);
        if (res.result != null) {
          that.isPaidPlan = true;
          that.sub_id = res.result.id;
          that.fromPlan = {
            title: res.result.productListVO.name,
            time: res.result.productListVO.time == "month" ? "月" : "年",
            price: res.result.productListVO.time == "month" ? Number(res.result.productListVO.priceCount) : Number(res.result.productListVO.priceYearCount)
          };
        }
        that.centerDialogVisible = true;
        that.product_id = id;
        that.des = des;
        that.dtitle = title;
        var pri = price.split("円");
        that.price = pri[0];
        that.priceYear = priceYear;

        that.toPlan = {
          title: title,
          time: "月",
          price: 0
        };
      });
    },
    getList: function getList() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["n" /* plan */])({}).then(function (res) {
        console.log("list", res);
        if (res.code == 200) {
          that.list = res.result;
        }
      });
    },
    updatePlan: function updatePlan() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["o" /* createPrice */])({
        currency: "jpy",
        interval: that.period,
        product: that.product_id,
        unitAmount: that.period == "month" ? that.price : that.priceYear
      }).then(function (res) {
        console.log("res", res);
        if (res.code == 200) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["p" /* updatePlan */])({
            customerId: localStorage.getItem("customerId"),
            subId: that.sub_id,
            priceId: res.result.id,
            prodId: that.product_id,
            prodName: that.dtitle
          }).then(function (result) {
            if (result.code == 200) {
              that.$router.push("/pay/choose");
            }
          });
        }
      });
    },
    createPrice: function createPrice(e) {
      var that = this;
      that.period = e;

      {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["o" /* createPrice */])({
          currency: "jpy",
          interval: e,
          product: that.product_id,
          unitAmount: e == "month" ? that.price : that.priceYear
        }).then(function (res) {
          console.log("res", res);
          if (res.code == 200) {
            var customer = localStorage.getItem("customerId");
            if (customer) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["q" /* createSession */])({
                price: res.result.id,
                customerId: customer
              }).then(function (result) {
                if (result.code == 200) {
                  window.open(result.result.url);
                }
              });
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["r" /* createCustomer */])({}).then(function (rest) {
                console.log(rest);
                if (rest.code == 200) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["q" /* createSession */])({
                    price: res.result.id,
                    customerId: rest.result.id
                  }).then(function (result) {
                    if (result.code == 200) {
                      window.open(result.result.url);
                    }
                  });
                }
              });
            }
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      links: [],
      centerDialogVisible: false,
      url: "",
      multies: true,
      price: 0,
      proname: "",
      plan: localStorage.getItem("plan"),
      passForm: {
        url1: "",
        url2: "",
        url3: "",
        url4: "",
        url5: "",
        url6: "",
        url7: "",
        url8: "",
        url9: "",
        url10: "",
        url11: "",
        url12: "",
        url13: "",
        url14: "",
        url15: "",
        url16: "",
        url17: "",
        url18: "",
        url19: "",
        url20: "",
        url21: "",
        url22: "",
        url23: "",
        url24: "",
        url25: "",
        url26: "",
        url27: "",
        url28: "",
        url29: "",
        url30: ""
      },
      passFormCopy: {
        url1: "",
        url2: "",
        url3: "",
        url4: "",
        url5: "",
        url6: "",
        url7: "",
        url8: "",
        url9: "",
        url10: "",
        url11: "",
        url12: "",
        url13: "",
        url14: "",
        url15: "",
        url16: "",
        url17: "",
        url18: "",
        url19: "",
        url20: "",
        url21: "",
        url22: "",
        url23: "",
        url24: "",
        url25: "",
        url26: "",
        url27: "",
        url28: "",
        url29: "",
        url30: ""
      }
    };
  },
  created: function created() {
    var that = this;
    that.price = that.$route.query.price;
    that.proname = that.$route.query.name;
    console.log(that.$route.query.name);
  },

  components: {},
  mounted: function mounted() {
    var that = this;
    that.showurl();
  },

  methods: {
    goPage: function goPage(page) {
      this.$router.push(page);
    },
    tobuy: function tobuy() {
      var that = this;
      that.centerDialogVisible = true;
    },
    showurl: function showurl() {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["l" /* showUrl */])(that.proname).then(function (res) {
        console.log(res);
        if (res.code == 200) {
          if (res.result) {
            if (res.result.userUrlList.length != 0) {
              if (that.plan == '認定ファシリテータープラン') {
                that.passForm.url1 = that.passFormCopy.url1 = res.result.userUrlList[0];
              } else if (that.plan == '法人プラン') {
                that.passForm.url1 = that.passFormCopy.url1 = res.result.userUrlList[0];
                that.passForm.url2 = that.passFormCopy.url2 = res.result.userUrlList[1] || "";
                that.passForm.url3 = that.passFormCopy.url3 = res.result.userUrlList[2] || "";
                that.passForm.url4 = that.passFormCopy.url4 = res.result.userUrlList[3] || "";
                that.passForm.url5 = that.passFormCopy.url5 = res.result.userUrlList[4] || "";
                that.passForm.url6 = that.passFormCopy.url6 = res.result.userUrlList[5] || "";
                that.passForm.url7 = that.passFormCopy.url7 = res.result.userUrlList[6] || "";
                that.passForm.url8 = that.passFormCopy.url8 = res.result.userUrlList[7] || "";
                that.passForm.url9 = that.passFormCopy.url9 = res.result.userUrlList[8] || "";
                that.passForm.url10 = that.passFormCopy.url10 = res.result.userUrlList[9] || "";
                that.passForm.url11 = that.passFormCopy.url11 = res.result.userUrlList[10] || "";
                that.passForm.url12 = that.passFormCopy.url12 = res.result.userUrlList[11] || "";
                that.passForm.url13 = that.passFormCopy.url13 = res.result.userUrlList[12] || "";
                that.passForm.url14 = that.passFormCopy.url14 = res.result.userUrlList[13] || "";
                that.passForm.url15 = that.passFormCopy.url15 = res.result.userUrlList[14] || "";
                that.passForm.urll6 = that.passFormCopy.url16 = res.result.userUrlList[15] || "";
                that.passForm.url17 = that.passFormCopy.url17 = res.result.userUrlList[16] || "";
                that.passForm.url18 = that.passFormCopy.url18 = res.result.userUrlList[17] || "";
                that.passForm.url19 = that.passFormCopy.url19 = res.result.userUrlList[18] || "";
                that.passForm.url20 = that.passFormCopy.url20 = res.result.userUrlList[19] || "";
                that.passForm.url21 = that.passFormCopy.url21 = res.result.userUrlList[20] || "";
                that.passForm.url22 = that.passFormCopy.url22 = res.result.userUrlList[21] || "";
                that.passForm.url23 = that.passFormCopy.url23 = res.result.userUrlList[22] || "";
                that.passForm.url24 = that.passFormCopy.url24 = res.result.userUrlList[23] || "";
                that.passForm.url25 = that.passFormCopy.url25 = res.result.userUrlList[24] || "";
                that.passForm.url26 = that.passFormCopy.url26 = res.result.userUrlList[25] || "";
                that.passForm.url27 = that.passFormCopy.url27 = res.result.userUrlList[26] || "";
                that.passForm.url28 = that.passFormCopy.url28 = res.result.userUrlList[27] || "";
                that.passForm.url29 = that.passFormCopy.url29 = res.result.userUrlList[28] || "";
                that.passForm.url30 = that.passFormCopy.url30 = res.result.userUrlList[29] || "";
              }
            }
          }
        }
      });
    },
    settled: function settled() {
      var that = this;
      var data = {};
      data.proName = that.proname;
      var price = that.price;

      var array = [];
      if (that.passForm.url1 != "") {
        array.push(that.passForm.url1);
      }
      if (that.passForm.url2 != "") {
        array.push(that.passForm.url2);
      }
      if (that.passForm.url3 != "") {
        array.push(that.passForm.url3);
      }
      if (that.passForm.url4 != "") {
        array.push(that.passForm.url4);
      }
      if (that.passForm.url5 != "") {
        array.push(that.passForm.url5);
      }
      if (that.passForm.url6 != "") {
        array.push(that.passForm.url6);
      }
      if (that.passForm.url7 != "") {
        array.push(that.passForm.url7);
      }
      if (that.passForm.url8 != "") {
        array.push(that.passForm.url8);
      }
      if (that.passForm.url9 != "") {
        array.push(that.passForm.url9);
      }
      if (that.passForm.url10 != "") {
        array.push(that.passForm.url10);
      }
      if (that.passForm.url11 != "") {
        array.push(that.passForm.url11);
      }
      if (that.passForm.url12 != "") {
        array.push(that.passForm.url12);
      }
      if (that.passForm.url13 != "") {
        array.push(that.passForm.url13);
      }
      if (that.passForm.url14 != "") {
        array.push(that.passForm.url14);
      }
      if (that.passForm.url15 != "") {
        array.push(that.passForm.url15);
      }
      if (that.passForm.url16 != "") {
        array.push(that.passForm.url16);
      }
      if (that.passForm.url17 != "") {
        array.push(that.passForm.url17);
      }
      if (that.passForm.url18 != "") {
        array.push(that.passForm.url18);
      }
      if (that.passForm.url19 != "") {
        array.push(that.passForm.url19);
      }
      if (that.passForm.url20 != "") {
        array.push(that.passForm.url20);
      }
      if (that.passForm.url21 != "") {
        array.push(that.passForm.url21);
      }
      if (that.passForm.url22 != "") {
        array.push(that.passForm.url22);
      }
      if (that.passForm.url23 != "") {
        array.push(that.passForm.url23);
      }
      if (that.passForm.url24 != "") {
        array.push(that.passForm.url24);
      }
      if (that.passForm.url25 != "") {
        array.push(that.passForm.url25);
      }
      if (that.passForm.url26 != "") {
        array.push(that.passForm.url26);
      }
      if (that.passForm.url27 != "") {
        array.push(that.passForm.url27);
      }
      if (that.passForm.url28 != "") {
        array.push(that.passForm.url28);
      }
      if (that.passForm.url29 != "") {
        array.push(that.passForm.url29);
      }
      if (that.passForm.url30 != "") {
        array.push(that.passForm.url30);
      }
      var str = "";
      for (var i = 0; i < array.length; i++) {
        if (i == array.length - 1) {
          str += array[i];
        } else {
          str += array[i] + ",";
        }
      }
      console.log(str);
      data.userUrl = str;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["m" /* setUrl */])(data).then(function (res) {
        console.log(res);
        if (res.code == 200) {
          that.$message({
            message: "設置しました",
            type: 'success'
          });
          that.showurl();
        }
      });
    }
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            lists: [],
            pageNo: 1,
            pageSize: 10,
            userId: ''
        };
    },
    created: function created() {
        this.userId = localStorage.getItem('homeowner');
    },

    components: {},
    mounted: function mounted() {
        this.getLists();
    },

    methods: {
        getLists: function getLists() {
            var that = this;
            var data = { pageNo: that.pageNo, pageSize: that.pageSize, userId: that.userId };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["w" /* getInvitationRecord */])(data).then(function (res) {
                console.log(res);
                if (res) {
                    if (res.code == 200) {
                        var lists = res.result.list;
                        lists.map(function (item, index) {
                            item.startTime = that.GLOBAL.timeFormat(item.startTime * 1000);
                        });
                        that.lists = lists;
                    }
                }
            });
        },
        toRoom: function toRoom(id, homer) {
            var that = this;
            that.$router.push({ path: '/room/info', query: { roomId: id, home: homer } });
        },
        toMy: function toMy() {
            this.$router.push('/my');
        }
    }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_websocket_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_global_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(52);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        var _this = this;

        var passwordValidator = function passwordValidator(rule, value, callback) {
            if (value === '') {
                callback(new Error('パスワードを入力'));
            } else if (value !== _this.info.password) {
                callback(new Error('招待コードを入力してください'));
            } else {
                callback();
            }
        };
        return {
            isUrl: '',
            tags: this.GLOBAL.tags,
            userId: '',
            userEmail: '',
            userName: '',
            roomId: '',
            code: '',
            invite: '',
            isJoin: false,
            info: {
                roomName: '',
                homeownerName: '',
                startTime: '',
                theme: '',
                isCopy: '',
                isPublic: '',
                peopleNumber: '',
                url: '',
                password: ''
            },
            home: 0,

            status: 'uncommitted',
            dialogFormVisible: false,
            passForm: {
                password: '' },
            passRules: {
                password: [{ required: true, validator: passwordValidator, message: '招待コードを入力', trigger: 'blur' }]
            },
            lists: []
        };
    },
    created: function created() {
        var that = this;
        that.isUrl = that.GLOBAL.getHttps();

        that.roomId = that.$route.query.roomId;
        that.invite = that.$route.query.invite;
        that.code = that.$route.query.code;
        that.home = that.$route.query.home;
        that.userId = localStorage.getItem('homeowner');
        that.userEmail = localStorage.getItem('userEmail');
        that.userName = localStorage.getItem('userName');
        that.isJoin = localStorage.getItem('join_' + that.roomId);

        if (that.roomId) {
            that.getRoomDetail();
        }
        if (that.invite && that.code) {
            that.getRoomDetailByUid(that.invite, that.code);
        }
        console.log('created-status: ', that.status);
    },

    watch: {
        roomId: {
            immediate: true,

            deep: true,
            handler: function handler(val) {
                console.log('watch-handler监听', val);
                if (val) {
                    this.isJoin = localStorage.getItem('join_' + this.roomId) ? localStorage.getItem('join_' + this.roomId) : false;
                    this.updateJoin(this.isJoin);
                    if (!this.isJoin) this.insertInvitationLog();
                    this.getroominfo();
                }
            }
        }
    },
    components: {},
    mounted: function mounted() {
        window.addEventListener('onmessageWS', this.getsocketData);
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['updateJoin']), {
        toBack: function toBack() {
            history.go(-1);
        },
        deleteRoom: function deleteRoom() {
            var that = this;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["t" /* delRoom */])(that.roomId).then(function (res) {
                console.log('deleteRoom: ', res);
                if (res.code == 200) {
                    that.$message({
                        message: res.message,
                        type: 'success'
                    });
                    setTimeout(function () {
                        that.$router.go(-1);
                    }, 1000);
                }
            });
        },

        getsocketData: function getsocketData(e) {
            var _this2 = this;

            console.log('getsocketData: ', e.detail.data);
            if (e.detail.data == '发生连接错误') return false;
            var data = JSON.parse(e.detail.data),
                newUser = {},
                isNew = true,
                that = this;
            if (data.result && data.operateMsg == '游戏开始，向每位玩家分牌') {
                var result = JSON.parse(data.result);
                console.log("result: ", result);
                var userCards = JSON.parse(data.result);
                var playerIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(userCards),
                    players = [],
                    count = playerIds.length;
                localStorage.setItem('room_usercards' + that.roomId, data.result);
                if (playerIds.length == 1) {
                    that.$router.push({ path: '/game/index1', query: { roomId: that.roomId } });
                } else if (playerIds.length == 2) {
                    that.$router.push({ path: '/game/index2', query: { roomId: that.roomId } });
                } else if (playerIds.length == 3) {
                    that.$router.push({ path: '/game/index3', query: { roomId: that.roomId } });
                } else if (playerIds.length == 4) {
                    that.$router.push({ path: '/game/index', query: { roomId: that.roomId } });
                }
            } else {
                this.lists.forEach(function (item, index) {
                    if (item.id == data.id) {
                        isNew = false;

                        if (data.lineStatus != item.lineStatus) {
                            _this2.lists[index].lineStatus = data.lineStatus;
                        }
                    }
                });
                if (isNew) {
                    var tag = '観戦者';
                    if (data.id == this.info.homeowner) tag = '房主';
                    newUser = {
                        email: data.email,
                        id: data.id,
                        lineStatus: data.lineStatus,
                        onlineNumber: data.onlineNumber,
                        realname: data.realname,
                        username: data.username,
                        tag: tag,
                        checked: false,
                        isSkip: false,
                        sort: 0
                    };
                    if (data.id = this.userId) {
                        newUser.isHomewer = true;
                    }
                    console.log(tag, newUser);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["a" /* getRoomDetail */])(this.roomId).then(function (res) {
                        console.log('RRRRRRRR', res);
                        if (res) {
                            if (res.code == 200 && res.result) {
                                var roomStatus = 'uncommitted';
                                switch (res.result.status) {
                                    case 1:
                                        roomStatus = 'waiting';
                                        break;
                                    case 2:
                                        roomStatus = 'ongoing';
                                        break;
                                    case 3:
                                        roomStatus = 'ending';
                                        break;
                                }
                                _this2.status = roomStatus;
                                console.log('Status', roomStatus);
                            }
                        }
                    });
                    this.lists.push(newUser);
                }


                localStorage.setItem('room_' + this.roomId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.lists));
            }
        },

        getUserInfo: function getUserInfo() {
            var that = this,
                token = localStorage.getItem('Authorization');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["f" /* getUserInfo */])(token).then(function (res) {
                console.log('getUserInfo: ', res);
                if (res) {
                    that.ruleForm = {
                        realname: res.result.realname,
                        falsename: res.result.falsename,
                        nickname: res.result.nickname,
                        sex: res.result.sex,
                        year: res.result.year,
                        month: res.result.month,
                        day: res.result.day,
                        address: res.result.address,
                        email: res.result.email };
                }
            });
        },

        insertInvitationLog: function insertInvitationLog() {
            var that = this;
            var data = {
                roomId: that.roomId,
                userId: that.userId
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["u" /* insertInvitationLog */])(data).then(function (res) {
                if (res) {}
            });
        },
        getRoomDetailByUid: function getRoomDetailByUid(homeowner, code) {
            var that = this;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["v" /* getRoomDetailByUid */])(homeowner, code).then(function (res) {
                if (res) {
                    if (res.code == 200 && res.result) {
                        var _code = res.result.url;
                        var url = that.isUrl + '://' + __WEBPACK_IMPORTED_MODULE_5__utils_global_js__["c" /* domain */] + '/#/room/info?invite=' + res.result.homeownerId + '&code=' + _code;
                        that.info = {
                            roomName: res.result.roomName,
                            homeownerName: res.result.homeownerName,
                            startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
                            theme: res.result.theme,
                            isCopy: res.result.isCopy == 1 ? 'あり' : 'なし',
                            isPublic: res.result.isPublic == 1 ? '公開' : '非公開',
                            peopleNumber: res.result.peopleNumber,
                            url: url,
                            password: res.result.password
                        };

                        that.roomId = res.result.id;

                        if (localStorage.getItem('join_' + that.roomId)) {
                            that.isJoin = true;
                        }
                        var roomStatus = 'uncommitted';
                        console.log('getRoomDetailByUid', res);
                        if (that.isJoin) {
                            switch (res.result.status) {
                                case 1:
                                    roomStatus = 'waiting';
                                    break;
                                case 2:
                                    roomStatus = 'ongoing';
                                    if (res.result.peopleNumber == 1) {
                                        that.$router.push({ path: '/game/index1', query: { roomId: res.result.id } });
                                    } else if (res.result.peopleNumber == 2) {
                                        that.$router.push({ path: '/game/index2', query: { roomId: res.result.id } });
                                    } else if (res.result.peopleNumber == 3) {
                                        that.$router.push({ path: '/game/index3', query: { roomId: res.result.id } });
                                    } else if (res.result.peopleNumber == 4) {
                                        that.$router.push({ path: '/game/index', query: { roomId: res.result.id } });
                                    }
                                    break;
                                case 3:
                                    roomStatus = 'ending';
                                    break;
                            }
                            that.$options.methods.createSocket(that.code, that.userEmail);
                        }
                        that.status = roomStatus;
                        that.code = _code;
                    }
                }
            });
        },
        getroominfo: function getroominfo() {
            var that = this,
                roomId = that.roomId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
                if (res) {
                    if (res.code == 200 && res.result) {
                        var code = res.result.url;
                        var url = that.isUrl + '://' + __WEBPACK_IMPORTED_MODULE_5__utils_global_js__["c" /* domain */] + '/#/room/info?invite=' + res.result.homeownerId + '&code=' + code;
                        that.info = {
                            roomName: res.result.roomName,
                            homeownerName: res.result.homeownerName,
                            startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
                            theme: res.result.theme,
                            isCopy: res.result.isCopy == 1 ? 'あり' : 'なし',
                            isPublic: res.result.isPublic == 1 ? '公開' : '非公開',
                            peopleNumber: res.result.peopleNumber,
                            url: url,
                            password: res.result.password
                        };
                        console.log("====== pwd:", res.result.password);
                        if (localStorage.getItem('join_' + that.roomId)) {
                            that.isJoin = true;
                        }

                        var roomStatus = 'uncommitted';
                        if (that.isJoin) {
                            switch (res.result.status) {
                                case 1:
                                    roomStatus = 'waiting';
                                case 2:
                                    roomStatus = 'ongoing';
                                case 3:
                                    roomStatus = 'ending';
                            }
                        }
                        that.status = roomStatus;
                        that.code = code;
                    }
                }
            });
        },

        getRoomDetail: function getRoomDetail() {
            var that = this,
                roomId = that.roomId;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_api_js__["a" /* getRoomDetail */])(roomId).then(function (res) {
                if (res) {
                    if (res.code == 200 && res.result) {
                        var code = res.result.url;
                        var url = that.isUrl + '://' + __WEBPACK_IMPORTED_MODULE_5__utils_global_js__["c" /* domain */] + '/#/room/info?invite=' + res.result.homeownerId + '&code=' + code;
                        that.info = {
                            roomName: res.result.roomName,
                            homeownerName: res.result.homeownerName,
                            startTime: that.GLOBAL.timeFormat(res.result.startTime * 1000),
                            theme: res.result.theme,
                            isCopy: res.result.isCopy == 1 ? 'あり' : 'なし',
                            isPublic: res.result.isPublic == 1 ? '公開' : '非公開',
                            peopleNumber: res.result.peopleNumber,
                            url: url,
                            password: res.result.password
                        };
                        if (localStorage.getItem('join_' + that.roomId)) {
                            that.isJoin = true;
                        }

                        var roomStatus = 'uncommitted';
                        that.$options.methods.createSocket(code, that.userEmail);
                        console.log('getRoomDetail', res);
                        switch (res.result.status) {
                            case 1:
                                if (that.home == 1) {
                                    roomStatus = 'waiting';
                                    that.$router.push({ path: '/waiting', query: { roomId: res.result.id } });
                                }
                                break;
                            case 2:
                                roomStatus = 'ongoing';

                                if (res.result.peopleNumber == 1) {
                                    that.$router.push({ path: '/game/index1', query: { roomId: res.result.id } });
                                } else if (res.result.peopleNumber == 2) {
                                    that.$router.push({ path: '/game/index2', query: { roomId: res.result.id } });
                                } else if (res.result.peopleNumber == 3) {
                                    that.$router.push({ path: '/game/index3', query: { roomId: res.result.id } });
                                } else if (res.result.peopleNumber == 4) {
                                    that.$router.push({ path: '/game/index', query: { roomId: res.result.id } });
                                }

                                break;
                            case 3:
                                roomStatus = 'ending';
                                break;
                        }
                        that.status = roomStatus;
                        that.code = code;
                    }
                }
            });
        },
        doJoin: function doJoin() {
            this.dialogFormVisible = true;
        },
        doSub: function doSub(formName) {
            var that = this;
            var data = that.passForm;
            that.$refs[formName].validate(function (valid) {
                if (valid) {
                    var formData = {
                        password: data.password
                    };
                    that.status = 'waiting';
                    localStorage.setItem('join_' + that.roomId, true);
                    console.log('房间ID：', that.roomId);
                    console.log('url：', that.code);
                    console.log('email：', that.userEmail);
                    that.$options.methods.createSocket(that.code, that.userEmail);
                    that.dialogFormVisible = false;
                    localStorage.setItem('join_' + that.roomId, true);
                    that.isJoin = true;
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        createSocket: function createSocket(code, userEmail) {
            var that = this;
            var wsUrl = '';
            var ishttps = 'https:' == document.location.protocol ? true : false;

            if (ishttps) wsUrl = "wss://" + __WEBPACK_IMPORTED_MODULE_5__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;else wsUrl = "ws://" + __WEBPACK_IMPORTED_MODULE_5__utils_global_js__["a" /* baseUrl */] + "/jeecg-boot/websocket/" + code + "/" + userEmail;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_websocket_js__["a" /* createSocket */])(wsUrl);
        }
    })
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            lists: [],
            pageNo: 1,
            pageSize: 10,
            userId: '',
            plan: "",
            userid: ""
        };
    },
    created: function created() {
        this.userId = localStorage.getItem('homeowner');
        var plan = localStorage.getItem("plan");
    },

    components: {},
    mounted: function mounted() {
        this.getLists();
    },

    methods: {
        getLists: function getLists() {
            var that = this;
            var data = { pageNo: that.pageNo, pageSize: that.pageSize, userId: that.userId };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["s" /* getGamesRecord */])(data).then(function (res) {
                console.log(res);
                if (res) {
                    if (res.code == 200) {
                        var lists = res.result.list;
                        lists.map(function (item, index) {
                            item.startTime = that.GLOBAL.timeFormat(item.startTime * 1000);
                        });
                        that.lists = lists;
                    }
                }
            });
        },
        toRoom: function toRoom(id) {
            var that = this;
            that.$router.push({ path: '/room/resu', query: { roomId: id } });
        },
        toMy: function toMy() {
            this.$router.push('/my');
        }
    }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_js__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      isUrl: '',
      roomId: '',
      room: {},
      timeStr: '',
      users: [],
      plan: "",
      cardsBack: __webpack_require__(123) };
  },

  components: {},
  created: function created() {
    this.roomId = this.$route.query.roomId;
    this.userId = localStorage.getItem('homeowner');
    this.userEmail = localStorage.getItem('userEmail');
    this.getRoom(this.roomId);

    this.getlog(this.$route.query.roomId);
    var plan = localStorage.getItem("plan");
    this.plan = plan;
  },

  methods: {
    getRoom: function getRoom(id) {
      var _this = this;

      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["a" /* getRoomDetail */])(id).then(function (res) {
        console.log(res);
        if (res.code == 200) {
          _this.room = res.result;
        }
      });
    },

    toRoom: function toRoom(id) {
      var that = this;
      that.$router.push({
        path: '/room/info',
        params: {
          roomId: id
        }
      });
    },
    formatSeconds: function formatSeconds(value) {
      var secondTime = parseInt(value);
      var minuteTime = 0;
      var hourTime = 0;
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);

        secondTime = parseInt(secondTime % 60);

        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60);

          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + parseInt(secondTime) + "秒";

      if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "時間" + result;
      }
      console.log('result', result);
      return result;
    },
    getlog: function getlog(id) {
      var that = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api_js__["b" /* getLogDetail */])(id).then(function (res) {
        console.log(res);
        if (res.code == 200) {
          var results = [];
          if (that.plan == '基本プラン') {
            for (var i = 0; i < res.result.length; i++) {
              if (res.result[i].currentUserFlag == 1) {
                res.result[i].isShowCard = 1;
                res.result[i].userCard = JSON.parse(res.result[i].userCard);
                res.result[i].urls = [];
                for (var j = 0; j < res.result[i].userCard.length; j++) {
                  if (res.result[i].userCard[j].id < 10) {
                    res.result[i].urls.push('https://online.engagement-card.com/img/card_0' + res.result[i].userCard[j] + '.png');
                  } else {
                    res.result[i].urls.push('https://online.engagement-card.com/img/card_' + res.result[i].userCard[j] + '.png');
                  }
                }
              } else {
                res.result[i].isShowCard = 0;
                res.result[i].userCard = JSON.parse(res.result[i].userCard);
                res.result[i].urls = [];
                for (var _j = 0; _j < res.result[i].userCard.length; _j++) {
                  if (res.result[i].userCard[_j].id < 10) {
                    res.result[i].urls.push('https://online.engagement-card.com/img/card_0' + res.result[i].userCard[_j] + '.png');
                  } else {
                    res.result[i].urls.push('https://online.engagement-card.com/img/card_' + res.result[i].userCard[_j] + '.png');
                  }
                }
              }
              results.push(res.result[i]);
            }
          } else {
            for (var _i = 0; _i < res.result.length; _i++) {
              res.result[_i].userCard = JSON.parse(res.result[_i].userCard);
              res.result[_i].urls = [];
              for (var _j2 = 0; _j2 < res.result[_i].userCard.length; _j2++) {
                if (res.result[_i].userCard[_j2].id < 10) {
                  res.result[_i].urls.push('https://online.engagement-card.com/img/card_0' + res.result[_i].userCard[_j2] + '.png');
                } else {
                  res.result[_i].urls.push('https://online.engagement-card.com/img/card_' + res.result[_i].userCard[_j2] + '.png');
                }
              }
              results.push(res.result[_i]);
            }
          }
          that.users = results;
        }
      });
    },

    toMy: function toMy() {
      this.$router.push('/room/Logs');
    },
    fenxi: function fenxi(e) {
      var that = this;
      console.log(e.userCard);
      var str = "";
      for (var i = 0; i < e.userCard.length; i++) {
        if (e.userCard[i] == "01") {
          e.userCard[i] = 1;
        } else if (e.userCard[i] == "02") {
          e.userCard[i] = 2;
        } else if (e.userCard[i] == "03") {
          e.userCard[i] = 3;
        } else if (e.userCard[i] == "04") {
          e.userCard[i] = 4;
        } else if (e.userCard[i] == "05") {
          e.userCard[i] = 5;
        } else if (e.userCard[i] == "06") {
          e.userCard[i] = 6;
        } else if (e.userCard[i] == "07") {
          e.userCard[i] = 7;
        } else if (e.userCard[i] == "08") {
          e.userCard[i] = 8;
        } else if (e.userCard[i] == "09") {
          e.userCard[i] = 9;
        }
        if (i == e.userCard.length - 1) {
          str += e.userCard[i];
        } else {
          str += e.userCard[i] + ',';
        }
      }
      console.log(str);
      this.$router.push({ path: '/game/analysis', query: { id: str, roomid: that.roomId } });
    }
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_socket_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Common__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Common__);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.GLOBAL = __WEBPACK_IMPORTED_MODULE_10__Common___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_7_echarts__["default"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$socketPublic = __WEBPACK_IMPORTED_MODULE_9__utils_socket_js__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$goRoute = function (index) {
  this.$router.push(index);
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__App___default.a);
  }
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);







var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://online.engagement-card.com",
  timeout: 5 * 1000
});

service.interceptors.request.use(function (config) {
  config.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(config.data);
  config.headers = {
    "Content-Type": "application/json;charset=UTF-8" };

  var token = localStorage.getItem("Authorization");
  if (token) {
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Access-Token": token
    };
  }
  return config;
}, function (error) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  if (response.status == 200) {
    var data = response.data;

    if (data.code != 200 && data.code != 0 && data.code != 405) {
      if (data.message != null) {
        if (data.message.includes("test mode") || data.message.includes("live mode")) {
          data.message = "料金プラン情報に異常が発生いたしました。「問い合わせ」メニューからお問い合わせください。";
        }
        __WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"].error(data.message);
      }

      return false;
    }
    return data;
  } else {
    console.log("code", response.status);
    __WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"].error(response.statusText);
    return false;
  }
  return response;
}, function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = "Request Error";
        break;
      case 401:
        error.message = "Unauthorized. Please log in";
        localStorage.removeItem("Authorization");
        localStorage.removeItem("homeowner");
        localStorage.removeItem("userInfo");
        break;
      case 403:
        error.message = "Access Refused";
        break;
      case 404:
        error.message = "Request Error. Resource not found";
        window.location.href = "/NotFound";
        break;
      case 405:
        error.message = "Request way not allowed";
        break;
      case 408:
        error.message = "Request timed out";
        break;
      case 500:
        localStorage.removeItem("Authorization");
        localStorage.removeItem("homeowner");
        localStorage.removeItem("userInfo");
        window.location.href = "/#/login";
        error.message = "Server error";
        break;
      case 501:
        error.message = "Not implemented";
        break;
      case 502:
        error.message = "Network error";
        break;
      case 503:
        error.message = "Service unavailable";
        break;
      case 504:
        error.message = "Network timed out";
        break;
      case 505:
        error.message = "http version not supported";
        break;
      default:
        error.message = "Connection error" + error.response.status;
    }
  } else {
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(error).includes("timeout")) {
      __WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"].error("Server response timed out. Please refresh this page.");
    }
    error.message = "Server connection error";
  }

  if (error.message != "Server error") {
    __WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"].error(error.message);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(error.response);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return domain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return revertFreePlan; });

var domain = 'online.engagement-card.com';
var baseUrl = 'online.engagement-card.com';
var revertFreePlan = false;

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 817:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSocket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendWSPush; });
/* unused harmony export WSClose */
/* unused harmony export sendPing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var Socket = '';
var setIntervalWesocketPush = null;
var status = localStorage.getItem("gamestatus");
var wsUrl = '';

var createSocket = function createSocket(url) {
    wsUrl = url;
    Socket && Socket.close();
    console.log("Socketcon", Socket);
    if (!Socket) {
        console.log('websocket create');
        Socket = new WebSocket(url);
        Socket.onopen = onopenWS;
        Socket.onmessage = onmessageWS;
        Socket.onerror = onerrorWS;
        Socket.onclose = oncloseWS;
    } else {
        console.log('websocket created');
    }
};

var onopenWS = function onopenWS() {
    console.log("socketOpen");
};

var onerrorWS = function onerrorWS(error) {
    console.log("error", error);
    clearInterval(setIntervalWesocketPush);
    console.log('Connection failed reconnecting');
};

var onmessageWS = function onmessageWS(e) {
    window.dispatchEvent(new CustomEvent('onmessageWS', {
        detail: {
            data: e.data
        }
    }));
};

var connecting = function connecting(message) {
    setTimeout(function () {
        if (Socket.readyState === 0) {
            connecting(message);
        }
    }, 1000);
};

var sendWSPush = function sendWSPush(message) {
    console.log("SocketStatus", Socket.readyState);
    if (Socket !== null && Socket.readyState === 3) {} else if (Socket.readyState === 1) {
        Socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(message));
    } else if (Socket.readyState === 0) {
        connecting(message);
    }
};

var WSClose = function WSClose(message) {
    console.log("主动断开socket");
    Socket = null;
};

var oncloseWS = function oncloseWS(e) {
    console.log("socket断开了");
    console.log(e);

    clearInterval(setIntervalWesocketPush);
    console.log('Websocket disconnected....Attempting to reconnect');
    console.log(Socket.readyState);
    if (Socket.readyState !== 2) {
        Socket = null;
        createSocket(wsUrl);
    }
};

var sendPing = function sendPing() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
    var ping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ping';

    clearInterval(setIntervalWesocketPush);
    setIntervalWesocketPush = setInterval(function () {
        Socket.send(ping);
    }, time);
};

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 831:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAORSURBVHgB7VqLcdswDIVzHcCZoOoEUSeoNqg7gTWCN5A6QdIJrE6QbiBlgjgTyBs4mQAlIthlYYD6mI7bu7w7WBIJEh/CEEgb4B2XxQwiAREzd0kd3fA1cTT3WJ4dbfj64KiZzWYbuCSc0omjwtEOp6F1lNM88JZgxWuMi/XZDXEC5th5/FxoHeVwDmDn9ceAcAqjytHKUSq9yeMz7m96DLl1NIdYYIWsOCdl8rEC2aCcva7hEWOEVEB5EryACHDzlIYRazgF7CVN+QpjLnEnq1DkNDAVrHyrTFoGxtCXnGL8XhlLjqhRSZvueYk6pq8we3mQ8jgtra553NLoz2Eq2EtDlV/hdLQYW3lWSk78qPBQuNxjfORwClD3/kLhqw0FKK3SqiSCP8Vw2jxdeRZkCSg8nkLpp3HZQBnluZTPMIy1o4WhfDJSFq3IxtEWY5UPqGeePrT41tWkh7/2A6QMdHX8Hj8cfRVtEp9cXb/VOtizXyAeXhzdqfJ4SX3suN16ob2GlCUJ9WQQA/RCPFQBV57MROjwRB9s7WfoVkPiJ9jI4DyY+3P7BqSC8bDdc0bQNrAS/VvX3sBlkOxvPniNsjh7tgYxnmAcKuj2wlNA30P/XXTQNWTAVjzL/h2Mw4NbsQomwMU8XXwDPu5vruA/h29AX8hIXMM/AD+EtqJPhow8wxmb32mfW/TwkBO/u1D7JdoT8fyyvwkZcLO/4by7FP1UjWYjMtEcjp2igSrca858/lgfhz4/hKSHX9MqdmVC7WgFx1iCjWeIhxvxrJ/o4fH+t8T+U7fMmCv0Bg+hHaBXahlwh+PRYqCYY0MsyhTl1mJ81mdgiFmCqtVY5TR9h7SDskTwVSEDtYmtkFl5PHeGETkMUz4zlC8FX6LwLPomL4cMQntL2WJXiaaKMnlgnLbvlt5vh3iHllauQm3wxdzUt+iFD+rez2EIUK/lbw3eEuOhRc5qeJzB+r0vFKsVAYXBS96qcBwatNNsrbTlMAZo5/GiZ8z++FyG4Y7bacUyj39IGE475EX7ZHqNETfyGA7D9iRZGD5ezyECsEurbXTlPQEp2vE62RBWvMYTPD/4Z1b8U9QlBgsVbw1020Yqtrb+8QePp6qS3g9Uii/Ark5p/DfruOYkYNy0qYHe8lF/PNGMmJI2+0AZKoW3hGdIi9NAyYE8nsFEnOOvBnRNoDs5kH81oK3ghqm54LnSO6LhN20S0aYNdTLyAAAAAElFTkSuQmCC"

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(831)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(897),
  /* scopeId */
  "data-v-88006176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(815)
__webpack_require__(814)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(886),
  /* scopeId */
  "data-v-36058a7a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(818)
__webpack_require__(817)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(888),
  /* scopeId */
  "data-v-46ac5b5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(840)
__webpack_require__(839)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(902),
  /* scopeId */
  "data-v-e22ebc72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(838)
__webpack_require__(837)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(901),
  /* scopeId */
  "data-v-e2128d70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(836)
__webpack_require__(835)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(900),
  /* scopeId */
  "data-v-e1f65e6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(816)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(887),
  /* scopeId */
  "data-v-42e10945",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(820)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  "data-v-5edcb738",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(842)
__webpack_require__(841)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(903),
  /* scopeId */
  "data-v-eb117020",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(811)
__webpack_require__(812)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(832)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(898),
  /* scopeId */
  "data-v-b1e9b724",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(819)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  "data-v-5e726c08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(826)
__webpack_require__(825)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  "data-v-6bfa2a65",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(813)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  "data-v-2a990d4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(809)
__webpack_require__(808)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(881),
  /* scopeId */
  "data-v-12630a7b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(822)
__webpack_require__(821)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(891),
  /* scopeId */
  "data-v-653d617a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(807)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(880),
  /* scopeId */
  "data-v-0b9acffa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(879),
  /* scopeId */
  "data-v-05882516",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(828)
__webpack_require__(827)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  "data-v-7515268e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(830)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  "data-v-86317dfa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(834)
__webpack_require__(833)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(899),
  /* scopeId */
  "data-v-b2558ae6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(882),
  /* scopeId */
  "data-v-154c330e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(843)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(904),
  /* scopeId */
  "data-v-f75e3bd8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 879:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pay-main-warp column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "home-btn",
    on: {
      "click": function($event) {
        return _vm.goPage('/')
      }
    }
  }, [_vm._v("マイページへ")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row"
  }, _vm._l((_vm.list), function(item, index) {
    return (item.name != '法人プラン' || _vm.revert) ? _c('div', {
      staticClass: "lists-item column"
    }, [_c('div', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "price-box row"
    }, [(item.priceCount != null) ? _c('div', {
      staticClass: "price",
      domProps: {
        "textContent": _vm._s(
          item.name == '法人プラン' ||
          // (item.name == '基本プラン' && !revert) ||
          // (item.name == '認定ファシリテータープラン' && !revert)
          //   ? '未定/月払い'
          //   : numberWithCommas(item.priceCount) + '円/月払い'
          (item.name == '基本プラン' && !_vm.revert) ?
          '未定/月払い' :
          item.name == '認定ファシリテータープラン' ?
          '3,300円/月払い' :
          _vm.numberWithCommas(item.priceYearCount) + '円/月払い'
        )
      }
    }) : _vm._e()]), _vm._v(" "), (item.priceCount != null) ? _c('div', {
      staticClass: "price-box row"
    }, [_c('div', {
      staticClass: "price",
      domProps: {
        "textContent": _vm._s(
          item.name == '法人プラン' ||
          // (item.name == '基本プラン' && !revert) ||
          // (item.name == '認定ファシリテータープラン' && !revert)
          //   ? '未定/年払い'
          //   : numberWithCommas(item.priceYearCount) + '円/年払い'
          (item.name == '基本プラン' && !_vm.revert) ?
          '未定/年払い' :
          item.name == '認定ファシリテータープラン' ?
          '33,000円/年払い' :
          _vm.numberWithCommas(item.priceYearCount) + '円/年払い'
        )
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "des",
      domProps: {
        "innerHTML": _vm._s(item.describe)
      }
    }), _vm._v(" "), _vm._l((item.jurisdiction), function(ite, idx) {
      return _c('div', {
        staticClass: "item-list"
      }, [_c('i', {
        staticClass: "el-icon-success"
      }), _vm._v(" " + _vm._s(ite) + "\n        ")])
    }), _vm._v(" "), (item.priceCount == null && !_vm.revert) ? _c('div', {
      staticClass: "des",
      staticStyle: {
        "font-size": "16px",
        "color": "block",
        "line-height": "20px"
      }
    }, [_vm._v("\n          ※β版リリースのため、"), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("期間限定で基本プランと同じサービスが利用可能")]), _vm._v("となっております。\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btns-box row row-center"
    }, [(
      item.name == '法人プラン' ||
      (item.name == '基本プラン' && !_vm.revert) ||
      (item.name == '認定ファシリテータープラン' && _vm.revert)
    ) ? _c('div', {
      staticClass: "disabled-btn"
    }, [_vm._v("\n            準備中\n          ")]) : (item.price != '無料/月' && item.name != _vm.my_plan) ? _c('el-button', {
      staticClass: "join-btn",
      staticStyle: {
        "font-weight": "700 !important"
      },
      on: {
        "click": function($event) {
          return _vm.tobuy(
            item.id,
            item.price,
            item.describe,
            item.name,
            item.priceYearCount
          )
        }
      }
    }, [_vm._v("購入する\n          ")]) : (item.price != '無料/月' && item.name == _vm.my_plan) ? _c('div', {
      staticClass: "purchased-btn"
    }, [_vm._v("\n            購入済み\n          ")]) : _vm._e()], 1)], 2) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "compare-table-container"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "color": "#577a9a",
      "background-color": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "col-free",
    staticStyle: {
      "background": "#dbdbdb"
    }
  }, [_vm._v("フリ一プラン")]), _vm._v(" "), _c('th', {
    staticClass: "col-h1"
  }, [_vm._v("基本プラン")]), _vm._v(" "), _c('th', {
    staticClass: "col-h1"
  }, [_vm._v("認定ファシリテータープラン")]), _vm._v(" "), (_vm.revert) ? _c('th', {
    staticClass: "col-h1"
  }, [_vm._v("法人プラン")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-free"
  }, [_vm._v("無料")]), _vm._v(" "), _c('th', {
    staticClass: "col-h2",
    domProps: {
      "innerHTML": _vm._s(
        _vm.revert ?
        '330円/月払い<br>3,300円/年払い' :
        '未定/月払い<br>未定/年払い'
      )
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "col-h2",
    domProps: {
      "innerHTML": _vm._s(
        _vm.revert ?
        '4,950円/月払い<br>49,500円/年払い' :
        '3,300円/月払い<br>33,000円/年払い'
      )
    }
  }), _vm._v(" "), (_vm.revert) ? _c('th', {
    staticClass: "col-h2"
  }, [_vm._v("未定/月払い"), _c('br'), _vm._v("未定/年払い")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("過去のプレイ結果を見る")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("プレイヤー参加")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("ルームの作成")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("同時ルーム作成")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }, [_vm._v("1ルーム")]), _vm._v(" "), _c('td', [_vm._v("1ルーム")]), _vm._v(" "), _c('td', [_vm._v("最大5ルーム")]), _vm._v(" "), (_vm.revert) ? _c('td', [_vm._v("最大30ルーム")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("１人プレイ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("1on1プレイ (２人)")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("複数人プレイ (3人)")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("複数人プレイ (4人)")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("1ル―ム最大プレイ人数")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }, [_vm._v("2名")]), _vm._v(" "), _c('td', [_vm._v("4名")]), _vm._v(" "), _c('td', [_vm._v("4名")]), _vm._v(" "), (_vm.revert) ? _c('td', [_vm._v("4名")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("観戦者として参加")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("招待URL発行")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("招待コード発行")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("ルーム名の設定")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("テーマ設定")]), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("手札の公開/非公開設定")]), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("カードコピー機能")]), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("制限時間の変更")]), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("パス機能")]), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("スキップ機能 (ルーム作成時)")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("一時停止機能 (ルーム作成時)")]), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("終了機能 (ルーム作成時)")]), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("結果表示")]), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("画像作成")]), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {})]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("プレイ結果データ保存")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("結果データの対象")]), _vm._v(" "), _c('td', {
    staticClass: "col-free"
  }), _vm._v(" "), _c('td', [_vm._v("本人のみ")]), _vm._v(" "), _c('td', [_vm._v("プレイヤー全員")]), _vm._v(" "), (_vm.revert) ? _c('td', [_vm._v("プレイヤー全員")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "row-h"
  }, [_vm._v("独自URL発行")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _vm._m(63), _vm._v(" "), (_vm.revert) ? _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })]) : _vm._e()])])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "title": _vm.dtitle,
      "visible": _vm.centerDialogVisible,
      "custom-class": "confirmContent",
      "top": "30vh",
      "width": "378px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.des.replace('\n', '<br>'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "colbtns"
  }, [_c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.createPrice('month')
      }
    }
  }, [_vm._v("1ヶ月プラン")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.createPrice('year')
      }
    }
  }, [_vm._v("1年プラン")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "title": _vm.dtitle1,
      "visible": _vm.centerDialogVisible1,
      "custom-class": "confirmContent",
      "top": "30vh",
      "width": "378px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible1 = $event
      }
    }
  }, [_c('div', {
    staticClass: "header-title",
    style: ({
      color: 'red'
    }),
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.dtitle1) + "\n    ")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.des1.replace('\n', '<br>'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "colbtns"
  }, [_c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.updatePlan()
      }
    }
  }, [_vm._v("はい")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible1 = false
      }
    }
  }, [_vm._v("いいえ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("料金プラン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-free"
  }, [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "el-icon-check"
  })])
}]}

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pay-main-warp column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "home-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('/')
      }
    }
  }, [_vm._v("\n        マイページへ\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row m-column"
  }, [(_vm.info.priceCount) ? _c('div', {
    staticClass: "lists-item column"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.info.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box row"
  }, [_c('div', {
    staticClass: "price",
    domProps: {
      "textContent": _vm._s(_vm.monthPlan)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-box row"
  }, [_c('div', {
    staticClass: "price",
    domProps: {
      "textContent": _vm._s(_vm.annualPlan)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "des",
    domProps: {
      "innerHTML": _vm._s(_vm.info.describe)
    }
  }, [_vm._v("\n          お試しプランでまずチームメンバーとゲームしよう！\n        ")]), _vm._v(" "), _vm._l((_vm.info.jurisdiction), function(item, index) {
    return _c('div', {
      staticClass: "item-list"
    }, [_c('i', {
      staticClass: "el-icon-success"
    }), _vm._v(" " + _vm._s(item) + "\n        ")])
  }), _vm._v(" "), _vm._m(1)], 2) : _c('div', {
    staticClass: "lists-item column"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.info.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box row"
  }, [_c('div', {
    staticClass: "price",
    domProps: {
      "innerHTML": _vm._s(_vm.info.price)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "des",
    domProps: {
      "textContent": _vm._s(_vm.info.describe)
    }
  }, [_vm._v("\n          お試しプランでまずチームメンバーとゲームしよう！\n        ")]), _vm._v(" "), _vm._l((_vm.info.jurisdiction), function(item, index) {
    return _c('div', {
      staticClass: "item-list"
    }, [_c('i', {
      staticClass: "el-icon-success"
    }), _vm._v(" " + _vm._s(item) + "\n        ")])
  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('div', {
    staticClass: "edits m-column"
  }, [(_vm.info.priceCount) ? _c('div', {
    staticClass: "over-Time"
  }, [_vm._v("\n          契約期間：" + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "editbtn",
    on: {
      "click": function($event) {
        return _vm.goPage('/pay/index')
      }
    }
  }, [_vm._v("別のプランを確認")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [(_vm.plan != '1on1プラン' && _vm.plan != '基本プラン') ? _c('el-button', {
    staticClass: "editbtn",
    on: {
      "click": function($event) {
        return _vm.goPage(
          '/pay/seturl?price=' + _vm.info.priceCount + '&name=' + _vm.info.name
        )
      }
    }
  }, [_vm._v("固定URLの設定")]) : _vm._e()], 1), _vm._v(" "), (_vm.info.priceCount) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "release",
    on: {
      "click": _vm.showMask
    }
  }, [_vm._v("解約する")])]) : _vm._e()])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "title": "基本プラン",
      "visible": _vm.centerDialogVisible,
      "custom-class": "confirmContent",
      "top": "30vh",
      "width": "378px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("お試しプランでまずチームメンバーとゲームしよう！")]), _vm._v(" "), _c('div', {
    staticClass: "colbtns"
  }, [_c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    }
  }, [_vm._v("1ヶ月プラン")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    }
  }, [_vm._v("1年プラン")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "title": "解約しますか",
      "visible": _vm.dialogSettingVisible,
      "custom-class": "confirmContent",
      "top": "30vh",
      "width": "378px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('span', [_vm._v("お試しプランでまずチームメンバーとゲームしよう！")]), _vm._v(" "), _c('div', {
    staticClass: "colbtns"
  }, [_c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.rescind()
      }
    }
  }, [_vm._v("解約する")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.toClose()
      }
    }
  }, [_vm._v("キャンセル")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("料金プランを確認")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('div', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important",
      "text-align": "center",
      "box-sizing": "border-box",
      "padding": "8px 0"
    }
  }, [_vm._v("\n            利用中\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('div', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important",
      "text-align": "center",
      "box-sizing": "border-box",
      "padding": "8px 0"
    }
  }, [_vm._v("\n            利用中\n          ")])])
}]}

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-box column"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "waiting-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("待機室")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": _vm.deleteRoom
    }
  }, [_vm._v("ルームを削除\n\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "waiting-info-box column"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("基本情報")]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ルーム名")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.roomName))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("開始時刻")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.startTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("テーマ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("カードコピー機能")]), _vm._v(" "), (_vm.info.isCopy) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("あり")]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("なし")])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("手札公開")]), _vm._v(" "), (_vm.info.isPublic) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("公開")]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("非公開")])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人数")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.peopleNumber) + "人")])]), _vm._v(" "), _c('div', {
    staticClass: "item row m-column url-box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("招待URL")]), _vm._v(" "), _c('div', {
    staticClass: "text row"
  }, [_c('div', {
    staticClass: "url-text"
  }, [_vm._v(_vm._s(_vm.info.url))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copyInfo),
      expression: "copyInfo",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "copy-btn",
    attrs: {
      "id": "copy-btn"
    }
  }, [_vm._v("\n\t\t\t\t\tコピーする\n\t\t\t\t")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "waiting-info-box column"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("参加人員(プレイヤー設定)")]), _vm._v(" "), _c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.lists), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [(_vm.info.homeowner == item.id) ? _c('i', {
      staticClass: "el-icon-setting"
    }) : _vm._e(), _vm._v(" "), _c('el-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.checked),
        expression: "item.checked"
      }],
      staticClass: "item",
      attrs: {
        "value": item.sort,
        "type": "primary"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), (_vm.info.homeowner == item.id) ? _c('div', {
      staticClass: "tag"
    }, [_vm._v("ファシリテーター")]) : _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.startGame()
      }
    }
  }, [_vm._v("スタート")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert"
  }, [_vm._v("プレイ時にカードが正常に表示されないときはブラウザを更新してください。")])])])
},staticRenderFns: []}

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-room-box column",
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "waiting-room-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toMy
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("過去に参加した結果")])])]), _vm._v(" "), _c('div', {
    staticClass: "waiting-room-info-box column"
  }, _vm._l((_vm.lists), function(item, index) {
    return (item.peopleNumber > 0 && item.status == 3) ? _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title-box column"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.roomName))]), _vm._v(" "), _c('div', {
      staticClass: "label row m-column",
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('div', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('span', {
      staticClass: "iconfont icon-shijian"
    }), _vm._v(_vm._s(item.startTime))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "iconfont icon-01"
    }), _vm._v(_vm._s(item.homeownerName))]), _vm._v(" "), _c('div', [_c('i', {
      staticClass: "el-icon-collection-tag iconfont"
    }), _vm._v(_vm._s(item.theme))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns-box row row-right"
    }, [_c('el-button', {
      staticClass: "details-btn",
      on: {
        "click": function($event) {
          return _vm.toRoom(item.id)
        }
      }
    }, [_vm._v("結果詳細")])], 1)]) : _vm._e()
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-form column column-center"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "メールアドレス",
      "id": "username"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "パスワード",
      "id": "password",
      "show-password": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-check-container"
  }, [_c('el-checkbox', {
    staticClass: "login-check",
    attrs: {
      "id": "login"
    },
    model: {
      value: (_vm.form.login),
      callback: function($$v) {
        _vm.$set(_vm.form, "login", $$v)
      },
      expression: "form.login"
    }
  }, [_vm._v("ログイン状態を維持")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#a3a3a3"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.shows = 1
      }
    }
  }, [_vm._v("パスワードをお忘れの方")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box column column-center"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        return _vm.doLogin()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ss()
      }
    }
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        _vm.shows = 4
      }
    }
  }, [_vm._v("新規登録")]), _vm._v(" "), _c('el-button', {
    staticClass: "facebook-btn",
    on: {
      "click": function($event) {
        return _vm.faceLogin()
      }
    }
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" Facebookでログイン\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "google-btn",
    on: {
      "click": function($event) {
        return _vm.googleLogin()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px",
      "border-radius": "50%",
      "vertical-align": "middle",
      "margin-right": ""
    },
    attrs: {
      "src": __webpack_require__(855),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Googleでログイン")])])], 1), _vm._v(" "), (_vm.shows == 1) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("パスワードお忘れの方")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("メールアドレス")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "メールアドレスを入力"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendEmail()
      }
    }
  }, [_vm._v("認証コードを送信")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 2) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("パスワードお忘れの方")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("認証コード")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "認証コードを入力"
    },
    model: {
      value: (_vm.yzm),
      callback: function($$v) {
        _vm.yzm = $$v
      },
      expression: "yzm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendXin()
      }
    }
  }, [_vm._v("確認")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 3) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("パスワードお忘れの方")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("新しいパスワード")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "新しいパスワードを入力"
    },
    model: {
      value: (_vm.newPass),
      callback: function($$v) {
        _vm.newPass = $$v
      },
      expression: "newPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("新しいパスワードを確認")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "新しいパスワードを再入力"
    },
    model: {
      value: (_vm.aginPass),
      callback: function($$v) {
        _vm.aginPass = $$v
      },
      expression: "aginPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.edit()
      }
    }
  }, [_vm._v("登録")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 4) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("メールアドレス認証")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("メールアドレス")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "メールアドレスを入力"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendVEmail()
      }
    }
  }, [_vm._v("認証メールを送信")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shows == 5) ? _c('div', {
    staticClass: "poup"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hidemask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("メールアドレス認証")]), _vm._v(" "), _c('div', {
    staticClass: "bboox"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("認証コード")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "認証コードを入力"
    },
    model: {
      value: (_vm.vyzm),
      callback: function($$v) {
        _vm.vyzm = $$v
      },
      expression: "vyzm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bbt"
  }, [_c('el-button', {
    staticClass: "default-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendVXin()
      }
    }
  }, [_vm._v("確認")])], 1)], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo column row-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(340)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("もっとワクワークする世の中を")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_vm._v("会員登録いただいた際のメールアドレスを入力し，「認証コードを送信」のボタンをクリックしてください。"), _c('br'), _vm._v("メールアドレス宛にパスワード再設定用の認証コードを送付したします。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_vm._v("メールアドレスに認証コードを送信しました。"), _c('br'), _vm._v("認証コードの有効期限は発行から10分間です。")])
}]}

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("利用規約 ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n      この利用規約（以下，「本規約」といいます。）は，株式会社トリプルバリュー（以下，「当社」といいます。）がこのウェブサイト上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。"), _c('br'), _vm._v("\n      登録ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第1条（適用）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。"), _c('br'), _vm._v("\n        当社は本サービスに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下，「個別規定」といいます。）をすることがあります。"), _c('br'), _vm._v("\n        これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。"), _c('br'), _vm._v("\n        本規約の規定が前条の個別規定の規定と矛盾する場合には，個別規定において特段の定めなき限り，個別規定の規定が優先されるものとします。")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第2条（利用登録）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        本サービスにおいては，登録希望者が本規約に同意の上，当社の定める方法によって利用登録を申請し，当社がこれを承認することによって，利用登録が完了するものとします。"), _c('br'), _vm._v("\n        当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("利用登録の申請に際して虚偽の事項を届け出た場合")]), _vm._v(" "), _c('li', [_vm._v("本規約に違反したことがある者からの申請である場合")]), _vm._v(" "), _c('li', [_vm._v("その他，当社が利用登録を相当でないと判断した場合")])])]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第3条（ユーザーIDおよびパスワードの管理）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを適切に管理するものとします。"), _c('br'), _vm._v("\n        ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与し，もしくは第三者と共用することはできません。"), _c('br'), _vm._v("\n        当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。"), _c('br'), _vm._v("\n        ユーザーID及びパスワードが第三者によって使用されたことによって生じた損害は，当社に故意又は重大な過失がある場合を除き，当社は一切の責任を負わないものとします。")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第4条（利用料金および支払方法）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        ユーザーは，本サービスの有料部分の対価として，当社が別途定め，本ウェブサイトに表示する利用料金を，当社が指定する方法により支払うものとします。"), _c('br'), _vm._v("\n        ユーザーが利用料金の支払を遅滞した場合には，ユーザーは年14．6％の割合による遅延損害金を支払うものとします。")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第5条（禁止事項）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("法令または公序良俗に違反する行為")]), _vm._v(" "), _c('li', [_vm._v("犯罪行為に関連する行為")]), _vm._v(" "), _c('li', [_vm._v("本サービスの内容等，本サービスに含まれる著作権，商標権ほか知的財産権を侵害する行為")]), _vm._v(" "), _c('li', [_vm._v("当社，ほかのユーザー，またはその他第三者のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為")]), _vm._v(" "), _c('li', [_vm._v("本サービスによって得られた情報を商業的に利用する行為")]), _vm._v(" "), _c('li', [_vm._v("当社のサービスの運営を妨害するおそれのある行為")]), _vm._v(" "), _c('li', [_vm._v("不正アクセスをし，またはこれを試みる行為")]), _vm._v(" "), _c('li', [_vm._v("他のユーザーに関する個人情報等を収集または蓄積する行為")]), _vm._v(" "), _c('li', [_vm._v("不正な目的を持って本サービスを利用する行為")]), _vm._v(" "), _c('li', [_vm._v("本サービスの他のユーザーまたはその他の第三者に不利益，損害，不快感を与える行為")]), _vm._v(" "), _c('li', [_vm._v("他のユーザーに成りすます行為")]), _vm._v(" "), _c('li', [_vm._v("当社が許諾しない本サービス上での宣伝，広告，勧誘，または営業行為")]), _vm._v(" "), _c('li', [_vm._v("面識のない異性との出会いを目的とした行為")]), _vm._v(" "), _c('li', [_vm._v("当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為")]), _vm._v(" "), _c('li', [_vm._v("その他，当社が不適切と判断する行為")])])]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第6条（本サービスの提供の停止等）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        １．当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("本サービスにかかるコンピュータシステムの保守点検または更新を行う場合")]), _vm._v(" "), _c('li', [_vm._v("地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合")]), _vm._v(" "), _c('li', [_vm._v("コンピュータまたは通信回線等が事故により停止した場合")]), _vm._v(" "), _c('li', [_vm._v("その他，当社が本サービスの提供が困難と判断した場合")])]), _vm._v("\n        ２．当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害についても，一切の責任を負わないものとします。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第7条（利用制限および登録抹消）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        １．当社は，ユーザーが以下のいずれかに該当する場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("本規約のいずれかの条項に違反した場合")]), _vm._v(" "), _c('li', [_vm._v("登録事項に虚偽の事実があることが判明した場合")]), _vm._v(" "), _c('li', [_vm._v("料金等の支払債務の不履行があった場合")]), _vm._v(" "), _c('li', [_vm._v("当社からの連絡に対し，一定期間返答がない場合")]), _vm._v(" "), _c('li', [_vm._v("本サービスについて，最終の利用から一定期間利用がない場合")]), _vm._v(" "), _c('li', [_vm._v("その他，当社が本サービスの利用を適当でないと判断した場合")])]), _vm._v("\n        ２．当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第8条（退会）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        ユーザーは，当社の定める退会手続により，本サービスから退会できるものとします。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第9条（保証の否認および免責事項）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        １．当社は，本サービスに事実上または法律上の瑕疵（安全性，信頼性，正確性，完全性，有効性，特定の目的への適合性，セキュリティなどに関する欠陥，エラーやバグ，権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。"), _c('br'), _vm._v("\n        ２．当社は，本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。"), _c('br'), _vm._v("\n        ただし，本サービスに関する当社とユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。"), _c('br'), _vm._v("\n        ３．前項ただし書に定める場合であっても，当社は，当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害（当社またはユーザーが損害発生につき予見し，または予見し得た場合を含みます。）について一切の責任を負いません。また，当社の過失（重過失を除きます。）による債務不履行または不法行為によりユーザーに生じた損害の賠償は，ユーザーから当該損害が発生した月に受領した利用料の額を上限とします。"), _c('br'), _vm._v("\n        ４．当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。"), _c('br')]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第10条（サービス内容の変更等）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第11条（利用規約の変更）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。なお，本規約の変更後，本サービスの利用を開始した場合には，当該ユーザーは変更後の規約に同意したものとみなします。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第12条（個人情報の取扱い）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は，本サービスの利用によって取得する個人情報については，当社「プライバシーポリシー」に従い適切に取り扱うものとします。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第13条（通知または連絡）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        ユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。当社は,ユーザーから,当社が別途定める方式に従った変更届け出がない限り,現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い,これらは,発信時にユーザーへ到達したものとみなします。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第14条（権利義務の譲渡の禁止）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        ユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第15条（広告）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、本サービスに当社または第三者の広告を掲載することができます。\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("第16条（準拠法・裁判管轄）")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        本規約の解釈にあたっては，日本法を準拠法とします。\n        本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。\n        ")])])
}]}

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pay-main-warp column"
  }, [_c('div', {
    staticClass: "lists-box row m-column"
  }, [_c('div', {
    staticClass: "setUrl"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": _vm.goback
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setTitle"
  }, [_vm._v("\n          問い合わせフォーム\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "feedContent"
  }, [_c('div', {
    staticClass: "feed-title"
  }, [_vm._v("\n            お問合せカテゴリー\n          ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "お問合せカテゴリーを選択"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "feed-title",
    staticStyle: {
      "margin-top": "47px"
    }
  }, [_vm._v("\n            お問い合わせ内容\n          ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "resize": "none",
      "rows": 15,
      "placeholder": "お問合せ内容を入力"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    staticClass: "btn_confirm",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.sendMail()
      }
    }
  }, [_vm._v("送信")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setContent"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n            もっとワクワークする世の中を\n          ")])])
}]}

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-result-warp column"
  }, [_c('div', {
    staticClass: "game-result-header"
  }, [_c('div', {
    staticClass: "my-btn",
    on: {
      "click": function($event) {
        return _vm.toMy()
      }
    }
  }, [_vm._v("マイページへ")]), _vm._v(" "), _c('div', {
    staticClass: "my-topic"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.2rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("テーマ:")]), _c('span', {
    staticClass: "my-topic-theme"
  }, [_vm._v(_vm._s(_vm.room.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "title-box column column-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("結果")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("プレイ時間：" + _vm._s(_vm.timeStr))])])]), _vm._v(" "), _c('div', {
    staticClass: "game-result-info-box column"
  }, _vm._l((_vm.users), function(item, index) {
    return _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "tig"
    }, [_vm._v("\n            " + _vm._s(item.tag == "房主" ? "ファシリテーター" : "プレイヤー") + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))])]), _vm._v(" "), _c('div', {
      staticClass: "cards-lists row-flex row"
    }, _vm._l((item.cards), function(item2, index2) {
      return _c('el-image', {
        key: index2,
        staticClass: "card",
        attrs: {
          "src": item2.url,
          "fit": "contain"
        }
      })
    }), 1)])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "game-warp"
  }, [_c('div', {
    staticClass: "game-box row"
  }, [_c('div', {
    staticClass: "game-box-left column",
    class: {
      'current-user': _vm.user2.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user2.id,
      "data-email": _vm.user2.email,
      "data-username": _vm.user2.username,
      "data-realname": _vm.user2.realname,
      "data-lineStatus": _vm.user2.lineStatus,
      "data-isSkip": _vm.user2.isSkip,
      "data-sort": _vm.user2.sort
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user2.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box column column-center"
  }, [_vm._l((_vm.user2.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card2 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 2, _vm.user2.cards, 'user2')
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user2.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card2 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user2.isSkip),
      expression: "user2.isSkip"
    }],
    staticClass: "mask left-mask",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user2.username, _vm.user2.id, 2)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip"
  }, [_vm._v("スキップ解除")]) : _vm._e(), _vm._v("\n        スキップ状態\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "game-box-min column column-center row-flex"
  }, [_c('div', {
    staticClass: "user-box row row-center",
    class: {
      'current-user': _vm.user3.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user3.id,
      "data-email": _vm.user3.email,
      "data-username": _vm.user3.username,
      "data-realname": _vm.user3.realname,
      "data-lineStatus": _vm.user3.lineStatus,
      "data-isSkip": _vm.user3.isSkip,
      "data-sort": _vm.user3.sort
    }
  }, [_c('div', {
    staticClass: "usernamesc"
  }, [_vm._v(_vm._s(_vm.user3.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box row row-center column-center"
  }, [_vm._l((_vm.user3.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('el-image', {
      key: index,
      staticClass: "card2 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 3, _vm.user3.cards, 'user3')
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user3.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('el-image', {
      key: index,
      staticClass: "card2 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "contain"
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user3.isSkip),
      expression: "user3.isSkip"
    }],
    staticClass: "mask top-mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user3.username, _vm.user3.id, 3)
      }
    }
  }, [_vm._v("\n            スキップ解除\n          ")]) : _vm._e(), _vm._v("\n          スキップ状態\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "game-cards-box row-flex row"
  }, [_c('div', {
    staticClass: "left column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location2",
    staticClass: "cards-scroll column column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user2.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ver-cardd"
    }, [_c('el-image', {
      staticClass: "card cardl",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            2,
            $event,
            _vm.user2.discard,
            'user2'
          )
        }
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "min column"
  }, [_c('div', {
    staticClass: "min-top column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location3",
    staticClass: "cards-scroll row column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user3.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            3,
            $event,
            _vm.user3.discard,
            'user3'
          )
        }
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "min-cards-box row-flex column column-center row-center"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "calc(var(--vp) * 8.765 * 1.1)",
      "height": "calc(var(--vp) * 10.925 * 1.1)"
    }
  }, [_c('div', {
    staticClass: "rest"
  }, [_vm._v("残り枚数: " + _vm._s(_vm.cards.length) + "枚")]), _vm._v(" "), _c('div', {
    ref: "gamecardslists",
    staticClass: "cards-lists"
  }, _vm._l((_vm.cards), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card-box",
      class: 'card' + item.id,
      style: (item.style)
    }, [_c('el-image', {
      staticClass: "card",
      attrs: {
        "src": _vm.cardsBack,
        "fit": "contain"
      },
      on: {
        "click": function($event) {
          return _vm.extractCard(item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.extracting) ? _c('div', {
    staticClass: "card-top"
  }, [(_vm.info.isPublic || _vm.mode == 'watch' || _vm.user1.sort == _vm.playUser) ? _c('el-image', {
    staticClass: "card cardh",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.extractCardInfo.url,
      "fit": "contain"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.info.isPublic && _vm.mode != 'watch' && _vm.user1.sort != _vm.playUser) ? _c('el-image', {
    staticClass: "card cardh",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.cardsBack,
      "fit": "contain"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "min-bottom column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists cards-lists-mine",
    on: {
      "click": function($event) {
        return _vm.discardCard(1, $event)
      }
    }
  }, [_c('div', {
    ref: "location1",
    staticClass: "cards-scroll row column-center",
    style: ({
      width: _vm.scrollWidth
    }),
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user1.discard), function(item, index) {
    return _c('div', {
      key: item.url,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            1,
            $event,
            _vm.user1.discard,
            'user1'
          )
        }
      }
    })], 1)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "right column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location4",
    staticClass: "cards-scroll column column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user4.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ver-cardd"
    }, [_c('el-image', {
      staticClass: "card cardr",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            4,
            $event,
            _vm.user4.discard,
            'user4'
          )
        }
      }
    })], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "game-box-right column",
    class: {
      'current-user': _vm.user4.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user4.id,
      "data-email": _vm.user4.email,
      "data-username": _vm.user4.username,
      "data-realname": _vm.user4.realname,
      "data-lineStatus": _vm.user4.lineStatus,
      "data-isSkip": _vm.user4.isSkip,
      "data-sort": _vm.user4.sort
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user4.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box column column-center",
    staticStyle: {
      "flex-direction": "column-reverse"
    }
  }, [_vm._l((_vm.user4.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card4 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 4, _vm.user4.cards, 'user4')
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user4.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card4 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user4.isSkip),
      expression: "user4.isSkip"
    }],
    staticClass: "mask right-mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user4.username, _vm.user4.id, 4)
      }
    }
  }, [_vm._v("\n          スキップ解除\n        ")]) : _vm._e(), _vm._v("\n        スキップ状態\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "game-user-self row"
  }, [_c('div', {
    staticClass: "myself"
  }, [_vm._v(_vm._s(_vm.user1.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-box",
    attrs: {
      "data-id": _vm.user1.id,
      "data-email": _vm.user1.email,
      "data-username": _vm.user1.username,
      "data-realname": _vm.user1.realname,
      "data-lineStatus": _vm.user1.lineStatus,
      "data-isSkip": _vm.user1.isSkip,
      "data-sort": _vm.user1.sort
    }
  }, [_c('div', {
    staticClass: "user-cards-box row row-center column-center",
    class: {
      'current-user': _vm.user1.sort == _vm.playUser
    }
  }, [_vm._l((_vm.user1.cards), function(item, index) {
    return _c('el-image', {
      key: index,
      staticClass: "card cardh",
      class: {
        cardchecked: _vm.mode == 'play'
      },
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeSelfCard(item, index, $event, 1)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user1.isSkip),
      expression: "user1.isSkip"
    }],
    staticClass: "mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user1.username, _vm.user1.id, 1)
      }
    }
  }, [_vm._v("\n            スキップ解除\n          ")]) : _vm._e(), _vm._v("\n          スキップ状態\n        ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "room-info row-flex column column-center"
  }, [(_vm.mode == 'play' || _vm.isHomewer) ? _c('div', {
    staticClass: "btns-box row"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doTimeOut()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'watch'),
      expression: "mode != 'watch'"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSelfSkip()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#63aeb0",
      "font-weight": "bold"
    }
  }, [_vm._v("Pass")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'watch' && _vm.isHomewer),
      expression: "mode == 'watch' && isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPage('/')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomewer),
      expression: "isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mode == 'watch') ? _c('div', {
    staticClass: "item countdown spectator",
    staticStyle: {
      "flex-direction": "row",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("観戦者")]), _vm._v(" "), (_vm.mode == 'watch' && _vm.isHomewer) ? _c('div', {
    staticClass: "watch-number peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item countdown ii-t"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.userTimes)), _c('span', [_vm._v("s")])]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item times ii-t"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.gameTimes.str))]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("トータル時間")])]), _vm._v(" "), (!(_vm.mode == 'watch' && _vm.isHomewer)) ? _c('div', {
    staticClass: "item peopleNumber ii-t"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "設定",
      "top": "250px",
      "visible": _vm.dialogSettingVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.toFinish()
      }
    }
  }, [_vm._v("終了")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "一時停止",
      "top": "250px",
      "visible": _vm.dialogPauseVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPauseVisiblePre = $event
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPause()
      }
    }
  }, [_vm._v("停止する")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "show-close": false,
      "title": "一時停止中",
      "top": "250px",
      "visible": _vm.dialogPauseVisible && _vm.cards.length > 0,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogPauseVisible && _vm.cards, "length > 0", $event)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reStart()
      }
    }
  }, [_vm._v("ゲームを再開する")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "title": "ゲームを終了しますか？",
      "top": "250px",
      "visible": _vm.dialogFinishVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFinishVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.doFinish()
      }
    }
  }, [_vm._v("終了する")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toGame()
      }
    }
  }, [_vm._v("続ける")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "Pass",
      "top": "250px",
      "visible": _vm.dialogSkipVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPass()
      }
    }
  }, [_vm._v("パスする")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "skip-box",
    attrs: {
      "title": "スキップさせるユーザーを選択",
      "top": "250px",
      "visible": _vm.dialogSkipVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.users2), function(item, index) {
    return (!item.isHomewer) ? _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      on: {
        "click": function($event) {
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [_c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box column"
  }, [_c('h1', {
    staticClass: "main"
  }, [_vm._v("\n      個人情報保護方針"), _c('br'), _vm._v("\n      Privacy Policy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n      株式会社トリプルバリュー（以下、「当社」といいます。）は、経営コンサルティング、企業研修、エンゲージメントカード販売などで事業を展開しています。当社が取り扱う個人情報について、適切に取得、利用及び提供を行うため、個人情報の保護に関する法律その他関連法令を遵守するとともに、本個人情報保護方針を定め、個人情報管理体制を確立し、企業として責任ある対応を実現するものとします。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("法令、規範の遵守")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守します。そのため、日本工業規格「個人情報保護マネジメントシステム — 要求事項」(JIS Q 15001)に準拠した個人情報保護マネジメントシステムを策定し、適切に運用いたします。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("個人情報の安全対策")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の正確性及び安全性確保のために、個人情報の漏えい、滅失又はき損の防止及び是正のための適切な措置を講じます。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("目的外利用の禁止")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、事業の内容及び規模を考慮した適切な個人情報の取得、利用及び提供を行います。それには特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わないこと及びそのための措置を講じることを含みます。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("個人情報取扱の委託")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の取扱いの全部又は一部を委託する場合は、その取扱いを委託された個人情報の安全管理が図られるよう、委託を受けた者に対する必要かつ適切な監督を行います。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("苦情・相談に対する適切な対応")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、個人情報の取扱いに関する苦情及び相談への適切かつ迅速な対応に努めます。また、当社が保有する保有個人データの開示等の請求等(利用目的の通知、開示、訂正・追加又は削除、利用又は提供の停止）を受け付けます。開示等の求めの手続きにつきましては、「個人情報苦情および相談窓口」までご連絡ください。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("見直し及び改善")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        当社は、本個人情報保護方針の内容を適宜見直すとともに、個人情報保護マネジメントシステムの継続的改善に努めます。\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "main"
  }, [_vm._v("個人情報苦情および相談窓口")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("\n        〒532-0011"), _c('br'), _vm._v("\n        大阪府大阪市淀川区西中島6-3-32 第2新大阪ビル7F"), _c('br'), _vm._v("\n        株式会社トリプルバリュー"), _c('br'), _c('br'), _vm._v("\n        個人情報保護管理者：代表取締役　山本龍太"), _c('br'), _vm._v("\n        e-mail：info@triplevalue.jp"), _c('br'), _vm._v("\n        (受付時間 月曜日～金曜日 祝祭日を除く 10時～17時)\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("\n        制定：2022年6月1日"), _c('br'), _vm._v("\n        株式会社トリプルバリュー"), _c('br'), _vm._v("\n        代表取締役 山本龍太\n      ")])])
}]}

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-result-warp column"
  }, [_c('div', {
    staticClass: "game-result-header"
  }, [_c('div', {
    staticClass: "my-btn",
    on: {
      "click": function($event) {
        return _vm.toMy()
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "game-result-info-box column"
  }, [_c('div', {
    staticClass: "anbox"
  }, [_c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.details), function(item, index) {
    return _c('div', {
      staticClass: "tab-item",
      style: (index == _vm.idx ? 'background:#1E7578 !important;color:#fff !important' : ''),
      domProps: {
        "textContent": _vm._s(item.title)
      },
      on: {
        "click": function($event) {
          return _vm.choose(index)
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ascontent m-column"
  }, [_c('div', [_c('echarts', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "id": _vm.id,
      "userid": _vm.ids
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "textword"
  }, [_c('div', {
    staticClass: "wordTitle",
    domProps: {
      "textContent": _vm._s(_vm.details[_vm.idx].inner)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wordtext"
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.details[_vm.idx].text1)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.details[_vm.idx].text2)
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box column column-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("チャート分析")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v(" ")])])
}]}

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-box column"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": _vm.toMy
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "form-box column",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "ルーム名",
      "prop": "roomName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ルーム名を入力"
    },
    model: {
      value: (_vm.ruleForm.roomName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "roomName", $$v)
      },
      expression: "ruleForm.roomName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "birthday-box column"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px",
      "color": "#434242"
    }
  }, [_vm._v("開始日時・時刻")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticClass: "birthday-month",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "placeholder": "年を選択してください"
    },
    model: {
      value: (_vm.ruleForm.year),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "year", $$v)
      },
      expression: "ruleForm.year"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "年",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.year), function(year, index) {
    return (index >= 1) ? _c('el-option', {
      key: index,
      attrs: {
        "label": year,
        "value": year
      }
    }, [_vm._v("\n                " + _vm._s(year))]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "month"
    }
  }, [_c('el-select', {
    staticClass: "birthday-month",
    attrs: {
      "placeholder": "月を選択してください"
    },
    on: {
      "change": _vm.monthChange
    },
    model: {
      value: (_vm.ruleForm.month),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "month", $$v)
      },
      expression: "ruleForm.month"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "月",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((12), function(index) {
    return (index >= 1) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "day"
    }
  }, [_c('el-select', {
    staticClass: "birthday-day",
    attrs: {
      "placeholder": "日を選択してください"
    },
    model: {
      value: (_vm.ruleForm.day),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "day", $$v)
      },
      expression: "ruleForm.day"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "日",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.choosedate), function(index) {
    return (index >= 1) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "hour"
    }
  }, [_c('el-select', {
    staticClass: "birthday-hour",
    attrs: {
      "placeholder": "時を選択してください"
    },
    model: {
      value: (_vm.ruleForm.hour),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "hour", $$v)
      },
      expression: "ruleForm.hour"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "時",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.hourrs), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "min"
    }
  }, [_c('el-select', {
    staticClass: "birthday-min",
    attrs: {
      "placeholder": "分を選択してください"
    },
    model: {
      value: (_vm.ruleForm.min),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "min", $$v)
      },
      expression: "ruleForm.min"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "分",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((60), function(index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": index - 1,
        "value": index - 1
      }
    })
  })], 2)], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "テーマ",
      "prop": "theme"
    }
  }, [_c('el-radio-group', {
    staticClass: "themebox row",
    on: {
      "change": _vm.chooseTheme
    },
    model: {
      value: (_vm.ruleForm.theme),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "theme", $$v)
      },
      expression: "ruleForm.theme"
    }
  }, _vm._l((_vm.theme), function(item, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": item,
        "name": "theme"
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.showinput) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "入力してください"
    },
    on: {
      "input": _vm.otherInsert
    },
    model: {
      value: (_vm.diy),
      callback: function($$v) {
        _vm.diy = $$v
      },
      expression: "diy"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fun-box row m-column",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手札公開",
      "prop": "isPublic"
    }
  }, [_c('el-radio-group', {
    staticClass: "row",
    staticStyle: {
      "height": "43px"
    },
    on: {
      "change": _vm.publicChange
    },
    model: {
      value: (_vm.ruleForm.isPublic),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isPublic", $$v)
      },
      expression: "ruleForm.isPublic"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1",
      "name": "isPublic"
    }
  }, [_vm._v("公開")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "0",
      "name": "isPublic"
    }
  }, [_vm._v("非公開")])], 1)], 1), _vm._v(" "), (_vm.ruleForm.isPublic == 1) ? _c('el-form-item', {
    staticClass: "copyFun",
    attrs: {
      "label": "カードコピー機能",
      "prop": "isCopy"
    }
  }, [_c('el-radio-group', {
    staticClass: "row",
    staticStyle: {
      "height": "43px"
    },
    model: {
      value: (_vm.ruleForm.isCopy),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isCopy", $$v)
      },
      expression: "ruleForm.isCopy"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1",
      "name": "isCopy"
    }
  }, [_vm._v("あり")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "0",
      "name": "isCopy"
    }
  }, [_vm._v("なし")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人数",
      "prop": "peopleNumber"
    }
  }, [_c('el-select', {
    staticClass: "select-peopleNum",
    attrs: {
      "placeholder": "人数を選択"
    },
    model: {
      value: (_vm.ruleForm.peopleNumber),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "peopleNumber", $$v)
      },
      expression: "ruleForm.peopleNumber"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選んでください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.peopleNumber), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num,
        "value": num
      }
    }, [_vm._v(_vm._s(num) + "人\n            ")])
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "制限時間",
      "prop": "peopleNumber"
    }
  }, [_c('el-select', {
    staticClass: "select-peopleNum",
    attrs: {
      "placeholder": "人数を選択"
    },
    model: {
      value: (_vm.ruleForm.turnTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "turnTime", $$v)
      },
      expression: "ruleForm.turnTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選んでください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.turnTime), function(num, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": num,
        "value": num
      }
    }, [_vm._v(_vm._s(num) + "s")])
  })], 2)], 1)], 1), _vm._v(" "), (_vm.plan != '1on1プラン' && _vm.plan != '基本プラン') ? _c('el-form-item', {
    attrs: {
      "label": "公開URL",
      "prop": "isCustom"
    }
  }, [_c('el-radio-group', {
    staticClass: "row",
    on: {
      "change": _vm.changeUrlType
    },
    model: {
      value: (_vm.ruleForm.isCustom),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isCustom", $$v)
      },
      expression: "ruleForm.isCustom"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1",
      "name": "isCustom"
    },
    model: {
      value: (_vm.ruleForm.isCustom),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isCustom", $$v)
      },
      expression: "ruleForm.isCustom"
    }
  }, [_vm._v("ランダム")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2",
      "name": "isCustom",
      "disabled": _vm.plan == '1on1プラン' || _vm.plan == '基本プラン' ? true : false
    },
    model: {
      value: (_vm.ruleForm.isCustom),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isCustom", $$v)
      },
      expression: "ruleForm.isCustom"
    }
  }, [_vm._v("固定")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.isCustom == 2),
      expression: "ruleForm.isCustom == 2"
    }],
    staticClass: "url-box",
    attrs: {
      "label": "",
      "prop": "url"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.showurl))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "後ろの部分を入力"
    },
    on: {
      "change": _vm.Sechange
    },
    model: {
      value: (_vm.ruleForm.url),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "url", $$v)
      },
      expression: "ruleForm.url"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選んでください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.urls), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSub('ruleForm')
      }
    }
  }, [_vm._v("ルームを作成する")])], 1)]), _vm._v(" "), _c('footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("ルームを作成")])]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("もっとワクワークする世の中を")])])
}]}

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('vfooter')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-box column"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "form-box column",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "お名前",
      "prop": "realname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "お名前を入力"
    },
    model: {
      value: (_vm.ruleForm.realname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "realname", $$v)
      },
      expression: "ruleForm.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "フリガナ (カタカナを入力)",
      "prop": "falsename"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "フリガナを入力"
    },
    model: {
      value: (_vm.ruleForm.falsename),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "falsename", $$v)
      },
      expression: "ruleForm.falsename"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "ニックネーム (全角8文字まで)",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "8",
      "placeholder": "ニックネームを入力"
    },
    model: {
      value: (_vm.ruleForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "nickname", $$v)
      },
      expression: "ruleForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sex-box m-row",
    attrs: {
      "label": "性別",
      "prop": "sex"
    }
  }, [_c('el-radio-group', {
    staticClass: "m-row",
    model: {
      value: (_vm.ruleForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sex", $$v)
      },
      expression: "ruleForm.sex"
    }
  }, _vm._l((_vm.sexBox), function(item, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index,
        "value": index,
        "name": "sex"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', [_c('div', {
    staticClass: "row m-row"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "生年月",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticClass: "birthday-year",
    attrs: {
      "placeholder": "年を選択してください"
    },
    on: {
      "change": _vm.monthChange
    },
    model: {
      value: (_vm.ruleForm.year),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "year", $$v)
      },
      expression: "ruleForm.year"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "年",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((2022), function(index) {
    return (index >= 1900) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "month"
    }
  }, [_c('el-select', {
    staticClass: "birthday-month",
    attrs: {
      "placeholder": "月を選択してください"
    },
    on: {
      "change": _vm.monthChange
    },
    model: {
      value: (_vm.ruleForm.month),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "month", $$v)
      },
      expression: "ruleForm.month"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "月",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((12), function(index) {
    return (index >= 1) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "住所",
      "prop": "address"
    }
  }, [_c('el-select', {
    staticClass: "select-region",
    attrs: {
      "placeholder": "都道府県を選択"
    },
    model: {
      value: (_vm.ruleForm.address),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "address", $$v)
      },
      expression: "ruleForm.address"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選択してください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.region), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "label": "職業",
      "prop": "job"
    }
  }, [_c('el-select', {
    staticClass: "select-job",
    attrs: {
      "placeholder": "職業を選択"
    },
    model: {
      value: (_vm.ruleForm.job),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "job", $$v)
      },
      expression: "ruleForm.job"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選択してください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.job), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "メールアドレス (有効なメールアドレスを入力)",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "メールアドレスを入力",
      "disabled": _vm.isVerify
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "メールアドレスを再入力",
      "prop": "reemail"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "確認のためメールアドレスを再入力",
      "disabled": _vm.isVerify
    },
    model: {
      value: (_vm.ruleForm.reemail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "reemail", $$v)
      },
      expression: "ruleForm.reemail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "パスワード (6文字以上入力)",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "6文字以上のパスワードを入力"
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "パスワードを再入力",
      "prop": "repassword"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "確認のためパスワードを再入力"
    },
    model: {
      value: (_vm.ruleForm.repassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "repassword", $$v)
      },
      expression: "ruleForm.repassword"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "agree-box"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "agree"
    }
  }, [_c('el-checkbox', {
    staticClass: "agree-check",
    attrs: {
      "label": "",
      "name": "agree"
    },
    model: {
      value: (_vm.ruleForm.agree),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "agree", $$v)
      },
      expression: "ruleForm.agree"
    }
  }), _vm._v(" "), _c('el-link', {
    attrs: {
      "href": "https://online.engagement-card.com/#/terms-of-service",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "type": "primary"
    }
  }, [_vm._v("利用規約")]), _vm._v("に同意する\n        ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center m-column",
    staticStyle: {
      "width": "80%",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticClass: "register-btn",
    on: {
      "click": function($event) {
        return _vm.doReg('ruleForm')
      }
    }
  }, [_vm._v("アカウントを作成する")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center m-column",
    staticStyle: {
      "width": "80%",
      "margin": "10px auto",
      "text-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("アカウントをお持ちの方はこちらへ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(340)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("アカウント作成")])]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("もっとワクワークする世の中を")])])
}]}

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pay-main-warp column"
  }, [_c('div', {
    staticClass: "lists-box row m-column"
  }, [_c('div', {
    staticClass: "setUrl"
  }, [_c('div', {
    staticClass: "setTitle"
  }, [_vm._v("\n          固定URLの設定\n        ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.multies) ? _c('div', {
    staticClass: "setInput"
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.passFormCopy.url1.trim() !== '' || _vm.plan == 'フリープラン' || _vm.plan == '基本プラン'
    },
    model: {
      value: (_vm.passForm.url1),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url1", $$v)
      },
      expression: "passForm.url1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.multies) ? _c('div', {
    staticClass: "setInput",
    staticStyle: {
      "height": "350px",
      "overflow-y": "scroll"
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm
    }
  }, [_c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.1",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.passFormCopy.url1.trim() !== '' || _vm.plan == 'フリープラン' || _vm.plan == '基本プラン'
    },
    model: {
      value: (_vm.passForm.url1),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url1", $$v)
      },
      expression: "passForm.url1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.2",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.passFormCopy.url2.trim() !== '' || _vm.plan != '法人プラン'
    },
    model: {
      value: (_vm.passForm.url2),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url2", $$v)
      },
      expression: "passForm.url2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.3",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.passFormCopy.url3.trim() !== '' || _vm.plan != '法人プラン'
    },
    model: {
      value: (_vm.passForm.url3),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url3", $$v)
      },
      expression: "passForm.url3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.4",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.passFormCopy.url4.trim() !== '' || _vm.plan != '法人プラン'
    },
    model: {
      value: (_vm.passForm.url4),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url4", $$v)
      },
      expression: "passForm.url4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.5",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.passFormCopy.url5.trim() !== '' || _vm.plan != '法人プラン'
    },
    model: {
      value: (_vm.passForm.url5),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url5", $$v)
      },
      expression: "passForm.url5"
    }
  })], 1), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.6",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url6),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url6", $$v)
      },
      expression: "passForm.url6"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.7",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url7),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url7", $$v)
      },
      expression: "passForm.url7"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.8",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url8),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url8", $$v)
      },
      expression: "passForm.url8"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.9",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url9),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url9", $$v)
      },
      expression: "passForm.url9"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.10",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url10),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url10", $$v)
      },
      expression: "passForm.url10"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.11",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url11),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url11", $$v)
      },
      expression: "passForm.url11"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.12",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url12),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url12", $$v)
      },
      expression: "passForm.url12"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.13",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url13),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url13", $$v)
      },
      expression: "passForm.url13"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.14",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url14),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url14", $$v)
      },
      expression: "passForm.url14"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.15",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url15),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url15", $$v)
      },
      expression: "passForm.url15"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.16",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url16),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url16", $$v)
      },
      expression: "passForm.url16"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.17",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url17),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url17", $$v)
      },
      expression: "passForm.url17"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.18",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url18),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url18", $$v)
      },
      expression: "passForm.url18"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.19",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url19),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url19", $$v)
      },
      expression: "passForm.url19"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.20",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url20),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url20", $$v)
      },
      expression: "passForm.url20"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.21",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url21),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url21", $$v)
      },
      expression: "passForm.url21"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.22",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url22),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url22", $$v)
      },
      expression: "passForm.url22"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.23",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url23),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url23", $$v)
      },
      expression: "passForm.url23"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.24",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url24),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url24", $$v)
      },
      expression: "passForm.url24"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.25",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url25),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url25", $$v)
      },
      expression: "passForm.url25"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.26",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url26),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url26", $$v)
      },
      expression: "passForm.url26"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.27",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url27),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url27", $$v)
      },
      expression: "passForm.url27"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.28",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url28),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url28", $$v)
      },
      expression: "passForm.url28"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.29",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url29),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url29", $$v)
      },
      expression: "passForm.url29"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-form-item', {
    staticClass: "for_item",
    attrs: {
      "label": "NO.30",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.passForm.url30),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "url30", $$v)
      },
      expression: "passForm.url30"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_vm._v("\n          ※一度決定すると変更することが出来ません\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    staticClass: "btn_cancel",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('/my')
      }
    }
  }, [_vm._v("マイページへ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn_confirm",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.settled
    }
  }, [_vm._v("決定")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setContent"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n            設定した文字がURLに反映されます。\n          ")]), _vm._v(" "), _c('div', [_vm._v("\n            例）engagementcard　と設定した場合のURLは、https://OOOO/engagementcard　となる。\n          ")])])
}]}

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-box"
  }, [_c('div', {
    staticClass: "footer-text"
  }, [_c('span', {
    on: {
      "click": _vm.toTermsOfService
    }
  }, [_vm._v("利用規約")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.toPrivacyPolicy
    }
  }, [_vm._v("プライバシーポリシー")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.toFeedback
    }
  }, [_vm._v("問い合わせ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-room-index-box column"
  }, [_c('div', {
    staticClass: "waiting-room-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": _vm.toMy
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("招待されたルーム")])]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("招待されたルームが表示されない場合は、招待リンクから再度ご参加ください。")])]), _vm._v(" "), _c('div', {
    staticClass: "waiting-room-info-box column"
  }, _vm._l((_vm.lists), function(item, index) {
    return _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title-box column"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.roomName))]), _vm._v(" "), _c('div', {
      staticClass: "label row m-column"
    }, [_c('div', [_c('span', {
      staticClass: "iconfont icon-shijian"
    }), _vm._v(_vm._s(item.startTime))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "iconfont icon-01"
    }), _vm._v(_vm._s(item.homeownerName))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns-box row row-right"
    }, [_c('el-button', {
      staticClass: "details-btn",
      on: {
        "click": function($event) {
          return _vm.toRoom(item.id, item.isHomeownerFlag)
        }
      }
    }, [_vm._v("詳細を見る")])], 1)])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echart-container",
    style: ({
      height: _vm.height,
      width: _vm.width
    }),
    attrs: {
      "id": _vm.id,
      "userid": _vm.userid
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logout-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.doLogout()
      }
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('div', {
    staticClass: "main-warp column"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("マイページ")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("ようこそ、" + _vm._s(_vm.nickname) + " 様")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row"
  }, [_c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": function($event) {
        return _vm.goPage('/room/index')
      }
    }
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": _vm.record
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon1.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("ルームに参加する")])], 1), _vm._v(" "), _c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": function($event) {
        return _vm.goPage('/workspace')
      }
    }
  }, [_c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon2.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("ルームを作成する")])])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row"
  }, [_c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": _vm.toRecord
    }
  }, [(_vm.su != 1) ? _c('div', {
    staticClass: "ribbon"
  }, [_c('span', {
    staticClass: "ribbon2"
  }, [_vm._v("有料")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon3.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("過去の結果を見る")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-item column column-center",
    on: {
      "click": function($event) {
        return _vm.goPage('/info')
      }
    }
  }, [_c('div', {
    staticClass: "icon column column-center row-center"
  }, [_c('el-image', {
    attrs: {
      "src": "https://online.engagement-card.com/img/icon4.png",
      "fit": "contain"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("アカウントを確認・変更")])])]), _vm._v(" "), (_vm.su == 0) ? _c('div', {
    staticClass: "des-box su",
    on: {
      "click": function($event) {
        return _vm.goPage('/pay/index')
      }
    }
  }, [_vm._v("有料プラン"), _c('br'), _vm._v("機能をアップグレードしませんか？")]) : _c('div', {
    staticClass: "des-box",
    on: {
      "click": function($event) {
        return _vm.goPage('/pay/choose')
      }
    }
  }, [_vm._v(" 料金プランを確認\n    ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-room-in-box column"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.toBack()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "waiting-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("待機室")]), _vm._v(" "), (_vm.home == 1) ? _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": _vm.deleteRoom
    }
  }, [_vm._v("\n                ルームを削除\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "waiting-info-box column"
  }, [_c('div', {
    staticClass: "sub-title"
  }, [_vm._v("基本情報")]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ルーム名")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.roomName))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("ファシリテーター")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.homeownerName))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("開始時刻")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.startTime))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("テーマ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("手札公開")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.isPublic))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("カードコピー機能")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.isCopy))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人数")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.info.peopleNumber) + "人")])])]), _vm._v(" "), (_vm.isJoin == false && _vm.home != 1) ? _c('div', [_c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": _vm.doJoin
    }
  }, [_vm._v("参加する")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert"
  }, [_vm._v("プレイ時にカードが正常に表示されないときはブラウザを更新してください。")])]) : _c('div', [(_vm.status == 'waiting') ? _c('div', {
    staticClass: "waiting-des-box column row-center"
  }, [_c('div', [_vm._v("ファシリテーターがプレイヤーを選択中です。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("しばらくお待ちください。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("プレイ時にカードが正常に表示されないときはブラウザを更新してください。")])]) : _c('div', {
    staticClass: "waiting-des-box column row-center"
  }, [_c('div', [_vm._v("このゲームは既に開始されています。")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "change-box",
    attrs: {
      "title": "招待コードを入力してください",
      "top": "250px",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm,
      "rules": _vm.passRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "autocomplete": "off",
      "placeholder": ""
    },
    model: {
      value: (_vm.passForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "password", $$v)
      },
      expression: "passForm.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box row row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSub('passForm')
      }
    }
  }, [_vm._v("続ける")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "game-warp"
  }, [_c('div', {
    staticClass: "game-box row"
  }, [_c('div', {
    staticClass: "game-box-left column",
    class: {
      'current-user': _vm.user2.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user2.id,
      "data-email": _vm.user2.email,
      "data-username": _vm.user2.username,
      "data-realname": _vm.user2.realname,
      "data-lineStatus": _vm.user2.lineStatus,
      "data-isSkip": _vm.user2.isSkip,
      "data-sort": _vm.user2.sort
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user2.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box column column-center"
  }, [_vm._l((_vm.user2.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card2 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 2, _vm.user2.cards, 'user2')
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user2.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card2 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user2.isSkip),
      expression: "user2.isSkip"
    }],
    staticClass: "mask left-mask",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user2.username, _vm.user2.id, 2)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip"
  }, [_vm._v("スキップ解除")]) : _vm._e(), _vm._v("\n        スキップ状態\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "game-box-min column column-center row-flex"
  }, [_c('div', {
    staticClass: "game-cards-box row-flex row"
  }, [_c('div', {
    staticClass: "left column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location2",
    staticClass: "cards-scroll column column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user2.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ver-cardd"
    }, [_c('el-image', {
      staticClass: "card cardl",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            2,
            $event,
            _vm.user2.discard,
            'user2'
          )
        }
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "min column row-flex"
  }, [_c('div', {
    staticClass: "min-cards-box row-flex column column-center row-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "calc(var(--vp) * 8.765 * 1.1)",
      "height": "calc(var(--vp) * 10.925 * 1.1)"
    }
  }, [_c('div', {
    staticClass: "rest"
  }, [_vm._v("残り枚数: " + _vm._s(_vm.cards.length) + "枚")]), _vm._v(" "), _c('div', {
    ref: "gamecardslists",
    staticClass: "cards-lists"
  }, _vm._l((_vm.cards), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card-box",
      class: 'card' + item.id,
      style: (item.style)
    }, [_c('el-image', {
      staticClass: "card",
      attrs: {
        "src": _vm.cardsBack,
        "fit": "contain"
      },
      on: {
        "click": function($event) {
          return _vm.extractCard(item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.extracting) ? _c('div', {
    staticClass: "card-top"
  }, [(_vm.info.isPublic || _vm.mode == 'watch' || _vm.user1.sort == _vm.playUser) ? _c('el-image', {
    staticClass: "card cards",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.extractCardInfo.url,
      "fit": "contain"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.info.isPublic && _vm.mode != 'watch' && _vm.user1.sort != _vm.playUser) ? _c('el-image', {
    staticClass: "card cards",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.cardsBack,
      "fit": "contain"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "min-bottom column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists cards-lists-mine",
    on: {
      "click": function($event) {
        return _vm.discardCard(1, $event)
      }
    }
  }, [_c('div', {
    ref: "location1",
    staticClass: "cards-scroll row column-center",
    style: ({
      width: _vm.scrollWidth
    }),
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user1.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            1,
            $event,
            _vm.user1.discard,
            'user1'
          )
        }
      }
    })], 1)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "right column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location3",
    staticClass: "cards-scroll column column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user3.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ver-cardd"
    }, [_c('el-image', {
      staticClass: "card cardr",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            3,
            $event,
            _vm.user3.discard,
            'user3'
          )
        }
      }
    })], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "game-box-right column",
    class: {
      'current-user': _vm.user3.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user3.id,
      "data-email": _vm.user3.email,
      "data-username": _vm.user3.username,
      "data-realname": _vm.user3.realname,
      "data-lineStatus": _vm.user3.lineStatus,
      "data-isSkip": _vm.user3.isSkip,
      "data-sort": _vm.user3.sort
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user3.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box column column-center",
    staticStyle: {
      "flex-direction": "column-reverse"
    }
  }, [_vm._l((_vm.user3.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card3 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 3, _vm.user3.cards, 'user3')
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user3.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card3 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user3.isSkip),
      expression: "user3.isSkip"
    }],
    staticClass: "mask right-mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user3.username, _vm.user3.id, 3)
      }
    }
  }, [_vm._v("\n          スキップ解除\n        ")]) : _vm._e(), _vm._v("\n        スキップ状態\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "game-user-self row"
  }, [_c('div', {
    staticClass: "myself"
  }, [_vm._v(_vm._s(_vm.user1.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-box",
    attrs: {
      "data-id": _vm.user1.id,
      "data-email": _vm.user1.email,
      "data-username": _vm.user1.username,
      "data-realname": _vm.user1.realname,
      "data-lineStatus": _vm.user1.lineStatus,
      "data-isSkip": _vm.user1.isSkip,
      "data-sort": _vm.user1.sort
    }
  }, [_c('div', {
    staticClass: "user-cards-box row row-center column-center",
    class: {
      'current-user': _vm.user1.sort == _vm.playUser
    }
  }, [_vm._l((_vm.user1.cards), function(item, index) {
    return _c('el-image', {
      key: index,
      staticClass: "card cards",
      class: {
        cardchecked: _vm.mode == 'play'
      },
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeSelfCard(item, index, $event, 1)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user1.isSkip),
      expression: "user1.isSkip"
    }],
    staticClass: "mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user1.username, _vm.user1.id, 1)
      }
    }
  }, [_vm._v("\n            スキップ解除\n          ")]) : _vm._e(), _vm._v("\n          スキップ状態\n        ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "room-info row-flex column column-center"
  }, [(_vm.mode == 'play' || _vm.isHomewer) ? _c('div', {
    staticClass: "btns-box row"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doTimeOut()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'watch'),
      expression: "mode != 'watch'"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSelfSkip()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#63aeb0",
      "font-weight": "bold"
    }
  }, [_vm._v("Pass")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'watch' && _vm.isHomewer),
      expression: "mode == 'watch' && isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPage('/')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomewer),
      expression: "isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mode == 'watch') ? _c('div', {
    staticClass: "item countdown spectator",
    staticStyle: {
      "flex-direction": "row",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("観戦者")]), _vm._v(" "), (_vm.mode == 'watch' && _vm.isHomewer) ? _c('div', {
    staticClass: "watch-number peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item countdown"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.userTimes)), _c('span', [_vm._v("s")])]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item times"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.gameTimes.str))]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("トータル時間")])]), _vm._v(" "), (!(_vm.mode == 'watch' && _vm.isHomewer)) ? _c('div', {
    staticClass: "item peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "設定",
      "top": "250px",
      "visible": _vm.dialogSettingVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.toFinish()
      }
    }
  }, [_vm._v("終了")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "一時停止",
      "top": "250px",
      "visible": _vm.dialogPauseVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPauseVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isHomewer) ? _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPause()
      }
    }
  }, [_vm._v("停止する")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "show-close": false,
      "title": "一時停止中",
      "top": "250px",
      "visible": _vm.dialogPauseVisible && _vm.cards.length > 0,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogPauseVisible && _vm.cards, "length > 0", $event)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reStart()
      }
    }
  }, [_vm._v("ゲームを再開する")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "title": "ゲームを終了しますか？",
      "top": "250px",
      "visible": _vm.dialogFinishVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFinishVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.doFinish()
      }
    }
  }, [_vm._v("終了する")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toGame()
      }
    }
  }, [_vm._v("続ける")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "Pass",
      "top": "250px",
      "visible": _vm.dialogSkipVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPass()
      }
    }
  }, [_vm._v("パスする")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "skip-box",
    attrs: {
      "title": "スキップさせるユーザーを選択",
      "top": "250px",
      "visible": _vm.dialogSkipVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.users2), function(item, index) {
    return (!item.isHomewer) ? _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      on: {
        "click": function($event) {
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [_c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "game-warp"
  }, [_c('div', {
    staticClass: "game-box row"
  }, [_c('div', {
    staticClass: "game-box-min column row-flex"
  }, [_c('div', {
    staticClass: "user-box row row-center",
    class: {
      'current-user': _vm.user2.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user2.id,
      "data-email": _vm.user2.email,
      "data-username": _vm.user2.username,
      "data-realname": _vm.user2.realname,
      "data-lineStatus": _vm.user2.lineStatus,
      "data-isSkip": _vm.user2.isSkip,
      "data-sort": _vm.user2.sort
    }
  }, [_c('div', {
    staticClass: "usernamesc",
    staticStyle: {
      "word-wrap": "break-word",
      "writing-mode": "vertical-tb",
      "overflow": "hidden",
      "font-size": "14px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.user2.nickname) + "\n\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box row row-center column-center"
  }, [_vm._l((_vm.user2.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('el-image', {
      key: index,
      staticClass: "card2 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 2, _vm.user2.cards, 'user2')
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user2.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('el-image', {
      key: index,
      staticClass: "card2",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user2.isSkip),
      expression: "user2.isSkip"
    }],
    staticClass: "mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user2.username, _vm.user2.id, 2)
      }
    }
  }, [_vm._v("\n              スキップ解除\n            ")]) : _vm._e(), _vm._v("\n            スキップ状態\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "game-cards-box row-flex row row-center"
  }, [_c('div', {
    staticClass: "min column"
  }, [_c('div', {
    staticClass: "min-top column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location2",
    staticClass: "cards-scroll row column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user2.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            2,
            $event,
            _vm.user2.discard,
            'user2'
          )
        }
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex column column-center row-center"
  }, [_c('div', {
    staticClass: "min-cards-box",
    staticStyle: {
      "position": "relative",
      "overflow": "visible",
      "height": "calc(var(--vp) * 10.925 * 1.1)",
      "width": "calc(var(--vp) * 8.765 * 1.1)"
    }
  }, [_c('div', {
    staticClass: "rest"
  }, [_vm._v("残り枚数: " + _vm._s(_vm.cards.length) + "枚")]), _vm._v(" "), _c('div', {
    ref: "gamecardslists",
    staticClass: "cards-lists"
  }, _vm._l((_vm.cards), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card-box",
      class: 'card' + item.id,
      style: (item.style)
    }, [_c('el-image', {
      staticClass: "card",
      attrs: {
        "src": _vm.cardsBack,
        "fit": "contain"
      },
      on: {
        "click": function($event) {
          return _vm.extractCard(item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.extracting) ? _c('div', {
    staticClass: "card-top"
  }, [(_vm.info.isPublic || _vm.mode == 'watch' || _vm.user1.sort == _vm.playUser) ? _c('el-image', {
    staticClass: "card cardm",
    staticStyle: {
      "z-index": "1002 !important"
    },
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.extractCardInfo.url,
      "fit": "contain"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.info.isPublic && _vm.mode != 'watch' && _vm.user1.sort != _vm.playUser) ? _c('el-image', {
    staticClass: "card cardm",
    staticStyle: {
      "z-index": "1002 !important"
    },
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.cardsBack,
      "fit": "contain"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "min-bottom column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists cards-lists-mine",
    on: {
      "click": function($event) {
        return _vm.discardCard(1, $event)
      }
    }
  }, [_c('div', {
    ref: "location1",
    staticClass: "cards-scroll row column-center",
    style: ({
      width: _vm.scrollWidth
    }),
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user1.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            1,
            $event,
            _vm.user1.discard,
            'user1'
          )
        }
      }
    })], 1)
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "game-user-self row"
  }, [_c('div', {
    staticClass: "myself"
  }, [_vm._v(_vm._s(_vm.user1.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-box column column-center",
    attrs: {
      "data-id": _vm.user1.id,
      "data-email": _vm.user1.email,
      "data-username": _vm.user1.username,
      "data-realname": _vm.user1.realname,
      "data-lineStatus": _vm.user1.lineStatus,
      "data-isSkip": _vm.user1.isSkip,
      "data-sort": _vm.user1.sort
    }
  }, [_c('div', {
    staticClass: "user-cards-box row row-center column-center",
    class: {
      'current-user': _vm.user1.sort == _vm.playUser
    }
  }, [_vm._l((_vm.user1.cards), function(item, index) {
    return _c('el-image', {
      key: index,
      staticClass: "card cardh",
      class: {
        cardchecked: _vm.mode == 'play'
      },
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeSelfCard(item, index, $event, 1)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user1.isSkip),
      expression: "user1.isSkip"
    }],
    staticClass: "mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user1.username, _vm.user1.id, 1)
      }
    }
  }, [_vm._v("\n              スキップ解除\n            ")]) : _vm._e(), _vm._v("\n            スキップ状態\n          ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "room-info row-flex column column-center"
  }, [(_vm.mode == 'play' || _vm.isHomewer) ? _c('div', {
    staticClass: "btns-box row s-column"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doTimeOut()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'watch'),
      expression: "mode != 'watch'"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSelfSkip()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#63aeb0",
      "font-weight": "bold"
    }
  }, [_vm._v("Pass")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomewer),
      expression: "isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mode == 'watch') ? _c('div', {
    staticClass: "item countdown spectator"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("観戦者")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item countdown"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.userTimes)), _c('span', [_vm._v("s")])]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item times"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.gameTimes.str))]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("トータル時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]), _vm._v(" "), (_vm.mode == 'watch' && _vm.isHomewer) ? _c('div', {
    staticClass: "item countdown",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPage('/')
      }
    }
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("マイページへ")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "設定",
      "top": "250px",
      "visible": _vm.dialogSettingVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.toFinish()
      }
    }
  }, [_vm._v("終了")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "一時停止",
      "top": "250px",
      "visible": _vm.dialogPauseVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPauseVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isHomewer) ? _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPause()
      }
    }
  }, [_vm._v("停止する")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "show-close": false,
      "title": "一時停止中",
      "top": "250px",
      "visible": _vm.dialogPauseVisible && _vm.cards.length > 0,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogPauseVisible && _vm.cards, "length > 0", $event)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reStart()
      }
    }
  }, [_vm._v("ゲームを再開する")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "title": "ゲームを終了しますか？",
      "top": "250px",
      "visible": _vm.dialogFinishVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFinishVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.doFinish()
      }
    }
  }, [_vm._v("終了する")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toGame()
      }
    }
  }, [_vm._v("続ける")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "Pass",
      "top": "250px",
      "visible": _vm.dialogSkipVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPass()
      }
    }
  }, [_vm._v("パスする")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "skip-box",
    attrs: {
      "title": "スキップさせるユーザーを選択",
      "top": "250px",
      "visible": _vm.dialogSkipVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.users2), function(item, index) {
    return (!item.isHomewer) ? _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      on: {
        "click": function($event) {
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [_c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "game-warp"
  }, [_c('div', {
    staticClass: "game-box row"
  }, [_c('div', {
    staticClass: "game-box-min column column-center row-flex"
  }, [_c('div', {
    staticClass: "game-cards-box row-flex row"
  }, [_c('div', {
    staticClass: "min column"
  }, [_c('div', {
    staticClass: "min-cards-box row-flex column column-center row-center"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "overflow": "visible",
      "height": "calc(var(--vp) * 10.925 * 1.1)",
      "width": "calc(var(--vp) * 8.765 * 1.1)"
    }
  }, [_c('div', {
    staticClass: "rest"
  }, [_vm._v("残り枚数: " + _vm._s(_vm.cards.length) + "枚")]), _vm._v(" "), _c('div', {
    ref: "gamecardslists",
    staticClass: "cards-lists"
  }, _vm._l((_vm.cards), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card-box",
      class: 'card' + item.id,
      style: (item.style)
    }, [_c('el-image', {
      staticClass: "card",
      attrs: {
        "src": _vm.cardsBack,
        "fit": "contain"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCard(item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.extracting) ? _c('div', {
    staticClass: "card-top"
  }, [_c('el-image', {
    staticClass: "card cardh",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.extractCardInfo.url,
      "fit": "contain"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "min-bottom column column-center row-center",
    staticStyle: {
      "z-index": "999"
    }
  }, [_c('div', {
    staticClass: "cards-lists cards-lists-mine",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.discardCard(1, $event)
      }
    }
  }, [_c('div', {
    ref: "location1",
    staticClass: "cards-scroll row column-center",
    style: ({
      width: _vm.scrollWidth
    }),
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user1.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            1,
            $event,
            _vm.user1.discard,
            'user1'
          )
        }
      }
    })], 1)
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "game-user-self row"
  }, [_c('div', {
    staticClass: "myself"
  }, [_vm._v(_vm._s(_vm.user1.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-box",
    attrs: {
      "data-id": _vm.user1.id,
      "data-email": _vm.user1.email,
      "data-username": _vm.user1.username,
      "data-realname": _vm.user1.realname,
      "data-lineStatus": _vm.user1.lineStatus,
      "data-isSkip": _vm.user1.isSkip,
      "data-sort": _vm.user1.sort
    }
  }, [_c('div', {
    staticClass: "user-cards-box row row-center column-center",
    class: {
      'current-user': _vm.user1.sort == _vm.playUser
    }
  }, [_vm._l((_vm.user1.cards), function(item, index) {
    return _c('el-image', {
      key: index,
      staticClass: "card cardh",
      class: {
        cardchecked: _vm.mode == 'play'
      },
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeSelfCard(item, index, $event, 1)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user1.isSkip),
      expression: "user1.isSkip"
    }],
    staticClass: "mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelSkip(_vm.user1.id, 1)
      }
    }
  }, [_vm._v("\n            スキップ解除\n          ")]) : _vm._e(), _vm._v("\n          スキップ状態\n        ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "room-info row-flex column column-center"
  }, [(_vm.mode == 'play' || _vm.isHomewer) ? _c('div', {
    staticClass: "btns-box row s-column"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doTimeOut()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(154)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doSelfSkip()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#63aeb0",
      "font-weight": "bold"
    }
  }, [_vm._v("Pass")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomewer),
      expression: "isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doSet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(153)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mode == 'watch') ? _c('div', {
    staticClass: "item countdown spectator"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("観戦者")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item countdown"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.userTimes)), _c('span', [_vm._v("s")])]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item times"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.gameTimes.str))]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("トータル時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]), _vm._v(" "), (_vm.mode == 'watch' && _vm.isHomewer) ? _c('div', {
    staticClass: "item countdown",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPage('/')
      }
    }
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("マイページへ")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "設定",
      "top": "250px",
      "visible": _vm.dialogSettingVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toFinish()
      }
    }
  }, [_vm._v("終了")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "一時停止",
      "top": "250px",
      "visible": _vm.dialogPauseVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPauseVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isHomewer) ? _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPause()
      }
    }
  }, [_vm._v("停止する")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "show-close": false,
      "title": "一時停止中",
      "top": "250px",
      "visible": _vm.dialogPauseVisible && _vm.cards.length > 0,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogPauseVisible && _vm.cards, "length > 0", $event)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reStart()
      }
    }
  }, [_vm._v("ゲームを再開する")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "title": "ゲームを終了しますか？",
      "top": "250px",
      "visible": _vm.dialogFinishVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFinishVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doFinish()
      }
    }
  }, [_vm._v("終了する")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toGame()
      }
    }
  }, [_vm._v("続ける")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "Pass",
      "top": "250px",
      "visible": _vm.dialogSkipVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPass()
      }
    }
  }, [_vm._v("パスする")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "skip-box",
    attrs: {
      "title": "スキップさせるユーザーを選択",
      "top": "250px",
      "visible": _vm.dialogSkipVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.users2), function(item, index) {
    return (!item.isHomewer) ? _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [_c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box column"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    staticStyle: {
      "margin-right": "10px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toMy
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "form-box column",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "お名前",
      "prop": "realname"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": false,
      "placeholder": "お名前を入力"
    },
    model: {
      value: (_vm.ruleForm.realname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "realname", $$v)
      },
      expression: "ruleForm.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "フリガナ (カタカナを入力)",
      "prop": "falsename"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": false,
      "placeholder": "フリガナを入力"
    },
    model: {
      value: (_vm.ruleForm.falsename),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "falsename", $$v)
      },
      expression: "ruleForm.falsename"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "ニックネーム (全角8文字まで)",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ニックネームを入力",
      "maxlength": "8"
    },
    model: {
      value: (_vm.ruleForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "nickname", $$v)
      },
      expression: "ruleForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sex-box m-row",
    attrs: {
      "label": "性別",
      "prop": "sex"
    }
  }, [_c('el-radio-group', {
    staticClass: "m-row",
    model: {
      value: (_vm.ruleForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sex", $$v)
      },
      expression: "ruleForm.sex"
    }
  }, _vm._l((_vm.sexBox), function(item, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index,
        "value": index,
        "name": "sex"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', [_c('div', {
    staticClass: "row m-row"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "生年月",
      "prop": "year"
    }
  }, [_c('el-select', {
    staticClass: "birthday-year",
    attrs: {
      "disabled": false,
      "placeholder": "年を選択してください"
    },
    model: {
      value: (_vm.ruleForm.year),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "year", $$v)
      },
      expression: "ruleForm.year"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "年",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((2022), function(index) {
    return (index >= 1900) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "month"
    }
  }, [_c('el-select', {
    staticClass: "birthday-month",
    attrs: {
      "disabled": false,
      "placeholder": "月を選択してください"
    },
    on: {
      "change": _vm.monthChange
    },
    model: {
      value: (_vm.ruleForm.month),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "month", $$v)
      },
      expression: "ruleForm.month"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "月",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((12), function(index) {
    return (index >= 1) ? _c('el-option', {
      key: index,
      attrs: {
        "label": index,
        "value": index
      }
    }) : _vm._e()
  })], 2)], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "住所",
      "prop": "address"
    }
  }, [_c('el-select', {
    staticClass: "select-region",
    attrs: {
      "disabled": false,
      "placeholder": "都道府県を選択"
    },
    model: {
      value: (_vm.ruleForm.address),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "address", $$v)
      },
      expression: "ruleForm.address"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選択してください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.region), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    attrs: {
      "label": "職業",
      "prop": "job"
    }
  }, [_c('el-select', {
    staticClass: "select-job",
    attrs: {
      "placeholder": "職業を選択"
    },
    model: {
      value: (_vm.ruleForm.job),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "job", $$v)
      },
      expression: "ruleForm.job"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "選択してください",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.job), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "メールアドレス",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.socialType == 'google',
      "placeholder": "メールアドレスを入力"
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.isSocial && _vm.socialType == null) ? _c('div', {
    staticClass: "form-item row m-column"
  }, [_c('el-form-item', {
    staticClass: "password-btn-box column",
    attrs: {
      "label": "パスワード"
    }
  }, [_c('el-button', {
    staticClass: "change-password-btn",
    on: {
      "click": _vm.changePass
    }
  }, [_vm._v("パスワードを変更")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSub('ruleForm')
      }
    }
  }, [_vm._v("保存する")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "change-box",
    attrs: {
      "title": "パスワードを変更",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "passForm",
    attrs: {
      "model": _vm.passForm,
      "rules": _vm.passRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "元のパスワード",
      "prop": "oldpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "autocomplete": "off",
      "placeholder": "元のパスワードを入力"
    },
    model: {
      value: (_vm.passForm.oldpassword),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "oldpassword", $$v)
      },
      expression: "passForm.oldpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新しいパスワード",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "autocomplete": "off",
      "placeholder": "新しいパスワードを入力"
    },
    model: {
      value: (_vm.passForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "password", $$v)
      },
      expression: "passForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新しいパスワード",
      "prop": "confirmpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "autocomplete": "off",
      "placeholder": "確認のため新しいパスワードを再入力"
    },
    model: {
      value: (_vm.passForm.confirmpassword),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "confirmpassword", $$v)
      },
      expression: "passForm.confirmpassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box row row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doChangePass('passForm')
      }
    }
  }, [_vm._v("変更する")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-header row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("アカウント情報")])])
}]}

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-result-warp column"
  }, [_c('div', {
    staticClass: "game-result-header"
  }, [_c('div', {
    staticClass: "my-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.toMy()
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('div', {
    staticClass: "my-topic"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.2rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("テーマ:")]), _c('span', {
    staticClass: "my-topic-theme"
  }, [_vm._v(_vm._s(_vm.room.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "title-box column column-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("結果")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("プレイ時間：" + _vm._s(_vm.users.length > 0 ? _vm.formatSeconds(_vm.users[0].turnTime) : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "game-result-info-box column"
  }, _vm._l((_vm.users), function(item, index) {
    return _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "tig"
    }, [_vm._v(_vm._s(item.userRole == 1 ? 'ファシリテーター' : 'プレイヤー'))]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-button', {
      staticClass: "details-btn",
      on: {
        "click": function($event) {
          return _vm.fenxi(item)
        }
      }
    }, [_vm._v("チャート分析をみる")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "cards-lists row-flex row"
    }, [_vm._l((item.urls), function(item2, index2) {
      return (item.isShowCard == 1) ? _c('el-image', {
        key: index2,
        staticClass: "card",
        attrs: {
          "src": item2,
          "fit": "contain"
        }
      }) : _vm._e()
    }), _vm._v(" "), _vm._l((item.urls), function(item2, index2) {
      return (item.isShowCard == 0) ? _c('el-image', {
        key: index2,
        staticClass: "card",
        attrs: {
          "src": _vm.cardsBack,
          "fit": "contain"
        }
      }) : _vm._e()
    })], 2)])
  }), 0)])
},staticRenderFns: []}

/***/ })

},[439]);


// WEBPACK FOOTER //
// static/js/app.0939193d7904ffb42157.js